// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            home: 'Home',
            aboutUs: 'About Us',
            sriLankanav: 'Japan',
            gallerynav: 'Gallery',
            bookATour: 'Tours',
            thingsToDo: 'Things To Do',
            contactUs: 'Contact Us',
            contactJapan: 'Contact Japan',
            japanHeroEyebrow: 'Discover Japan',
            japanHeroTitle: 'Experience the elegance of Japan with Sonic Tours',
            japanHeroSubtitle: 'From ancient temples and serene gardens to lively cities and unforgettable adventures, Japan offers a journey unlike any other.',
            japanHeroImageAlt: 'Japan landscape',
            japanAboutEyebrow: 'About Japan',
            japanSectionTitle: 'A timeless destination crafted for curious travelers',
            japanSectionDescription: 'Japan blends rich cultural heritage, world-class cuisine, natural beauty, and modern innovation into one extraordinary travel experience. Whether you are seeking quiet temples, bright city lights, or scenic landscapes, Sonic Tours helps you discover it all with comfort and care.',
            japanSectionImageAlt: 'Japanese travel scene',
        },
        about: {
            hero: {
                discover: 'Classic Japan',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: 'Discover the timeless beauty of Japan with expert-guided journeys',
                tagline2: 'From vibrant cities to sacred mountains and ancient temples — let us craft your perfect Japanese adventure.',
            },

            about: {
                title: 'About Sonic Tours Japan',
            },

            tours: {
                classic: 'Classic Japan (First-Time Visitors)',
                days4: '5–7 Days',
                desc1: 'Tokyo – Shibuya Crossing, Asakusa, Tokyo Skytree, shopping, anime & nightlife. Mount Fuji – Scenic views, Lake Kawaguchi & Fuji 5th Station.',

                safari: 'Cultural Attractions',
                days5: 'Kyoto • Nara • Osaka',
                desc2: 'Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Himeji Castle and the peaceful charm of Nara Park.',

                retreat: 'Nature & Scenic Spots',
                days6: 'Hakone • Arashiyama • Nikko',
                desc3: 'Hakone hot springs & Mt. Fuji views, Arashiyama Bamboo Forest, Nikko and historic Shirakawa-go.',
            },
            owner: {
                title: 'Meet Our Leadership',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: 'With a deep passion for Japanese culture and decades of experience in luxury travel, Tomoya Izawa leads Sonic Tours Japan with vision and dedication. His commitment to authentic experiences and exceptional service ensures every guest receives world-class hospitality and unforgettable journeys through Japan.',
                imageAlt: 'Tomoya Izawa - CEO & President of Sonic Tours Japan',
            },

            whoWeAre: {
                title: 'Your Japan Travel Expert',
                description: 'Led by <strong>Buddika</strong>, Sonic Tours Japan specializes in creating personalized, high-quality travel experiences across Japan. With deep local knowledge and a passion for Japanese culture, we ensure every journey is smooth, enriching, and truly memorable.',
                item1: { title: 'Expert Local Guides', text: 'Licensed & experienced' },
                item2: { title: 'Tailor-Made Itineraries', text: 'Customized to your pace' },
                item3: { title: 'Seamless Experience', text: 'Stress-free travel' },
                item4: { title: '24/7 Support', text: 'Always here for you' },
                imageAlt: 'Buddika - Japan Tour Expert',
            },

            offers: {
                title: 'What We Offer',
                cultural: {
                    title: 'Cultural Immersion',
                    text: 'Temples, shrines, traditional arts & local traditions',
                    alt: 'Japanese cultural experiences'
                },
                adventure: {
                    title: 'Nature & Adventure',
                    text: 'Mount Fuji, Hakone, hiking & scenic journeys',
                    alt: 'Japan nature adventures'
                },
                luxury: {
                    title: 'Luxury Travel',
                    text: 'Premium hotels, private transfers & exclusive experiences',
                    alt: 'Luxury Japan travel'
                },
                wellness: {
                    title: 'Wellness & Relaxation',
                    text: 'Onsen hot springs, mindfulness & rejuvenating retreats',
                    alt: 'Japan wellness retreats'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'Lead Tour Guide',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: 'With years of experience guiding travelers across Japan, Buddika is passionate about sharing the authentic beauty, culture, and hidden gems of this incredible country. His warm personality and deep knowledge make every tour truly special.',
            },

            villageTours: {
                title: 'Authentic Japan Experiences',
                description: 'Beyond the big cities, discover traditional villages, local craftsmanship, seasonal festivals, and the warm hospitality that defines real Japan.',
                imageAlt: 'Traditional Japanese village experience',
                bookButton: 'Explore Authentic Japan',
            },

            vehicles: {
                title: 'Our Fleet',
                text: 'Comfortable, modern, and well-maintained vehicles for a relaxing journey across Japan.',
                bookButton: 'Book Your Tour',
                car: { title: 'Private Car', text: 'Ideal for couples & small groups' },
                van: { title: 'Comfort Van', text: 'Spacious & comfortable' },
                minibus: { title: 'Minibus', text: 'Perfect for families & medium groups' },
                luxury: { title: 'Luxury Coach', text: 'Premium experience for larger groups' },
            },

            notices: {
                title: 'Travel with Confidence',
                intro: 'At Sonic Tours Japan, your comfort, safety, and satisfaction are our top priorities.',
                fruits: { title: 'Complimentary Snacks', text: 'Seasonal fruits & light refreshments' },
                meals: { title: 'Carefully Selected Meals', text: 'Authentic Japanese cuisine experiences' },
                massage: { title: 'Relaxation Services', text: 'Optional onsen & wellness add-ons' },
                flowers: { title: 'Warm Welcome', text: 'Traditional Japanese hospitality' },
            },

            slider: {
                sigiriya: 'Mount Fuji',
                yala: 'Kyoto Temples',
                tea: 'Arashiyama Bamboo',
                beaches: 'Hakone Lake',
                temples: 'Nara Deer Park',
            },
        },
        tourPackages: {
            hero: {
                discover: 'Classic Japan',
                starLankaTours: 'First-Time Visitors',
                highlight: 'A timeless journey across Tokyo, Fuji, Kyoto, and Osaka',
                tagline1: 'From iconic city lights to serene temples, Japan offers a remarkable first-time journey for every traveler.',
                tagline2: 'Let Sonic Tours turn your dream itinerary into a smooth and memorable escape across Japan.',
            },
            overview: {
                eyebrow: 'Japan highlights',
                title: 'Japan highlights for first-time visitors',
                description: 'These destinations are among the most popular with international travelers and make an excellent foundation for attractive Japan tour packages.',
            },
            cards: {
                classicTitle: 'Classic Japan (First-Time Visitors)',
                classicMeta: 'Tokyo • Mount Fuji',
                classicText: 'Tokyo brings Shibuya Crossing, Asakusa, Tokyo Skytree, shopping, anime, and nightlife. Mount Fuji offers scenic views, Lake Kawaguchi, and Fuji 5th Station.',
                classicAlt: 'Tokyo skyline and Mount Fuji',
                culturalTitle: 'Cultural Attractions',
                culturalMeta: 'Kyoto • Nara • Osaka',
                culturalText: 'Discover Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Himeji Castle, and the peaceful charm of Nara Park.',
                culturalAlt: 'Japanese temples and heritage sites',
                natureTitle: 'Nature & Scenic Spots',
                natureMeta: 'Hakone • Arashiyama • Nikko',
                natureText: 'Enjoy Hakone for hot springs and Mount Fuji views, Arashiyama’s bamboo forest, Nikko, and Shirakawa-go.',
                natureAlt: 'Scenic Japanese landscapes',
            },
            highlights: {
                eyebrow: 'Popular experiences',
                title: 'Plan the perfect Japan trip for your interests',
                text: 'Whether you love seasonal beauty, family fun, or cultural discovery, Sonic Tours can shape a route that feels effortless and inspiring.',
                seasonalTitle: 'Seasonal Attractions',
                seasonalText: 'Spring is perfect for cherry blossoms, summer for Mount Fuji climbing and festivals, autumn for Kyoto and Nikko foliage, and winter for skiing in Niseko or Sapporo’s Snow Festival.',
                familyTitle: 'Family-Friendly Attractions',
                familyText: 'Tokyo Disneyland, Tokyo DisneySea, Universal Studios Japan, and Osaka Aquarium Kaiyukan are wonderful choices for families.',
            },
            recommended: {
                eyebrow: 'Recommended Tour Packages',
                title: 'Recommended Tour Packages',
                subtitle: 'Choose the perfect duration for your first Japan adventure',
                packages: {
                    fiveDays: {
                        title: '5 Days: Tokyo + Mount Fuji',
                        description: 'Perfect introduction to Japan — vibrant Tokyo and the iconic Mount Fuji.',
                        alt: 'Tokyo and Mount Fuji'
                    },
                    sevenDays: {
                        title: '7 Days: Tokyo + Mount Fuji + Kyoto + Osaka',
                        description: 'Classic route covering Japan’s must-see cities and cultural heart.',
                        alt: 'Kyoto and Osaka'
                    },
                    tenDays: {
                        title: '10 Days: Tokyo + Hakone + Kyoto + Nara + Osaka',
                        description: 'In-depth exploration with Hakone’s scenic beauty and historic Nara.',
                        alt: 'Hakone and Nara'
                    },
                    twelveToFourteenDays: {
                        title: '12–14 Days: Tokyo + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima',
                        description: 'Comprehensive journey including the poignant history of Hiroshima and sacred Miyajima.',
                        alt: 'Hiroshima and Miyajima'
                    }
                }
            },
            cta: {
                eyebrow: 'Tailor-made Japan journeys',
                title: 'Let Sonic Tours design your Japan journey',
                text: 'Choose a classic first-time route or a custom itinerary tailored to your pace, interests, and season.',
                button: 'Plan My Japan Trip',
                imageAlt: 'Japan travel experience',
            },
        },
        contactus: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Sonic Tours Japan – Your Gateway to Unforgettable Japanese Journeys',

            feelFree: 'Feel Free to Reach Out',
            planDream: 'Plan Your Perfect Japan Getaway',
            reachOutDesc: 'Contact Sonic Tours Japan for tailor-made itineraries, expert advice, and memorable experiences throughout Japan.',

            callCenter: 'Call Center',
            phone: '+81 90-8251-4053',
            emailTitle: 'Email',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: 'Our Location',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: 'Follow Us',

            getInTouch: 'Let’s Connect',
            getInTouchDesc: 'Start your Japanese adventure with Sonic Tours Japan – we’re available to help you create unforgettable memories.',

            nameLabel: 'Name',
            namePlaceholder: 'Your full name',
            emailLabel: 'Email',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: 'Phone Number',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'Message',
            messagePlaceholder: 'Tell us about your ideal trip to Japan...',

            sendButton: 'Send Message',
            sendingButton: 'Sending...',
            successMsg: 'Your message has been sent via WhatsApp!',
            errorMsg: 'Couldn’t open WhatsApp. Please try again.',

            findUsTitle: 'Find Us in Japan',
        },
        japan: {
            heroTitle: 'CEO & President of Japan Office',
            heroSubtitle: 'Your Trusted Partner for Sri Lankan Adventures from Japan',

            contactPerson: 'Tomoya Izawa',
            position: 'Japan Representative',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'Connect with us on social media',

            formTitle: 'Send Us a Message',
            formHeading: 'Start Your Sri Lankan Adventure',
            formDescription: 'Contact Tomoya Izawa for personalized tour packages, expert travel advice, and unforgettable Sri Lankan experiences.',

            nameLabel: 'Your Name *',
            namePlaceholder: 'Enter your full name',
            emailLabel: 'Email Address *',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: 'Phone Number',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'Your Message *',
            messagePlaceholder: 'Tell us about your dream Sri Lankan adventure...',

            sendButton: 'Send Message via Email',
            sendingButton: 'Opening Email Client...',
            successMsg: 'Your email client has been opened with the message!',
            errorMsg: 'Couldn\'t open email client. Please try again.',

            whyChooseTitle: 'Why Choose Sonic Tours?',

            expertiseTitle: 'Local Expertise',
            expertiseDesc: 'Authentic Sri Lankan experiences curated by local experts who know every hidden gem',

            supportTitle: 'Japanese Support',
            supportDesc: 'Dedicated Japanese-speaking representative for seamless communication',

            personalizedTitle: 'Personized Tours',
            personalizedDesc: 'Custom itineraries designed to match your interests and travel style',

            mapTitle: 'Find Us in Sri Lanka',
        },
        // Add this inside the resources object in i18n.js
        thingstodo: {
            heroTitle: "Things to Do in Japan",
            heroSubtitle: "Discover unforgettable experiences and create lifelong memories in the Land of the Rising Sun.",

            sectionTitle: "Unforgettable Experiences in Japan",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "Cherry Blossom Viewing",
                description: "Japan’s most iconic and breathtaking seasonal experience.",
                para1: "Cherry blossom viewing, known as 'hanami', is one of Japan’s most beloved traditions. Every spring, millions gather under pink sakura trees to celebrate the fleeting beauty of life.",
                para2: "Popular spots include Tokyo’s Ueno Park, Shinjuku Gyoen, Kyoto’s Philosopher’s Path, and Osaka Castle Park. Many people enjoy picnics (hanami bentos) with family and friends under the blossoms.",
                para3: "The season usually peaks from late March to early April. Evening illuminations create a magical atmosphere at many locations."
            },

            ancientTemples: {
                title: "Ancient Temples & Shrines",
                description: "Discover Japan’s spiritual heritage through ancient temples and shrines.",
                para1: "Japan is home to thousands of historic temples and shrines, many of which are UNESCO World Heritage Sites.",
                para2: "Iconic sites include Fushimi Inari Taisha with its thousands of red torii gates, Kinkaku-ji (Golden Pavilion), and the grand Todaiji Temple in Nara.",
                para3: "Visitors can participate in rituals, receive fortunes, or simply enjoy the serene gardens and seasonal beauty surrounding these sacred places."
            },

            mountFuji: {
                title: "Mount Fuji & Fuji Five Lakes",
                description: "Witness the majestic and sacred symbol of Japan.",
                para1: "Standing at 3,776 meters, Mount Fuji is Japan’s highest peak and a cultural icon.",
                para2: "The best views are from the Fuji Five Lakes region. You can hike to the summit during the official season or enjoy scenic views year-round.",
                para3: "The surrounding area offers charming towns, onsen resorts, and world-class photography opportunities."
            },

            onsenRelax: {
                title: "Traditional Onsen Hot Springs",
                description: "Rejuvenate body and mind in Japan’s traditional hot springs.",
                para1: "Onsen culture is deeply rooted in Japan. Natural hot springs are believed to have healing properties.",
                para2: "Popular destinations include Hakone, Beppu, and Kusatsu. Many ryokans offer open-air rotenburo baths with stunning views.",
                para3: "Following proper onsen etiquette enhances the experience and shows respect for Japanese bathing traditions."
            },

            japaneseCuisine: {
                title: "Authentic Japanese Cuisine",
                description: "Savor world-renowned Japanese cuisine and street food.",
                para1: "From fresh sushi and sashimi to hearty ramen, tempura, and kaiseki multi-course meals, Japanese cuisine is a UNESCO Intangible Cultural Heritage.",
                para2: "Tokyo, Osaka, and Kyoto are food paradises. Try street food in Dotonbori or Nishiki Market.",
                para3: "Food tours and cooking classes are excellent ways to deepen your understanding of Japanese culinary traditions."
            },

            shinkansen: {
                title: "Ride the Shinkansen Bullet Train",
                description: "Experience the world-famous bullet train.",
                para1: "The Shinkansen is a symbol of Japan’s technological excellence and punctuality.",
                para2: "Travel comfortably between major cities like Tokyo, Kyoto, Osaka, and Hiroshima at speeds over 300 km/h.",
                para3: "The journey itself is part of the experience — clean, quiet, and incredibly efficient."
            },

            matsuriFestivals: {
                title: "Traditional Matsuri Festivals",
                description: "Immerse yourself in vibrant traditional festivals.",
                para1: "Matsuri are lively community festivals featuring parades, music, food stalls, and traditional dances.",
                para2: "Famous events include Gion Matsuri in Kyoto, Nebuta Matsuri in Aomori, and Tenjin Matsuri in Osaka.",
                para3: "Attending a matsuri offers a wonderful opportunity to experience local culture and Japanese spirit."
            },

            themeParks: {
                title: "Theme Parks & Entertainment",
                description: "Enjoy world-class theme parks and attractions.",
                para1: "Tokyo Disneyland and DisneySea are among the most popular in the world.",
                para2: "Universal Studios Japan in Osaka offers exciting rides based on Harry Potter, Super Nintendo World, and more.",
                para3: "These parks provide fun for all ages and are especially magical during seasonal events."
            },

            shoppingJapan: {
                title: "Shopping in Tokyo, Osaka & Kyoto",
                description: "Shop till you drop in Japan’s vibrant cities.",
                para1: "From luxury brands in Ginza and Omotesando to electronics in Akihabara and fashion in Shinsaibashi.",
                para2: "Don’t miss department stores, 100-yen shops, and traditional craft markets.",
                para3: "Tax-free shopping and unique souvenirs make shopping in Japan a delightful experience."
            },

            fourSeasons: {
                title: "Japan’s Four Beautiful Seasons",
                description: "Experience the magic of Japan’s distinct four seasons.",
                para1: "Japan is famous for its dramatic seasonal changes — spring cherry blossoms, vibrant summer festivals, colorful autumn leaves, and snowy winter landscapes.",
                para2: "Each season offers unique festivals, cuisine, and landscapes across the country.",
                para3: "No matter when you visit, Japan’s natural beauty and cultural celebrations will leave a lasting impression."
            },

            viewMore: "View Details",
            close: "Close",

            ctaTitle: "Ready for Your Japanese Adventure?",
            ctaDescription: "Let Sonic Tours Japan craft your perfect itinerary with expert guidance and personalized service.",
            ctaButton: "Plan Your Trip Now"
        },
        // Add inside en, ru, ar objects in resources
        gallery: {
            heroTitle: "Discover Japan",
            heroSubtitle: "Explore the breathtaking beauty, culture, and iconic landmarks of Japan through our curated gallery.",

            // 20 Selected Places
            shibuya: "Shibuya Crossing",
            asakusa: "Senso-ji Temple",
            skytree: "Tokyo Skytree",
            mtfuji: "Mount Fuji",
            lakeKawaguchi: "Lake Kawaguchi",
            hakoneRopeway: "Hakone Ropeway",
            fushimiInari: "Fushimi Inari Taisha",
            arashiyama: "Arashiyama Bamboo Forest",
            kinkakuji: "Kinkaku-ji (Golden Pavilion)",
            osakaCastle: "Osaka Castle",
            dotonbori: "Dotonbori",
            naraPark: "Nara Park",
            todaiji: "Todai-ji Temple",
            hiroshimaPeace: "Hiroshima Peace Memorial",
            miyajima: "Itsukushima Shrine",
            nikko: "Toshogu Shrine",
            shirakawago: "Shirakawa-go",
            himeji: "Himeji Castle",
            universal: "Universal Studios Japan",
            teamlab: "TeamLab Planets",
            lightboxClose: "Close",
            lightboxNext: "Next",
            lightboxPrevious: "Previous",
            tabPlaces: "Places",
            tabEvents: "Events"
        },
        // Inside en, ru, ar → resources
        events: {
            heroTitle: "Japanese Festivals",
            heroSubtitle: "Experience the vibrant colors, deep traditions, and unforgettable atmosphere of Japan’s world-famous festivals and celebrations.",

            // 20 Selected Festivals
            sakuraMatsuri: "Cherry Blossom Festivals (Sakura Matsuri)",
            hinaMatsuri: "Hina Matsuri (Doll Festival)",
            takayamaSpring: "Takayama Spring Festival",
            kandaMatsuri: "Kanda Matsuri",
            aoiMatsuri: "Aoi Matsuri",
            fujiShibazakura: "Fuji Shibazakura Festival",
            gionMatsuri: "Gion Matsuri",
            tenjinMatsuri: "Tenjin Matsuri",
            nebutaMatsuri: "Nebuta Matsuri",
            sendaiTanabata: "Sendai Tanabata Festival",
            awaOdori: "Awa Odori Festival",
            sumidaFireworks: "Sumida River Fireworks Festival",
            nagaokaFireworks: "Nagaoka Fireworks Festival",
            kishiwadaDanjiri: "Kishiwada Danjiri Festival",
            jidaiMatsuri: "Jidai Matsuri",
            takayamaAutumn: "Takayama Autumn Festival",
            sapporoSnow: "Sapporo Snow Festival",
            otaruSnow: "Otaru Snow Light Path Festival",
            nozawaOnsenFire: "Nozawa Onsen Fire Festival",
            obonFestival: "Obon Festival",

            tabPlaces: "Places",
            tabEvents: "Events"
        },

        home: {
            sections: {
                recommendations: {
                    title: "POPULAR DESTINATIONS",
                    subtitle: "Discover Japan's most iconic cities, cultural treasures and breathtaking landscapes."
                },
                excursions: {
                    title: "JAPAN TOUR PROGRAMMES",
                    desc: "Choose from carefully designed Japan itineraries for first-time visitors, families, couples and culture lovers."
                },
                packages: {
                    title: "POPULAR JAPAN TOUR PACKAGES"
                }
            },

            recommendations: {
                tokyo: {
                    label: "Tokyo",
                    name: "Shibuya Crossing, Asakusa, Tokyo Skytree, Shopping & Anime"
                },
                mountFuji: {
                    label: "Mount Fuji",
                    name: "Lake Kawaguchi, Fuji 5th Station & Scenic Views"
                },
                kyoto: {
                    label: "Kyoto",
                    name: "Temples, Shrines, Bamboo Forest & Geisha District"
                },
                osaka: {
                    label: "Osaka",
                    name: "Dotonbori, Osaka Castle & Universal Studios Japan"
                },
                nara: {
                    label: "Nara",
                    name: "Historic Temples & Friendly Deer Park"
                },
                hakone: {
                    label: "Hakone",
                    name: "Hot Springs, Ropeway & Mt. Fuji Views"
                },
                nikko: {
                    label: "Nikko",
                    name: "UNESCO Shrines & Natural Beauty"
                },
                shirakawago: {
                    label: "Shirakawa-go",
                    name: "Traditional Japanese Village"
                },
                arashiyama: {
                    label: "Arashiyama",
                    name: "Famous Bamboo Forest & Scenic River"
                },
                himeji: {
                    label: "Himeji",
                    name: "Japan's Most Beautiful Castle"
                }
            },

            excursions: {
                oneDay: {
                    title: "Tokyo City Tour",
                    des: "Visit Shibuya Crossing, Asakusa Temple, Tokyo Skytree and Ginza shopping district."
                },
                twoDays: {
                    title: "Tokyo & Mount Fuji",
                    des: "Experience Tokyo highlights before enjoying breathtaking views of Mount Fuji and Lake Kawaguchi."
                },
                threeDays: {
                    title: "Tokyo • Fuji • Hakone",
                    des: "Combine modern Tokyo with Hakone hot springs, ropeway and Mount Fuji scenery."
                },
                fourDays: {
                    title: "Tokyo • Kyoto",
                    des: "Explore Japan's modern capital and the ancient cultural heart of Kyoto."
                },
                fiveDays: {
                    title: "Golden Route Japan",
                    des: "Travel through Tokyo, Mount Fuji, Kyoto and Osaka."
                },
                sixDays: {
                    title: "Classic Japan Discovery",
                    des: "Visit Tokyo, Hakone, Kyoto, Nara and Osaka in one unforgettable journey."
                }
            },

            packages: {
                one: {
                    title: "Tokyo & Mount Fuji",
                    duration: "5 Days",
                    desc: "Perfect first-time Japan experience including Tokyo highlights and Mount Fuji."
                },
                two: {
                    title: "Classic Japan",
                    duration: "7 Days",
                    desc: "Tokyo, Mount Fuji, Kyoto and Osaka."
                },
                three: {
                    title: "Golden Route",
                    duration: "10 Days",
                    desc: "Tokyo, Hakone, Kyoto, Nara and Osaka."
                },
                four: {
                    title: "Japan Explorer",
                    duration: "12 Days",
                    desc: "Tokyo, Hakone, Kyoto, Nara, Osaka and Hiroshima."
                },
                five: {
                    title: "Japan Highlights",
                    duration: "14 Days",
                    desc: "Discover Japan's famous cities, cultural landmarks and scenic countryside."
                },
                six: {
                    title: "Grand Japan Tour",
                    duration: "14 Days",
                    desc: "The ultimate journey across Japan including Miyajima Island and Hiroshima."
                }
            },

            featured: {
                elephantRide: {
                    h2: "ICONIC LANDMARK",
                    h3: "MOUNT FUJI",
                    paragraph: "Experience Japan's most famous mountain with panoramic views, Lake Kawaguchi and Fuji 5th Station.",
                    button: "Explore"
                },
                perahera: {
                    h2: "CULTURAL HERITAGE",
                    h3: "KYOTO TEMPLES",
                    h4: "Ancient Japan",
                    paragraph: "Discover Kyoto's timeless temples, shrines, bamboo forests and the famous Geisha district.",
                    button: "Discover"
                },
                safari: {
                    h2: "FAMILY ADVENTURE",
                    h3: "TOKYO DISNEY RESORT",
                    paragraph: "Enjoy unforgettable family moments at Tokyo Disneyland and Tokyo DisneySea with world-class attractions.",
                    button: "Learn More"
                }
            },

            famousTours: {
                title: "OUR MOST POPULAR JAPAN TOURS",
                subtitle: "Discover Japan with carefully designed itineraries covering the country's most iconic destinations.",
                bookNow: "Book Now",

                tours: {
                    benthotaRiverSafari: {
                        title: "5 Days",
                        description: "Tokyo + Mount Fuji"
                    },

                    polgampalaWaterPool: {
                        title: "7 Days",
                        description: "Tokyo + Mount Fuji + Kyoto + Osaka"
                    },

                    galleTour: {
                        title: "10 Days",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka"
                    },

                    sigiriyaTour: {
                        title: "12–14 Days",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima"
                    }
                }
            },

            gallery: {
                title: "OUR JAPAN GALLERY",
                subtitle: "Explore unforgettable moments captured across Japan's iconic cities, cultural landmarks and scenic landscapes."
            },
            cta: {
                title: "START YOUR JAPAN ADVENTURE TODAY",
                desc: "Let Sonic Tours create your perfect Japan holiday with carefully designed itineraries, unforgettable experiences and exceptional service from start to finish.",
                button: "Plan Your Journey",
                alt: "Japan Tour"
            }
        },

        hero: {
            title: {
                line1: "Explore Japan with",
                line2: "Sonic Tours",
                line3: "Japan"
            },
            subtitle: "Ancient temples, vibrant cities, peaceful gardens, and unforgettable adventures —",
            subtitle2: "crafted around your journey.",
            cta: "Start Your Journey",
            trust: "Loved by travelers from 50+ countries • Trusted by global travel experts"
        },
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "Home",
                about: "About Us",
                explore: "Japan Tourism",
                tours: "Tours",
                gallery: "Gallery",
                events: "Events",
                things: "Things to Do",
                contact: "Contact Us"
            },

            contact: {
                title: "Get in Touch",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "Stay Connected",
                desc: "Subscribe to receive exclusive Japan travel tips, seasonal offers, and early access to new tours.",
                placeholder: "Enter your email",
                subscribe: "Subscribe"
            },

            tagline: "Discover the soul of Japan with <span class='text-[#f7d774]'>Sonic Tours Japan</span> — Your trusted travel partner for authentic and unforgettable journeys.",

            copyright: "All Rights Reserved.",
            developedBy: "Developed by"
        },



    },

    de: {
        translation: {
            home: 'Startseite',
            aboutUs: 'Über uns',
            sriLankanav: 'Japan',
            gallerynav: 'Galerie',
            bookATour: 'Touren',
            thingsToDo: 'Dinge zu tun',
            contactUs: 'Kontakt',
            contactJapan: 'Kontakt Japan',
            japanHeroEyebrow: 'Japan entdecken',
            japanHeroTitle: 'Erleben Sie die Eleganz Japans mit Sonic Tours',
            japanHeroSubtitle: 'Von alten Tempeln und ruhigen Gärten bis hin zu lebendigen Städten und unvergesslichen Abenteuern – Japan bietet eine Reise wie keine andere.',
            japanHeroImageAlt: 'Landschaft in Japan',
            japanAboutEyebrow: 'Über Japan',
            japanSectionTitle: 'Ein zeitloses Reiseziel für neugierige Reisende',
            japanSectionDescription: 'Japan verbindet reiches kulturelles Erbe, erstklassige Küche, natürliche Schönheit und moderne Innovation zu einem außergewöhnlichen Reiseerlebnis. Ob stille Tempel, helle Stadtlichter oder malerische Landschaften – Sonic Tours begleitet Sie mit Komfort und Sorgfalt durch alles.',
            japanSectionImageAlt: 'Japanische Reise-Szene',
        },
        about: {
            hero: {
                discover: 'Klassisches Japan',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: 'Entdecken Sie die zeitlose Schönheit Japans mit fachkundig geführten Reisen',
                tagline2: 'Von pulsierenden Städten über heilige Berge bis zu alten Tempeln – lassen Sie uns Ihr perfektes Japan-Abenteuer gestalten.',
            },

            about: {
                title: 'Über Sonic Tours Japan',
            },

            tours: {
                classic: 'Klassisches Japan (Für Erstbesucher)',
                days4: '5–7 Tage',
                desc1: 'Tokio – Shibuya Crossing, Asakusa, Tokyo Skytree, Shopping, Anime & Nachtleben. Mount Fuji – Beeindruckende Aussichten, Kawaguchi-See & Fuji 5th Station.',

                safari: 'Kulturelle Highlights',
                days5: 'Kyoto • Nara • Osaka',
                desc2: 'Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Himeji Burg und der friedliche Charme des Nara Parks.',

                retreat: 'Natur & Landschaften',
                days6: 'Hakone • Arashiyama • Nikko',
                desc3: 'Hakone Onsen & Mt. Fuji Ausblicke, Arashiyama Bambuswald, Nikko und das historische Shirakawa-go.',
            },

            owner: {
                title: 'Unsere Führungskräfte',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: 'Mit tiefer Leidenschaft für die japanische Kultur und jahrzehntelanger Erfahrung im Luxusreisebereich führt Tomoya Izawa Sonic Tours Japan mit Vision und Hingabe. Sein Engagement für authentische Erlebnisse und außergewöhnlichen Service sorgt dafür, dass jeder Gast erstklassige Gastfreundschaft und unvergessliche Reisen durch Japan erlebt.',
                imageAlt: 'Tomoya Izawa - CEO & President von Sonic Tours Japan',
            },

            whoWeAre: {
                title: 'Ihr Japan-Reiseexperte',
                description: 'Unter der Leitung von <strong>Buddika</strong> spezialisiert sich Sonic Tours Japan auf die Gestaltung persönlicher, hochwertiger Reiseerlebnisse durch ganz Japan. Mit tiefem lokalen Wissen und einer Leidenschaft für die japanische Kultur sorgen wir dafür, dass jede Reise reibungslos, bereichernd und wirklich unvergesslich wird.',
                item1: { title: 'Erfahrene Lokale Guides', text: 'Lizenziert & erfahren' },
                item2: { title: 'Individuelle Reiserouten', text: 'An Ihr Tempo angepasst' },
                item3: { title: 'Nahtloses Erlebnis', text: 'Stressfreies Reisen' },
                item4: { title: '24/7 Support', text: 'Immer für Sie da' },
                imageAlt: 'Buddika - Japan Reiseexperte',
            },

            offers: {
                title: 'Was wir anbieten',
                cultural: {
                    title: 'Kulturelles Eintauchen',
                    text: 'Tempel, Schreine, traditionelle Künste & lokale Traditionen',
                    alt: 'Japanische kulturelle Erlebnisse'
                },
                adventure: {
                    title: 'Natur & Abenteuer',
                    text: 'Mount Fuji, Hakone, Wandern & landschaftliche Reisen',
                    alt: 'Japan Naturabenteuer'
                },
                luxury: {
                    title: 'Luxusreisen',
                    text: 'Premium-Hotels, private Transfers & exklusive Erlebnisse',
                    alt: 'Luxus Japan Reisen'
                },
                wellness: {
                    title: 'Wellness & Entspannung',
                    text: 'Onsen-Heilquellen, Achtsamkeit & erholsame Retreats',
                    alt: 'Japan Wellness Retreats'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'Lead Tour Guide',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: 'Mit jahrelanger Erfahrung als Reiseleiter durch Japan teilt Buddika leidenschaftlich die authentische Schönheit, Kultur und verborgenen Schätze dieses beeindruckenden Landes. Seine herzliche Persönlichkeit und sein tiefes Wissen machen jede Tour zu etwas Besonderem.',
            },

            villageTours: {
                title: 'Authentische Japan-Erlebnisse',
                description: 'Abseits der großen Städte entdecken Sie traditionelle Dörfer, lokales Handwerk, saisonale Feste und die herzliche Gastfreundschaft, die das echte Japan ausmacht.',
                imageAlt: 'Traditionelles japanisches Dorferlebnis',
                bookButton: 'Authentisches Japan entdecken',
            },

            vehicles: {
                title: 'Unsere Fahrzeugflotte',
                text: 'Komfortable, moderne und gut gepflegte Fahrzeuge für eine entspannte Reise durch Japan.',
                bookButton: 'Ihre Tour buchen',
                car: { title: 'Privater Wagen', text: 'Ideal für Paare & kleine Gruppen' },
                van: { title: 'Komfort-Van', text: 'Geräumig & komfortabel' },
                minibus: { title: 'Minibus', text: 'Perfekt für Familien & mittelgroße Gruppen' },
                luxury: { title: 'Luxus-Bus', text: 'Premium-Erlebnis für größere Gruppen' },
            },

            notices: {
                title: 'Mit Zuversicht reisen',
                intro: 'Bei Sonic Tours Japan stehen Ihr Komfort, Ihre Sicherheit und Ihre Zufriedenheit an erster Stelle.',
                fruits: { title: 'Kostenlose Snacks', text: 'Saisonale Früchte & leichte Erfrischungen' },
                meals: { title: 'Sorgfältig ausgewählte Mahlzeiten', text: 'Authentische japanische Küche-Erlebnisse' },
                massage: { title: 'Entspannungsangebote', text: 'Optionale Onsen- & Wellness-Zusatzleistungen' },
                flowers: { title: 'Herzliche Begrüßung', text: 'Traditionelle japanische Gastfreundschaft' },
            },

            slider: {
                sigiriya: 'Mount Fuji',
                yala: 'Kyoto Tempel',
                tea: 'Arashiyama Bambuswald',
                beaches: 'Hakone See',
                temples: 'Nara Rehpark',
            },
        },
        tourPackages: {
            hero: {
                discover: 'Klassisches Japan',
                starLankaTours: 'Erstbesucher',
                highlight: 'Eine zeitlose Reise durch Tokio, Fuji, Kyoto und Osaka',
                tagline1: 'Von ikonischen Stadtlichtern bis zu ruhigen Tempeln bietet Japan eine bemerkenswerte erste Reise für jeden Reisenden.',
                tagline2: 'Lassen Sie Sonic Tours Ihre Traumroute in eine reibungslose und unvergessliche Japan-Reise verwandeln.',
            },
            overview: {
                eyebrow: 'Japan Highlights',
                title: 'Japan Highlights für Erstbesucher',
                description: 'Diese Ziele gehören zu den beliebtesten bei internationalen Reisenden und bilden eine hervorragende Grundlage für attraktive Japan-Rundreisen.',
            },
            cards: {
                classicTitle: 'Klassisches Japan (Erstbesucher)',
                classicMeta: 'Tokio • Mount Fuji',
                classicText: 'Tokio begeistert mit der Shibuya Crossing, Asakusa, dem Tokyo Skytree, Shopping, Anime und Nachtleben. Der Mount Fuji bietet atemberaubende Ausblicke, den Kawaguchi-See und die 5. Station.',
                classicAlt: 'Tokio Skyline und Mount Fuji',
                culturalTitle: 'Kulturelle Attraktionen',
                culturalMeta: 'Kyoto • Nara • Osaka',
                culturalText: 'Entdecken Sie den Fushimi Inari Taisha, den Kinkaku-ji, den Senso-ji, die Burg Himeji und den friedlichen Charme des Nara Parks.',
                culturalAlt: 'Japanische Tempel und Kulturstätten',
                natureTitle: 'Natur & Landschaften',
                natureMeta: 'Hakone • Arashiyama • Nikko',
                natureText: 'Genießen Sie Hakone mit heißen Quellen und Mount Fuji Ausblicken, den Bambuswald von Arashiyama, Nikko und Shirakawa-go.',
                natureAlt: 'Malerische japanische Landschaften',
            },
            highlights: {
                eyebrow: 'Beliebte Erlebnisse',
                title: 'Planen Sie die perfekte Japan-Reise nach Ihren Interessen',
                text: 'Ob Sie saisonale Schönheit, Familienvergnügen oder kulturelle Entdeckungen lieben – Sonic Tours gestaltet eine Route, die sich mühelos und inspirierend anfühlt.',
                seasonalTitle: 'Saisonale Attraktionen',
                seasonalText: 'Der Frühling ist ideal für Kirschblüten, der Sommer zum Mount Fuji Besteigen und für Festivals, der Herbst für das Laub in Kyoto und Nikko und der Winter zum Skifahren in Niseko oder dem Schnee-Festival in Sapporo.',
                familyTitle: 'Familienfreundliche Attraktionen',
                familyText: 'Tokyo Disneyland, Tokyo DisneySea, Universal Studios Japan und das Osaka Aquarium Kaiyukan sind wunderbare Ziele für Familien.',
            },
            recommended: {
                eyebrow: 'Empfohlene Reise-Pakete',
                title: 'Empfohlene Reise-Pakete',
                subtitle: 'Wählen Sie die perfekte Reisedauer für Ihr erstes Japan-Abenteuer',
                packages: {
                    fiveDays: {
                        title: '5 Tage: Tokio + Mount Fuji',
                        description: 'Perfekte Einführung in Japan – pulsierendes Tokio und der ikonische Mount Fuji.',
                        alt: 'Tokio und Mount Fuji'
                    },
                    sevenDays: {
                        title: '7 Tage: Tokio + Mount Fuji + Kyoto + Osaka',
                        description: 'Klassische Route durch Japans wichtigste Städte und das kulturelle Herz des Landes.',
                        alt: 'Kyoto und Osaka'
                    },
                    tenDays: {
                        title: '10 Tage: Tokio + Hakone + Kyoto + Nara + Osaka',
                        description: 'Tiefgehende Erkundung mit Hakones landschaftlicher Schönheit und dem historischen Nara.',
                        alt: 'Hakone und Nara'
                    },
                    twelveToFourteenDays: {
                        title: '12–14 Tage: Tokio + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima',
                        description: 'Umfassende Reise inklusive der bewegenden Geschichte Hiroshimas und der heiligen Insel Miyajima.',
                        alt: 'Hiroshima und Miyajima'
                    }
                }
            },
            cta: {
                eyebrow: 'Maßgeschneiderte Japan-Reisen',
                title: 'Lassen Sie Sonic Tours Ihre Japan-Reise gestalten',
                text: 'Wählen Sie eine klassische Erstbesucher-Route oder eine individuelle Reiseroute, die auf Ihr Tempo, Ihre Interessen und die Jahreszeit abgestimmt ist.',
                button: 'Meine Japan-Reise planen',
                imageAlt: 'Japan Reise-Erlebnis',
            },
        },
        // German (de)
        contactus: {
            heroTitle: 'Kontaktieren Sie uns',
            heroSubtitle: 'Sonic Tours Japan – Ihr Tor zu unvergesslichen Japan-Reisen',

            feelFree: 'Zögern Sie nicht, uns zu kontaktieren',
            planDream: 'Planen Sie Ihre perfekte Japan-Reise',
            reachOutDesc: 'Kontaktieren Sie Sonic Tours Japan für maßgeschneiderte Reisepläne, fachkundige Beratung und unvergessliche Erlebnisse in ganz Japan.',

            callCenter: 'Kontaktzentrum',
            phone: '+81 90-8251-4053',
            emailTitle: 'E-Mail',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: 'Unsere Adresse',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: 'Folgen Sie uns',

            getInTouch: 'Lassen Sie uns verbinden',
            getInTouchDesc: 'Starten Sie Ihr Japan-Abenteuer mit Sonic Tours Japan – wir sind für Sie da, um unvergessliche Erinnerungen zu schaffen.',

            nameLabel: 'Name',
            namePlaceholder: 'Ihr vollständiger Name',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'ihre.email@beispiel.de',
            phoneLabel: 'Telefonnummer',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'Nachricht',
            messagePlaceholder: 'Erzählen Sie uns von Ihrer Traumreise nach Japan...',

            sendButton: 'Nachricht senden',
            sendingButton: 'Wird gesendet...',
            successMsg: 'Ihre Nachricht wurde per WhatsApp gesendet!',
            errorMsg: 'WhatsApp konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',

            findUsTitle: 'Finden Sie uns in Japan',
        },
        japan: {
            heroTitle: 'CEO & Präsident des Japan-Büros',
            heroSubtitle: 'Ihr vertrauenswürdiger Partner für Sri Lanka-Abenteuer aus Japan',

            contactPerson: 'Tomoya Izawa',
            position: 'Japan-Vertreter',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'Verbinden Sie sich mit uns in sozialen Medien',

            formTitle: 'Senden Sie uns eine Nachricht',
            formHeading: 'Beginnen Sie Ihr Sri Lanka-Abenteuer',
            formDescription: 'Kontaktieren Sie Tomoya Izawa für personalisierte Tourpakete, fachkundige Reiseberatung und unvergessliche Sri Lanka-Erlebnisse.',

            nameLabel: 'Ihr Name *',
            namePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
            emailLabel: 'E-Mail-Adresse *',
            emailPlaceholder: 'ihre.email@beispiel.de',
            phoneLabel: 'Telefonnummer',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'Ihre Nachricht *',
            messagePlaceholder: 'Erzählen Sie uns von Ihrem Traum-Sri-Lanka-Abenteuer...',

            sendButton: 'Nachricht per E-Mail senden',
            sendingButton: 'E-Mail-Client wird geöffnet...',
            successMsg: 'Ihr E-Mail-Client wurde mit der Nachricht geöffnet!',
            errorMsg: 'E-Mail-Client konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',

            whyChooseTitle: 'Warum Sonic Tours wählen?',

            expertiseTitle: 'Lokale Expertise',
            expertiseDesc: 'Authentische Sri Lanka-Erlebnisse, kuratiert von lokalen Experten, die jeden versteckten Schatz kennen',

            supportTitle: 'Japanischer Support',
            supportDesc: 'Engagierter japanischsprachiger Vertreter für nahtlose Kommunikation',

            personalizedTitle: 'Personalisierte Touren',
            personalizedDesc: 'Maßgeschneiderte Reisepläne, die Ihren Interessen und Ihrem Reisestil entsprechen',

            mapTitle: 'Finden Sie uns in Sri Lanka',
        },

        // German (de)
        thingstodo: {
            heroTitle: "Aktivitäten in Japan",
            heroSubtitle: "Entdecken Sie unvergessliche Erlebnisse und schaffen Sie lebenslange Erinnerungen im Land der aufgehenden Sonne.",

            sectionTitle: "Unvergessliche Erlebnisse in Japan",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "Kirschblütenbetrachtung",
                description: "Japans ikonischstes und atemberaubendstes saisonales Erlebnis.",
                para1: "Die Kirschblütenbetrachtung, bekannt als 'Hanami', ist eine der beliebtesten Traditionen Japans. Jeden Frühling versammeln sich Millionen unter rosa Kirschblüten, um die vergängliche Schönheit des Lebens zu feiern.",
                para2: "Beliebte Orte sind der Ueno-Park und Shinjuku Gyoen in Tokio, der Philosophenweg in Kyoto sowie der Schlosspark in Osaka. Viele Menschen machen Picknicks (Hanami-Bentos) mit Familie und Freunden unter den Blüten.",
                para3: "Die Hochsaison liegt meist Ende März bis Anfang April. Abends schaffen Beleuchtungen eine magische Atmosphäre an vielen Standorten."
            },

            ancientTemples: {
                title: "Alte Tempel & Schreine",
                description: "Entdecken Sie Japans spirituelles Erbe durch antike Tempel und Schreine.",
                para1: "Japan beherbergt Tausende historischer Tempel und Schreine, von denen viele UNESCO-Weltkulturerbestätten sind.",
                para2: "Ikone Stätten sind der Fushimi Inari Taisha mit seinen Tausenden roten Torii-Toren, der Kinkaku-ji (Goldener Pavillon) und der imposante Todaiji-Tempel in Nara.",
                para3: "Besucher können an Ritualen teilnehmen, Orakel (Omikuji) ziehen oder einfach die ruhigen Gärten und die saisonale Schönheit dieser heiligen Orte genießen."
            },

            mountFuji: {
                title: "Mount Fuji & Fuji Fünf Seen",
                description: "Erleben Sie das majestätische und heilige Symbol Japans.",
                para1: "Mit 3.776 Metern ist der Mount Fuji Japans höchster Berg und ein kulturelles Wahrzeichen.",
                para2: "Die besten Aussichten bietet die Region der Fuji Fünf Seen (besonders der Kawaguchi-See). Sie können den Gipfel in der offiziellen Saison besteigen oder das ganze Jahr über die Landschaft genießen.",
                para3: "Die Umgebung bietet charmante Städte, Onsen-Resorts und erstklassige Fotomotive."
            },

            onsenRelax: {
                title: "Traditionelle Onsen-Heilquellen",
                description: "Erholen Sie Körper und Geist in Japans traditionellen heißen Quellen.",
                para1: "Die Onsen-Kultur ist tief in Japan verwurzelt. Natürliche heiße Quellen sollen heilende Wirkungen haben.",
                para2: "Beliebte Ziele sind Hakone, Beppu und Kusatsu. Viele Ryokans bieten Außenbäder (Rotenburo) mit atemberaubender Aussicht.",
                para3: "Das Beachten der Onsen-Etikette verbessert das Erlebnis und zeigt Respekt vor der japanischen Badekultur."
            },

            japaneseCuisine: {
                title: "Authentische Japanische Küche",
                description: "Genießen Sie weltberühmte japanische Gerichte und Streetfood.",
                para1: "Von frischem Sushi und Sashimi über herzhafte Ramen, Tempura bis hin zu mehrgängigen Kaiseki-Menüs – die japanische Küche ist immaterielles UNESCO-Kulturerbe.",
                para2: "Tokio, Osaka und Kyoto sind kulinarische Paradiese. Probieren Sie Streetfood in Dotonbori oder auf dem Nishiki-Markt.",
                para3: "Food-Touren und Kochkurse sind hervorragende Möglichkeiten, die japanischen kulinarischen Traditionen besser kennenzulernen."
            },

            shinkansen: {
                title: "Fahrt mit dem Shinkansen (Hochgeschwindigkeitszug)",
                description: "Erleben Sie den weltberühmten Bullet Train.",
                para1: "Der Shinkansen ist ein Symbol für Japans technologische Exzellenz und Pünktlichkeit.",
                para2: "Reisen Sie komfortabel zwischen Großstädten wie Tokio, Kyoto, Osaka und Hiroshima mit Geschwindigkeiten über 300 km/h.",
                para3: "Die Fahrt selbst ist Teil des Erlebnisses – sauber, leise und unglaublich effizient."
            },

            matsuriFestivals: {
                title: "Traditionelle Matsuri-Festivals",
                description: "Tauchen Sie ein in lebendige traditionelle Feste.",
                para1: "Matsuri sind lebhafte Gemeinschaftsfeste mit Umzügen, Musik, Essensständen und traditionellen Tänzen.",
                para2: "Berühmte Veranstaltungen sind das Gion Matsuri in Kyoto, das Nebuta Matsuri in Aomori und das Tenjin Matsuri in Osaka.",
                para3: "Die Teilnahme an einem Matsuri bietet eine wunderbare Gelegenheit, die lokale Kultur und den japanischen Geist kennenzulernen."
            },

            themeParks: {
                title: "Themenparks & Unterhaltung",
                description: "Genießen Sie erstklassige Themenparks und Attraktionen.",
                para1: "Tokyo Disneyland und DisneySea gehören zu den beliebtesten der Welt.",
                para2: "Universal Studios Japan in Osaka bietet aufregende Attraktionen zu Harry Potter, Super Nintendo World und mehr.",
                para3: "Diese Parks bieten Spaß für alle Altersgruppen und sind besonders während saisonaler Events magisch."
            },

            shoppingJapan: {
                title: "Shopping in Tokio, Osaka & Kyoto",
                description: "Shoppen bis zum Umfallen in Japans pulsierenden Städten.",
                para1: "Von Luxusmarken in Ginza und Omotesando über Elektronik in Akihabara bis zu Mode in Shinsaibashi.",
                para2: "Vergessen Sie nicht Kaufhäuser, 100-Yen-Shops und traditionelle Handwerksmärkte.",
                para3: "Steuerfreies Shopping und einzigartige Souvenirs machen das Einkaufen in Japan zu einem besonderen Erlebnis."
            },

            fourSeasons: {
                title: "Japans Vier Schöne Jahreszeiten",
                description: "Erleben Sie die Magie von Japans ausgeprägten vier Jahreszeiten.",
                para1: "Japan ist bekannt für seine dramatischen jahreszeitlichen Veränderungen – Frühlingskirschblüten, lebendige Sommerfeste, bunte Herbstlaubfärbung und verschneite Winterlandschaften.",
                para2: "Jede Jahreszeit bietet einzigartige Feste, Küche und Landschaften im ganzen Land.",
                para3: "Egal wann Sie kommen – Japans natürliche Schönheit und kulturellen Feiern hinterlassen einen bleibenden Eindruck."
            },

            viewMore: "Mehr Details",
            close: "Schließen",

            ctaTitle: "Bereit für Ihr Japan-Abenteuer?",
            ctaDescription: "Lassen Sie Sonic Tours Japan mit fachkundiger Beratung und persönlichem Service Ihre perfekte Reiseroute gestalten.",
            ctaButton: "Jetzt Ihre Reise planen"
        },
        // German (de)
        gallery: {
            heroTitle: "Entdecke Japan",
            heroSubtitle: "Erkunde die atemberaubende Schönheit, Kultur und die ikonischen Wahrzeichen Japans in unserer sorgfältig zusammengestellten Galerie.",

            // 20 Selected Places
            shibuya: "Shibuya Crossing",
            asakusa: "Senso-ji Tempel",
            skytree: "Tokyo Skytree",
            mtfuji: "Mount Fuji",
            lakeKawaguchi: "Kawaguchi-See",
            hakoneRopeway: "Hakone Seilbahn",
            fushimiInari: "Fushimi Inari Taisha",
            arashiyama: "Arashiyama Bambuswald",
            kinkakuji: "Kinkaku-ji (Goldener Pavillon)",
            osakaCastle: "Osaka Burg",
            dotonbori: "Dotonbori",
            naraPark: "Nara Park",
            todaiji: "Todai-ji Tempel",
            hiroshimaPeace: "Hiroshima Friedensdenkmal",
            miyajima: "Itsukushima Schrein",
            nikko: "Toshogu Schrein",
            shirakawago: "Shirakawa-go",
            himeji: "Himeji Burg",
            universal: "Universal Studios Japan",
            teamlab: "TeamLab Planets",

            lightboxClose: "Schließen",
            lightboxNext: "Weiter",
            lightboxPrevious: "Zurück",
            tabPlaces: "Orte",
            tabEvents: "Events"
        },
        // German (de)
        events: {
            heroTitle: "Japanische Feste",
            heroSubtitle: "Erleben Sie die lebendigen Farben, tiefen Traditionen und die unvergessliche Atmosphäre der weltberühmten Feste und Feiern Japans.",

            // 20 Selected Festivals
            sakuraMatsuri: "Kirschblütenfestivals (Sakura Matsuri)",
            hinaMatsuri: "Hina Matsuri (Puppenfest)",
            takayamaSpring: "Takayama Frühlingsfest",
            kandaMatsuri: "Kanda Matsuri",
            aoiMatsuri: "Aoi Matsuri",
            fujiShibazakura: "Fuji Shibazakura Festival",
            gionMatsuri: "Gion Matsuri",
            tenjinMatsuri: "Tenjin Matsuri",
            nebutaMatsuri: "Nebuta Matsuri",
            sendaiTanabata: "Sendai Tanabata Festival",
            awaOdori: "Awa Odori Festival",
            sumidaFireworks: "Sumida River Feuerwerksfestival",
            nagaokaFireworks: "Nagaoka Feuerwerksfestival",
            kishiwadaDanjiri: "Kishiwada Danjiri Festival",
            jidaiMatsuri: "Jidai Matsuri",
            takayamaAutumn: "Takayama Herbstfest",
            sapporoSnow: "Sapporo Schneefestival",
            otaruSnow: "Otaru Schneelichterpfad Festival",
            nozawaOnsenFire: "Nozawa Onsen Feuerfestival",
            obonFestival: "Obon Festival",

            tabPlaces: "Orte",
            tabEvents: "Veranstaltungen"
        },

        // German (de)
        home: {
            sections: {
                recommendations: {
                    title: "BELIEBTE REISEZIELE",
                    subtitle: "Entdecken Sie Japans ikonischste Städte, kulturelle Schätze und atemberaubende Landschaften."
                },
                excursions: {
                    title: "JAPAN TOUR PROGRAMME",
                    desc: "Wählen Sie aus sorgfältig gestalteten Japan-Reiseplänen für Erstbesucher, Familien, Paare und Kulturliebhaber."
                },
                packages: {
                    title: "BELIEBTE JAPAN TOUR PAKETE"
                }
            },

            recommendations: {
                tokyo: {
                    label: "Tokyo",
                    name: "Shibuya Crossing, Asakusa, Tokyo Skytree, Shopping & Anime"
                },
                mountFuji: {
                    label: "Mount Fuji",
                    name: "Lake Kawaguchi, Fuji 5th Station & Panoramablicke"
                },
                kyoto: {
                    label: "Kyoto",
                    name: "Tempel, Schreine, Bambuswald & Geisha-Viertel"
                },
                osaka: {
                    label: "Osaka",
                    name: "Dotonbori, Osaka Castle & Universal Studios Japan"
                },
                nara: {
                    label: "Nara",
                    name: "Historische Tempel & Freundlicher Hirschpark"
                },
                hakone: {
                    label: "Hakone",
                    name: "Heiße Quellen, Seilbahn & Mt. Fuji Ausblicke"
                },
                nikko: {
                    label: "Nikko",
                    name: "UNESCO-Schreine & Naturschönheit"
                },
                shirakawago: {
                    label: "Shirakawa-go",
                    name: "Traditionelles japanisches Dorf"
                },
                arashiyama: {
                    label: "Arashiyama",
                    name: "Berühmter Bambuswald & Malerischer Fluss"
                },
                himeji: {
                    label: "Himeji",
                    name: "Japans schönstes Schloss"
                }
            },

            excursions: {
                oneDay: {
                    title: "Tokyo Stadtrundfahrt",
                    des: "Besuchen Sie Shibuya Crossing, Asakusa Tempel, Tokyo Skytree und das Ginza Einkaufsviertel."
                },
                twoDays: {
                    title: "Tokyo & Mount Fuji",
                    des: "Erleben Sie die Highlights Tokios und genießen Sie anschließend die atemberaubende Aussicht auf den Mount Fuji und den Lake Kawaguchi."
                },
                threeDays: {
                    title: "Tokyo • Fuji • Hakone",
                    des: "Kombinieren Sie das moderne Tokyo mit heißen Quellen in Hakone, Seilbahn und Mount Fuji Kulisse."
                },
                fourDays: {
                    title: "Tokyo • Kyoto",
                    des: "Erkunden Sie Japans moderne Hauptstadt und das antike kulturelle Herz Kyotos."
                },
                fiveDays: {
                    title: "Goldene Route Japan",
                    des: "Reisen Sie durch Tokyo, Mount Fuji, Kyoto und Osaka."
                },
                sixDays: {
                    title: "Klassische Japan Entdeckung",
                    des: "Besuchen Sie Tokyo, Hakone, Kyoto, Nara und Osaka in einer unvergesslichen Reise."
                }
            },

            packages: {
                one: {
                    title: "Tokyo & Mount Fuji",
                    duration: "5 Tage",
                    desc: "Perfekte Japan-Erfahrung für Erstbesucher mit Tokyo Highlights und Mount Fuji."
                },
                two: {
                    title: "Klassisches Japan",
                    duration: "7 Tage",
                    desc: "Tokyo, Mount Fuji, Kyoto und Osaka."
                },
                three: {
                    title: "Goldene Route",
                    duration: "10 Tage",
                    desc: "Tokyo, Hakone, Kyoto, Nara und Osaka."
                },
                four: {
                    title: "Japan Explorer",
                    duration: "12 Tage",
                    desc: "Tokyo, Hakone, Kyoto, Nara, Osaka und Hiroshima."
                },
                five: {
                    title: "Japan Highlights",
                    duration: "14 Tage",
                    desc: "Entdecken Sie Japans berühmte Städte, kulturelle Wahrzeichen und malerische Landschaften."
                },
                six: {
                    title: "Große Japan Rundreise",
                    duration: "14 Tage",
                    desc: "Die ultimative Reise durch Japan inklusive Miyajima Insel und Hiroshima."
                }
            },

            featured: {
                elephantRide: {
                    h2: "IKONISCHES WAHRZEICHEN",
                    h3: "MOUNT FUJI",
                    paragraph: "Erleben Sie Japans berühmtesten Berg mit Panoramablicken, Lake Kawaguchi und Fuji 5th Station.",
                    button: "Erkunden"
                },
                perahera: {
                    h2: "KULTURELLES ERBE",
                    h3: "KYOTO TEMPel",
                    h4: "Altes Japan",
                    paragraph: "Entdecken Sie Kyotos zeitlose Tempel, Schreine, Bambuswälder und das berühmte Geisha-Viertel.",
                    button: "Entdecken"
                },
                safari: {
                    h2: "FAMILIENABENTEUER",
                    h3: "TOKYO DISNEY RESORT",
                    paragraph: "Genießen Sie unvergessliche Familienmomente im Tokyo Disneyland und Tokyo DisneySea mit erstklassigen Attraktionen.",
                    button: "Mehr erfahren"
                }
            },

            famousTours: {
                title: "UNSERE BELIEBTESTEN JAPAN TOUREN",
                subtitle: "Entdecken Sie Japan mit sorgfältig gestalteten Reiseplänen, die die ikonischsten Ziele des Landes abdecken.",
                bookNow: "Jetzt buchen",

                tours: {
                    benthotaRiverSafari: {
                        title: "5 Tage",
                        description: "Tokyo + Mount Fuji"
                    },

                    polgampalaWaterPool: {
                        title: "7 Tage",
                        description: "Tokyo + Mount Fuji + Kyoto + Osaka"
                    },

                    galleTour: {
                        title: "10 Tage",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka"
                    },

                    sigiriyaTour: {
                        title: "12–14 Tage",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima"
                    }
                }
            },

            gallery: {
                title: "UNSERE JAPAN GALERIE",
                subtitle: "Erkunden Sie unvergessliche Momente aus Japans ikonischen Städten, kulturellen Wahrzeichen und malerischen Landschaften."
            },
            cta: {
                title: "STARTEN SIE HEUTE IHR JAPAN-ABENTEUER",
                desc: "Lassen Sie Sonic Tours Ihre perfekte Japan-Reise gestalten – mit sorgfältig ausgearbeiteten Reiseplänen, unvergesslichen Erlebnissen und außergewöhnlichem Service von Anfang bis Ende.",
                button: "Plane deine Reise",
                alt: "Japan Rundreise"
            }
        },
        // German (de)
        hero: {
            title: {
                line1: "Entdecken Sie Japan mit",
                line2: "Sonic Tours",
                line3: "Japan"
            },
            subtitle: "Alte Tempel, lebendige Städte, ruhige Gärten und unvergessliche Abenteuer —",
            subtitle2: "maßgeschneidert für Ihre Reise.",

            cta: "Beginnen Sie Ihre Reise",
            trust: "Geliebt von Reisenden aus über 50 Ländern • Vertraut von globalen Reiseexperten"
        },
        // German (de)
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "Startseite",
                about: "Über uns",
                explore: "Japan Tourismus",
                tours: "Touren",
                gallery: "Galerie",
                events: "Veranstaltungen",
                things: "Sehenswürdigkeiten",
                contact: "Kontakt"
            },

            contact: {
                title: "Kontaktieren Sie uns",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "Bleiben Sie verbunden",
                desc: "Abonnieren Sie unseren Newsletter und erhalten Sie exklusive Japan-Reisetipps, saisonale Angebote und frühzeitigen Zugang zu neuen Touren.",
                placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
                subscribe: "Abonnieren"
            },

            tagline: "Entdecken Sie die Seele Japans mit <span class='text-[#f7d774]'>Sonic Tours Japan</span> — Ihr vertrauenswürdiger Reiseveranstalter für authentische und unvergessliche Reisen.",

            copyright: "Alle Rechte vorbehalten.",
            developedBy: "Entwickelt von"
        },

    },
    ru: {
        translation: {
            home: 'Главная',
            aboutUs: 'О нас',
            sriLankanav: 'Япония',
            gallerynav: 'Галерея',
            bookATour: 'Туры',
            thingsToDo: 'Что делать',
            contactUs: 'Связаться с нами',
            contactJapan: 'Контакт Япония',
            japanHeroEyebrow: 'Откройте Японию',
            japanHeroTitle: 'Почувствуйте элегантность Японии с Sonic Tours',
            japanHeroSubtitle: 'От древних храмов и спокойных садов до ярких городов и незабываемых приключений — Япония предлагает путешествие, которого вы не забудете.',
            japanHeroImageAlt: 'Пейзаж Японии',
            japanAboutEyebrow: 'О Японии',
            japanSectionTitle: 'Вечная страна для любознательных путешественников',
            japanSectionDescription: 'Япония сочетает в себе богатое культурное наследие, превосходную кухню, природную красоту и современный инновационный дух в одном удивительном путешествии. Будь то тихие храмы, яркие огни городов или живописные пейзажи — Sonic Tours поможет вам открыть всё это с комфортом и заботой.',
            japanSectionImageAlt: 'Пейзаж путешествия по Японии',
        },
        about: {
            hero: {
                discover: 'Классическая Япония',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: 'Откройте для себя вневременную красоту Японии с экспертными экскурсиями',
                tagline2: 'От оживлённых городов до священных гор и древних храмов — позвольте нам создать ваше идеальное японское приключение.',
            },

            about: {
                title: 'О Sonic Tours Japan',
            },

            tours: {
                classic: 'Классическая Япония (Для первого визита)',
                days4: '5–7 дней',
                desc1: 'Токио — Перекрёсток Шибуя, Асакуса, Tokyo Skytree, шопинг, аниме и ночная жизнь. Гора Фудзи — живописные виды, озеро Кавагути и 5-я станция Фудзи.',

                safari: 'Культурные достопримечательности',
                days5: 'Киото • Нара • Осака',
                desc2: 'Фусими Инари Тайся, Кинкаку-дзи, Сенсо-дзи, Замок Химэдзи и спокойное очарование парка Нара.',

                retreat: 'Природа и живописные места',
                days6: 'Хаконэ • Арасияма • Никко',
                desc3: 'Хаконэ онсэны и виды на гору Фудзи, Бамбуковый лес Арасияма, Никко и историческая деревня Ширакава-го.',
            },

            owner: {
                title: 'Наше руководство',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: 'С глубокой страстью к японской культуре и многолетним опытом в сфере люксового туризма Томоя Идзава возглавляет Sonic Tours Japan с видением и преданностью делу. Его приверженность аутентичным впечатлениям и исключительному сервису гарантирует, что каждый гость получит первоклассное гостеприимство и незабываемые путешествия по Японии.',
                imageAlt: 'Tomoya Izawa - CEO & President Sonic Tours Japan',
            },

            whoWeAre: {
                title: 'Ваш эксперт по путешествиям в Японию',
                description: 'Под руководством <strong>Buddika</strong> Sonic Tours Japan специализируется на создании персонализированных, высококачественных туристических впечатлений по всей Японии. С глубокими местными знаниями и страстью к японской культуре мы гарантируем, что каждое путешествие будет гладким, обогащающим и по-настоящему запоминающимся.',
                item1: { title: 'Опытные местные гиды', text: 'Лицензированные и опытные' },
                item2: { title: 'Индивидуальные маршруты', text: 'Подстроенные под ваш темп' },
                item3: { title: 'Безупречное обслуживание', text: 'Путешествие без стресса' },
                item4: { title: 'Поддержка 24/7', text: 'Всегда на связи' },
                imageAlt: 'Buddika - Эксперт по турам в Японию',
            },

            offers: {
                title: 'Что мы предлагаем',
                cultural: {
                    title: 'Культурное погружение',
                    text: 'Храмы, святилища, традиционные искусства и местные традиции',
                    alt: 'Японские культурные впечатления'
                },
                adventure: {
                    title: 'Природа и приключения',
                    text: 'Гора Фудзи, Хаконэ, пешие походы и живописные маршруты',
                    alt: 'Приключения на природе в Японии'
                },
                luxury: {
                    title: 'Люксовые путешествия',
                    text: 'Премиум-отели, приватные трансферы и эксклюзивные впечатления',
                    alt: 'Люксовые путешествия по Японии'
                },
                wellness: {
                    title: 'Велнес и релаксация',
                    text: 'Онсэны, осознанность и восстановительные ретриты',
                    alt: 'Велнес-ретриты в Японии'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'Ведущий гид',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: 'С многолетним опытом сопровождения путешественников по Японии, Buddika с большой страстью делится аутентичной красотой, культурой и скрытыми жемчужинами этой удивительной страны. Его тёплый характер и глубокие знания делают каждый тур по-настоящему особенным.',
            },

            villageTours: {
                title: 'Аутентичные впечатления от Японии',
                description: 'За пределами больших городов откройте для себя традиционные деревни, местное ремесло, сезонные фестивали и тёплое гостеприимство, которое определяет настоящую Японию.',
                imageAlt: 'Традиционное японское деревенское впечатление',
                bookButton: 'Исследовать аутентичную Японию',
            },

            vehicles: {
                title: 'Наш автопарк',
                text: 'Комфортные, современные и хорошо обслуживаемые автомобили для расслабляющего путешествия по Японии.',
                bookButton: 'Забронировать тур',
                car: { title: 'Приватный автомобиль', text: 'Идеально для пар и небольших групп' },
                van: { title: 'Комфортный микроавтобус', text: 'Просторный и удобный' },
                minibus: { title: 'Микроавтобус', text: 'Идеально для семей и средних групп' },
                luxury: { title: 'Люксовый автобус', text: 'Премиум-опыт для больших групп' },
            },

            notices: {
                title: 'Путешествуйте с уверенностью',
                intro: 'В Sonic Tours Japan ваш комфорт, безопасность и удовлетворение — наши главные приоритеты.',
                fruits: { title: 'Бесплатные закуски', text: 'Сезонные фрукты и лёгкие освежающие напитки' },
                meals: { title: 'Тщательно подобранные блюда', text: 'Погружение в аутентичную японскую кухню' },
                massage: { title: 'Услуги релаксации', text: 'Опциональные онсэны и велнес-дополнения' },
                flowers: { title: 'Тёплый приём', text: 'Традиционное японское гостеприимство' },
            },

            slider: {
                sigiriya: 'Гора Фудзи',
                yala: 'Храмы Киото',
                tea: 'Бамбуковый лес Арасияма',
                beaches: 'Озеро Хаконэ',
                temples: 'Парк оленей в Наре',
            },
        },
        tourPackages: {
            hero: {
                discover: 'Классическая Япония',
                starLankaTours: 'Для первого визита',
                highlight: 'Вневременное путешествие по Токио, Фудзи, Киото и Осаке',
                tagline1: 'От ярких городских огней до спокойных храмов — Япония предлагает замечательное первое путешествие для каждого туриста.',
                tagline2: 'Позвольте Sonic Tours превратить вашу мечту в комфортное и незабываемое путешествие по Японии.',
            },
            overview: {
                eyebrow: 'Главные достопримечательности Японии',
                title: 'Япония: must-see для первого визита',
                description: 'Эти направления наиболее популярны среди иностранных туристов и являются отличной основой для привлекательных туристических пакетов по Японии.',
            },
            cards: {
                classicTitle: 'Классическая Япония (для первого визита)',
                classicMeta: 'Токио • Гора Фудзи',
                classicText: 'Токио — это Shibuya Crossing, Асакуса, Tokyo Skytree, шопинг, аниме и ночная жизнь. Гора Фудзи предлагает живописные виды, озеро Кавагути и 5-ю станцию.',
                classicAlt: 'Токио и гора Фудзи',
                culturalTitle: 'Культурные достопримечательности',
                culturalMeta: 'Киото • Нара • Осака',
                culturalText: 'Откройте для себя Фусими Инари Тайся, Кинкаку-дзи, Сенсо-дзи, замок Химэдзи и спокойное очарование парка Нара.',
                culturalAlt: 'Японские храмы и исторические места',
                natureTitle: 'Природа и живописные места',
                natureMeta: 'Хаконэ • Арашияма • Никко',
                natureText: 'Наслаждайтесь горячими источниками Хаконэ и видами на Фудзи, бамбуковым лесом Арашиямы, Никко и Широкава-го.',
                natureAlt: 'Живописные японские пейзажи',
            },
            highlights: {
                eyebrow: 'Популярные впечатления',
                title: 'Составьте идеальное путешествие по Японии под ваши интересы',
                text: 'Любите ли вы сезонную красоту, семейный отдых или культурные открытия — Sonic Tours создаст маршрут, который будет лёгким и вдохновляющим.',
                seasonalTitle: 'Сезонные достопримечательности',
                seasonalText: 'Весна идеальна для цветения сакуры, лето — для восхождения на Фудзи и фестивалей, осень — для красной листвы в Киото и Никко, зима — для катания на лыжах в Нико или Снежного фестиваля в Саппоро.',
                familyTitle: 'Семейные развлечения',
                familyText: 'Tokyo Disneyland, Tokyo DisneySea, Universal Studios Japan и Осака Аквариум Кайюкан — отличный выбор для семейного отдыха.',
            },
            recommended: {
                eyebrow: 'Рекомендуемые турпакеты',
                title: 'Рекомендуемые турпакеты',
                subtitle: 'Выберите идеальную продолжительность для вашего первого приключения в Японии',
                packages: {
                    fiveDays: {
                        title: '5 дней: Токио + Гора Фудзи',
                        description: 'Идеальное знакомство с Японией — динамичный Токио и легендарная гора Фудзи.',
                        alt: 'Токио и гора Фудзи'
                    },
                    sevenDays: {
                        title: '7 дней: Токио + Гора Фудзи + Киото + Осака',
                        description: 'Классический маршрут по главным городам и культурному сердцу Японии.',
                        alt: 'Киото и Осака'
                    },
                    tenDays: {
                        title: '10 дней: Токио + Хаконэ + Киото + Нара + Осака',
                        description: 'Глубокое погружение с живописной Хаконэ и исторической Нарой.',
                        alt: 'Хаконэ и Нара'
                    },
                    twelveToFourteenDays: {
                        title: '12–14 дней: Токио + Хаконэ + Киото + Нара + Осака + Хиросима + Миядзима',
                        description: 'Полноценное путешествие с трогательной историей Хиросимы и священным островом Миядзима.',
                        alt: 'Хиросима и Миядзима'
                    }
                }
            },
            cta: {
                eyebrow: 'Индивидуальные путешествия по Японии',
                title: 'Позвольте Sonic Tours спланировать ваше путешествие по Японии',
                text: 'Выберите классический маршрут для первого визита или индивидуальную программу под ваш темп, интересы и сезон.',
                button: 'Спланировать поездку в Японию',
                imageAlt: 'Путешествие по Японии',
            },
        },
        // Russian (ru)
        contactus: {
            heroTitle: 'Свяжитесь с нами',
            heroSubtitle: 'Sonic Tours Japan – Ваш путь к незабываемым путешествиям по Японии',

            feelFree: 'Не стесняйтесь обращаться к нам',
            planDream: 'Спланируйте свое идеальное путешествие в Японию',
            reachOutDesc: 'Свяжитесь с Sonic Tours Japan для разработки индивидуальных маршрутов, профессиональных консультаций и незабываемых впечатлений по всей Японии.',

            callCenter: 'Контактный центр',
            phone: '+81 90-8251-4053',
            emailTitle: 'Электронная почта',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: 'Наш адрес',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: 'Следите за нами',

            getInTouch: 'Давайте свяжемся',
            getInTouchDesc: 'Начните своё японское приключение вместе с Sonic Tours Japan — мы всегда готовы помочь вам создать незабываемые воспоминания.',

            nameLabel: 'Имя',
            namePlaceholder: 'Ваше полное имя',
            emailLabel: 'Электронная почта',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: 'Номер телефона',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'Сообщение',
            messagePlaceholder: 'Расскажите нам о вашей идеальной поездке в Японию...',

            sendButton: 'Отправить сообщение',
            sendingButton: 'Отправляем...',
            successMsg: 'Ваше сообщение отправлено через WhatsApp!',
            errorMsg: 'Не удалось открыть WhatsApp. Пожалуйста, попробуйте ещё раз.',

            findUsTitle: 'Найдите нас в Японии',
        },
        japan: {
            heroTitle: 'CEO и президент офиса в Японии',
            heroSubtitle: 'Ваш надежный партнер для приключений на Шри-Ланке из Японии',

            contactPerson: 'Tomoya Izawa',
            position: 'Представитель в Японии',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'Свяжитесь с нами в социальных сетях',

            formTitle: 'Отправьте нам сообщение',
            formHeading: 'Начните свое приключение на Шри-Ланке',
            formDescription: 'Свяжитесь с Tomoya Izawa для персонализированных туристических пакетов, экспертных советов по путешествиям и незабываемых впечатлений от Шри-Ланки.',

            nameLabel: 'Ваше имя *',
            namePlaceholder: 'Введите ваше полное имя',
            emailLabel: 'Адрес электронной почты *',
            emailPlaceholder: 'ваш.email@example.com',
            phoneLabel: 'Номер телефона',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'Ваше сообщение *',
            messagePlaceholder: 'Расскажите нам о вашем идеальном приключении на Шри-Ланке...',

            sendButton: 'Отправить сообщение по электронной почте',
            sendingButton: 'Открытие почтового клиента...',
            successMsg: 'Ваш почтовый клиент был открыт с сообщением!',
            errorMsg: 'Не удалось открыть почтовый клиент. Попробуйте снова.',

            whyChooseTitle: 'Почему выбирают Sonic Tours?',

            expertiseTitle: 'Местная экспертиза',
            expertiseDesc: 'Аутентичные впечатления от Шри-Ланки, подобранные местными экспертами, знающими каждую скрытую жемчужину',

            supportTitle: 'Поддержка на японском',
            supportDesc: 'Специальный представитель, говорящий по-японски, для беспрепятственного общения',

            personalizedTitle: 'Персонализированные туры',
            personalizedDesc: 'Индивидуальные маршруты, разработанные в соответствии с вашими интересами и стилем путешествия',

            mapTitle: 'Найдите нас в Шри-Ланке',
        },
        // Russian (ru)
        thingstodo: {
            heroTitle: "Что делать в Японии",
            heroSubtitle: "Откройте для себя незабываемые впечатления и создайте воспоминания на всю жизнь в Стране восходящего солнца.",

            sectionTitle: "Незабываемые впечатления в Японии",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "Любование цветением сакуры",
                description: "Самое iconic и захватывающее сезонное событие Японии.",
                para1: "Любование цветением сакуры, известное как «ханами», — одна из самых любимых традиций Японии. Каждую весну миллионы людей собираются под розовыми деревьями сакуры, чтобы отпраздновать мимолётную красоту жизни.",
                para2: "Популярные места: парк Уэно и Синдзюку Гёэн в Токио, Философская тропа в Киото и парк у замка в Осаке. Многие устраивают пикники (ханами-бенто) с семьёй и друзьями под цветущими деревьями.",
                para3: "Пик сезона обычно приходится на конец марта — начало апреля. Вечерняя подсветка создаёт волшебную атмосферу во многих местах."
            },

            ancientTemples: {
                title: "Древние храмы и святилища",
                description: "Откройте духовное наследие Японии через древние храмы и святилища.",
                para1: "В Японии тысячи исторических храмов и святилищ, многие из которых входят в список Всемирного наследия ЮНЕСКО.",
                para2: "Иконические места: Фусими Инари Тайся с тысячами красных тории, Кинкаку-дзи (Золотой павильон) и грандиозный храм Тодай-дзи в Наре.",
                para3: "Посетители могут участвовать в ритуалах, получать предсказания или просто наслаждаться спокойными садами и сезонной красотой этих священных мест."
            },

            mountFuji: {
                title: "Гора Фудзи и Пять озёр Фудзи",
                description: "Увидеть величественный и священный символ Японии.",
                para1: "Высотой 3776 метров, гора Фудзи — самая высокая вершина Японии и культурный символ страны.",
                para2: "Лучшие виды открываются из района Пяти озёр Фудзи (особенно с озера Кавагути). Вы можете подняться на вершину в официальный сезон или наслаждаться видами круглый год.",
                para3: "В окрестностях расположены очаровательные городки, онсэны и отличные места для фотографии."
            },

            onsenRelax: {
                title: "Традиционные онсэны (горячие источники)",
                description: "Восстановите тело и душу в традиционных японских горячих источниках.",
                para1: "Культура онсэнов глубоко укоренена в Японии. Природные горячие источники считаются целебными.",
                para2: "Популярные направления: Хаконэ, Бэппу и Кусацу. Многие рёканы предлагают открытые роtenburo с потрясающими видами.",
                para3: "Соблюдение правил этикета онсэнов улучшает опыт и демонстрирует уважение к японским традициям купания."
            },

            japaneseCuisine: {
                title: "Настоящая японская кухня",
                description: "Насладитесь всемирно известной японской кухней и уличной едой.",
                para1: "От свежего суши и сашими до сытных рамен, темпуры и многоступенчатых кайсэки — японская кухня признана нематериальным культурным наследием ЮНЕСКО.",
                para2: "Токио, Осака и Киото — настоящие гастрономические раи. Попробуйте уличную еду в Дотонбори или на рынке Нишики.",
                para3: "Гастрономические туры и кулинарные мастер-классы — отличный способ глубже понять японские кулинарные традиции."
            },

            shinkansen: {
                title: "Поездка на Синкансэн (Скоростной поезд)",
                description: "Испытайте всемирно известный японский скоростной поезд.",
                para1: "Синкансэн — символ технологического превосходства и пунктуальности Японии.",
                para2: "Комфортно путешествуйте между крупными городами (Токио, Киото, Осака, Хиросима) со скоростью более 300 км/ч.",
                para3: "Сама поездка — часть впечатлений: чисто, тихо и невероятно эффективно."
            },

            matsuriFestivals: {
                title: "Традиционные фестивали Мацури",
                description: "Погрузитесь в яркие традиционные фестивали.",
                para1: "Мацури — это живые народные праздники с парадами, музыкой, уличной едой и традиционными танцами.",
                para2: "Известные события: Гион Мацури в Киото, Небута Мацури в Аомори и Тэндзин Мацури в Осаке.",
                para3: "Посещение мацури — прекрасная возможность познакомиться с местной культурой и японским духом."
            },

            themeParks: {
                title: "Тематики парки и развлечения",
                description: "Наслаждайтесь мирового класса тематическими парками.",
                para1: "Tokyo Disneyland и DisneySea входят в число самых популярных парков мира.",
                para2: "Universal Studios Japan в Осаке предлагает захватывающие аттракционы по Гарри Поттеру, Super Nintendo World и многому другому.",
                para3: "Эти парки дарят радость всем возрастам и особенно волшебны во время сезонных мероприятий."
            },

            shoppingJapan: {
                title: "Шопинг в Токио, Осаке и Киото",
                description: "Шопинг в оживлённых городах Японии.",
                para1: "От люксовых брендов в Гиндзе и Омотэсандо до электроники в Акихабаре и моды в Синсайбаси.",
                para2: "Не пропустите универмаги, магазины 100 иен и рынки традиционных ремёсел.",
                para3: "Беспошлинный шопинг и уникальные сувениры делают покупки в Японии настоящим удовольствием."
            },

            fourSeasons: {
                title: "Четыре прекрасных сезона Японии",
                description: "Пережить волшебство четырёх ярко выраженных сезонов Японии.",
                para1: "Япония известна своими драматическими сезонными изменениями — весенними цветами сакуры, летними фестивалями, красочными осенними листьями и заснеженными зимними пейзажами.",
                para2: "Каждый сезон предлагает уникальные фестивали, кухню и пейзажи по всей стране.",
                para3: "Когда бы вы ни приехали, природная красота и культурные праздники Японии оставят неизгладимое впечатление."
            },

            viewMore: "Подробнее",
            close: "Закрыть",

            ctaTitle: "Готовы к своему японскому приключению?",
            ctaDescription: "Позвольте Sonic Tours Japan создать для вас идеальный маршрут с профессиональным гидом и персонализированным сервисом.",
            ctaButton: "Спланировать поездку сейчас"
        },
        // Russian (ru)
        gallery: {
            heroTitle: "Откройте для себя Японию",
            heroSubtitle: "Исследуйте захватывающую красоту, культуру и легендарные достопримечательности Японии с помощью нашей тщательно подобранной галереи.",

            // 20 Selected Places
            shibuya: "Shibuya Crossing",
            asakusa: "Храм Сэнсо-дзи",
            skytree: "Tokyo Skytree",
            mtfuji: "Гора Фудзи",
            lakeKawaguchi: "Озеро Кавагути",
            hakoneRopeway: "Канатная дорога Хаконэ",
            fushimiInari: "Фусими Инари Тайся",
            arashiyama: "Бамбуковый лес Арасияма",
            kinkakuji: "Кинкаку-дзи (Золотой павильон)",
            osakaCastle: "Замок Осака",
            dotonbori: "Дотонбори",
            naraPark: "Парк Нара",
            todaiji: "Храм Тодай-дзи",
            hiroshimaPeace: "Мирный мемориал Хиросимы",
            miyajima: "Святилище Ицукусима",
            nikko: "Святилище Тосёгу",
            shirakawago: "Ширакава-го",
            himeji: "Замок Химэдзи",
            universal: "Universal Studios Japan",
            teamlab: "TeamLab Planets",

            lightboxClose: "Закрыть",
            lightboxNext: "Далее",
            lightboxPrevious: "Назад",
            tabPlaces: "Места",
            tabEvents: "События"
        },
        // Russian (ru)
        events: {
            heroTitle: "Фестивали Японии",
            heroSubtitle: "Погрузитесь в яркие краски, глубокие традиции и незабываемую атмосферу всемирно известных фестивалей и праздников Японии.",

            // 20 Selected Festivals
            sakuraMatsuri: "Фестивали цветения сакуры (Sakura Matsuri)",
            hinaMatsuri: "Хина Мацури (Праздник кукол)",
            takayamaSpring: "Весенний фестиваль Такаяма",
            kandaMatsuri: "Канда Мацури",
            aoiMatsuri: "Аои Мацури",
            fujiShibazakura: "Фестиваль фудзи-шибадзакура",
            gionMatsuri: "Гион Мацури",
            tenjinMatsuri: "Тэндзин Мацури",
            nebutaMatsuri: "Нэбута Мацури",
            sendaiTanabata: "Фестиваль Танабата в Сэндае",
            awaOdori: "Фестиваль Ава Одори",
            sumidaFireworks: "Фестиваль фейерверков на реке Сумида",
            nagaokaFireworks: "Фестиваль фейерверков в Нагаоке",
            kishiwadaDanjiri: "Фестиваль Дандзири в Кисиваде",
            jidaiMatsuri: "Дзидай Мацури",
            takayamaAutumn: "Осенний фестиваль Такаяма",
            sapporoSnow: "Снежный фестиваль в Саппоро",
            otaruSnow: "Фестиваль снежных огней в Отару",
            nozawaOnsenFire: "Огненный фестиваль Нодзава Онсэн",
            obonFestival: "Обон (Праздник поминовения предков)",

            tabPlaces: "Места",
            tabEvents: "События"
        },

        // Russian (ru)
        home: {
            sections: {
                recommendations: {
                    title: "ПОПУЛЯРНЫЕ НАПРАВЛЕНИЯ",
                    subtitle: "Откройте для себя самые иконические города Японии, культурные сокровища и захватывающие дух пейзажи."
                },
                excursions: {
                    title: "ТУРЫ ПО ЯПОНИИ",
                    desc: "Выберите из тщательно разработанных маршрутов по Японии для первого визита, семей, пар и любителей культуры."
                },
                packages: {
                    title: "ПОПУЛЯРНЫЕ ТУРПАКЕТЫ ПО ЯПОНИИ"
                }
            },

            recommendations: {
                tokyo: {
                    label: "Токио",
                    name: "Shibuya Crossing, Асакуса, Tokyo Skytree, шопинг и аниме"
                },
                mountFuji: {
                    label: "Гора Фудзи",
                    name: "Озеро Кавагути, 5-я станция Фудзи и живописные виды"
                },
                kyoto: {
                    label: "Киото",
                    name: "Храмы, святилища, Бамбуковый лес и район гейш"
                },
                osaka: {
                    label: "Осака",
                    name: "Дотонбори, Замок Осака и Universal Studios Japan"
                },
                nara: {
                    label: "Нара",
                    name: "Исторические храмы и парк с дружелюбными оленями"
                },
                hakone: {
                    label: "Хаконэ",
                    name: "Горячие источники, канатная дорога и виды на гору Фудзи"
                },
                nikko: {
                    label: "Никко",
                    name: "Святилища ЮНЕСКО и природная красота"
                },
                shirakawago: {
                    label: "Ширакава-го",
                    name: "Традиционная японская деревня"
                },
                arashiyama: {
                    label: "Арасияма",
                    name: "Знаменитый Бамбуковый лес и живописная река"
                },
                himeji: {
                    label: "Химэдзи",
                    name: "Самый красивый замок Японии"
                }
            },

            excursions: {
                oneDay: {
                    title: "Обзорная экскурсия по Токио",
                    des: "Посетите Shibuya Crossing, храм Асакуса, Tokyo Skytree и торговый район Гиндза."
                },
                twoDays: {
                    title: "Токио и гора Фудзи",
                    des: "Познакомьтесь с главными достопримечательностями Токио, а затем насладитесь потрясающими видами на гору Фудзи и озеро Кавагути."
                },
                threeDays: {
                    title: "Токио • Фудзи • Хаконэ",
                    des: "Совместите современный Токио с горячими источниками Хаконэ, канатной дорогой и видами на гору Фудзи."
                },
                fourDays: {
                    title: "Токио • Киото",
                    des: "Исследуйте современную столицу Японии и древнее культурное сердце Киото."
                },
                fiveDays: {
                    title: "Золотой маршрут Японии",
                    des: "Путешествие через Токио, гору Фудзи, Киото и Осаку."
                },
                sixDays: {
                    title: "Классическое открытие Японии",
                    des: "Посетите Токио, Хаконэ, Киото, Нару и Осаку в одном незабываемом путешествии."
                }
            },

            packages: {
                one: {
                    title: "Токио и гора Фудзи",
                    duration: "5 дней",
                    desc: "Идеальное первое знакомство с Японией: главные достопримечательности Токио и гора Фудзи."
                },
                two: {
                    title: "Классическая Япония",
                    duration: "7 дней",
                    desc: "Токио, гора Фудзи, Киото и Осака."
                },
                three: {
                    title: "Золотой маршрут",
                    duration: "10 дней",
                    desc: "Токио, Хаконэ, Киото, Нара и Осака."
                },
                four: {
                    title: "Исследователь Японии",
                    duration: "12 дней",
                    desc: "Токио, Хаконэ, Киото, Нара, Осака и Хиросима."
                },
                five: {
                    title: "Яркая Япония",
                    duration: "14 дней",
                    desc: "Откройте знаменитые города Японии, культурные достопримечательности и живописную природу."
                },
                six: {
                    title: "Большое путешествие по Японии",
                    duration: "14 дней",
                    desc: "Максимальное путешествие по Японии, включая остров Миядзима и Хиросиму."
                }
            },

            featured: {
                elephantRide: {
                    h2: "ИКОНИЧЕСКАЯ ДОСТОПРИМЕЧАТЕЛЬНОСТЬ",
                    h3: "ГОРА ФУДЗИ",
                    paragraph: "Познайте самую известную гору Японии с панорамными видами, озером Кавагути и 5-й станцией Фудзи.",
                    button: "Исследовать"
                },
                perahera: {
                    h2: "КУЛЬТУРНОЕ НАСЛЕДИЕ",
                    h3: "ХРАМЫ КИОТО",
                    h4: "Древняя Япония",
                    paragraph: "Откройте для себя вневременные храмы, святилища, бамбуковые леса Киото и знаменитый район гейш.",
                    button: "Узнать больше"
                },
                safari: {
                    h2: "СЕМЕЙНОЕ ПРИКЛЮЧЕНИЕ",
                    h3: "TOKYO DISNEY RESORT",
                    paragraph: "Проведите незабываемые семейные моменты в Tokyo Disneyland и Tokyo DisneySea с мировыми аттракционами.",
                    button: "Подробнее"
                }
            },

            famousTours: {
                title: "НАШИ САМЫЕ ПОПУЛЯРНЫЕ ТУРЫ ПО ЯПОНИИ",
                subtitle: "Откройте Японию с тщательно продуманными маршрутами, охватывающими самые иконические места страны.",
                bookNow: "Забронировать",

                tours: {
                    benthotaRiverSafari: {
                        title: "5 дней",
                        description: "Токио + гора Фудзи"
                    },

                    polgampalaWaterPool: {
                        title: "7 дней",
                        description: "Токио + гора Фудзи + Киото + Осака"
                    },

                    galleTour: {
                        title: "10 дней",
                        description: "Токио + Хаконэ + Киото + Нара + Осака"
                    },

                    sigiriyaTour: {
                        title: "12–14 дней",
                        description: "Токио + Хаконэ + Киото + Нара + Осака + Хиросима + Миядзима"
                    }
                }
            },

            gallery: {
                title: "НАША ГАЛЕРЕЯ ЯПОНИИ",
                subtitle: "Погрузитесь в незабываемые моменты, запечатленные в иконических городах, культурных достопримечательностях и живописных пейзажах Японии."
            },
            cta: {
                title: "НАЧНИТЕ СВОЁ ПУТЕШЕСТВИЕ ПО ЯПОНИИ СЕГОДНЯ",
                desc: "Позвольте Sonic Tours создать для вас идеальное путешествие по Японии с тщательно продуманными маршрутами, незабываемыми впечатлениями и исключительным сервисом от начала и до конца.",
                button: "Запланировать поездку",
                alt: "Тур по Японии"
            }
        },
        // Russian (ru)
        hero: {
            title: {
                line1: "Откройте Японию вместе с",
                line2: "Sonic Tours",
                line3: "Япония"
            },
            subtitle: "Старинные храмы, яркие города, спокойные сады и незабываемые приключения —",
            subtitle2: "созданные специально для вашего путешествия.",

            cta: "Начните своё путешествие",
            trust: "Любим путешественниками из более чем 50 стран • Доверие мировых экспертов в туризме"
        },
        // Russian (ru)
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "Главная",
                about: "О нас",
                explore: "Туризм в Японии",
                tours: "Туры",
                gallery: "Галерея",
                events: "События",
                things: "Что посмотреть",
                contact: "Контакты"
            },

            contact: {
                title: "Свяжитесь с нами",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "Оставайтесь на связи",
                desc: "Подпишитесь, чтобы получать эксклюзивные советы по путешествиям в Японию, сезонные предложения и ранний доступ к новым турам.",
                placeholder: "Введите ваш email",
                subscribe: "Подписаться"
            },

            tagline: "Откройте душу Японии вместе с <span class='text-[#f7d774]'>Sonic Tours Japan</span> — вашим надежным партнером для аутентичных и незабываемых путешествий.",

            copyright: "Все права защищены.",
            developedBy: "Разработано"
        },

    },
    pl: {
        translation: {
            home: 'Strona główna',
            aboutUs: 'O nas',
            sriLankanav: 'Japonia',
            gallerynav: 'Galeria',
            bookATour: 'Wycieczki',
            thingsToDo: 'Atrakcje',
            contactUs: 'Kontakt',
            contactJapan: 'Kontakt Japonia',
            japanHeroEyebrow: 'Odkryj Japonię',
            japanHeroTitle: 'Doświadcz elegancji Japonii z Sonic Tours',
            japanHeroSubtitle: 'Od starożytnych świątyń i spokojnych ogrodów po tętniące życiem miasta i niezapomniane przygody — Japonia oferuje podróż jak żadna inna.',
            japanHeroImageAlt: 'Krajobraz Japonii',
            japanAboutEyebrow: 'O Japonii',
            japanSectionTitle: 'Kraj bez czasu dla ciekawych podróżników',
            japanSectionDescription: 'Japonia łączy bogate dziedzictwo kulturowe, świetną kuchnię, piękno natury i nowoczesną innowacyjność w jednym wyjątkowym doświadczeniu podróżniczym. Niezależnie od tego, czy szukasz cichych świątyń, jasnych świateł miast czy pięknych krajobrazów, Sonic Tours pomoże Ci odkryć wszystko z komfortem i troską.',
            japanSectionImageAlt: 'Scena podróży po Japonii',
        },
        about: {
            hero: {
                discover: 'Klasyczna Japonia',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: 'Odkryj ponadczasowe piękno Japonii z ekspertami-przewodnikami',
                tagline2: 'Od tętniących życiem miast po święte góry i starożytne świątynie — pozwól nam stworzyć Twoje idealne japońskie przygody.',
            },

            about: {
                title: 'O Sonic Tours Japan',
            },

            tours: {
                classic: 'Klasyczna Japonia (Dla pierwszych odwiedzających)',
                days4: '5–7 Dni',
                desc1: 'Tokio – Shibuya Crossing, Asakusa, Tokyo Skytree, zakupy, anime i życie nocne. Góra Fuji – malownicze widoki, Jezioro Kawaguchi i 5. Stacja Fuji.',

                safari: 'Atrakcje Kulturalne',
                days5: 'Kioto • Nara • Osaka',
                desc2: 'Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Zamek Himeji oraz spokojny urok Parku Nara.',

                retreat: 'Natura i Malownicze Miejsca',
                days6: 'Hakone • Arashiyama • Nikko',
                desc3: 'Gorące źródła Hakone i widoki na Mt. Fuji, Las Bambusowy Arashiyama, Nikko i historyczna wioska Shirakawa-go.',
            },

            owner: {
                title: 'Poznaj Nasze Kierownictwo',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: 'Z głęboką pasją do japońskiej kultury i wieloletnim doświadczeniem w luksusowej turystyce, Tomoya Izawa prowadzi Sonic Tours Japan z wizją i oddaniem. Jego zaangażowanie w autentyczne doświadczenia i wyjątkową obsługę gwarantuje, że każdy gość otrzyma światowej klasy gościnność i niezapomniane podróże po Japonii.',
                imageAlt: 'Tomoya Izawa - CEO & President Sonic Tours Japan',
            },

            whoWeAre: {
                title: 'Twój Ekspert Podróży po Japonii',
                description: 'Pod kierownictwem <strong>Buddiki</strong>, Sonic Tours Japan specjalizuje się w tworzeniu spersonalizowanych, wysokiej jakości doświadczeń podróżniczych po całej Japonii. Dzięki głębokiej znajomości lokalnego terenu i pasji do japońskiej kultury zapewniamy, że każda podróż będzie płynna, wzbogacająca i naprawdę niezapomniana.',
                item1: { title: 'Doświadczeni Lokalni Przewodnicy', text: 'Licencjonowani i doświadczeni' },
                item2: { title: 'Spersonalizowane Itineraria', text: 'Dostosowane do Twojego tempa' },
                item3: { title: 'Bezproblemowe Doświadczenie', text: 'Podróż bez stresu' },
                item4: { title: 'Wsparcie 24/7', text: 'Zawsze do Twojej dyspozycji' },
                imageAlt: 'Buddika - Ekspert Turystyki po Japonii',
            },

            offers: {
                title: 'Co Oferujemy',
                cultural: {
                    title: 'Zanurzenie w Kulturze',
                    text: 'Świątynie, kapliczki, tradycyjne sztuki i lokalne zwyczaje',
                    alt: 'Japońskie doświadczenia kulturowe'
                },
                adventure: {
                    title: 'Natura i Przygoda',
                    text: 'Góra Fuji, Hakone, wędrówki i malownicze trasy',
                    alt: 'Przygody na łonie natury w Japonii'
                },
                luxury: {
                    title: 'Podróże Luksusowe',
                    text: 'Hotele premium, prywatne transfery i ekskluzywne doświadczenia',
                    alt: 'Luksusowe podróże po Japonii'
                },
                wellness: {
                    title: 'Wellness i Relaks',
                    text: 'Gorące źródła onsen, mindfulness i regenerujące retreaty',
                    alt: 'Japońskie retreaty wellness'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'Główny Przewodnik',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: 'Z wieloletnim doświadczeniem w oprowadzaniu podróżników po Japonii, Buddika z pasją dzieli się autentycznym pięknem, kulturą i ukrytymi skarbami tego niesamowitego kraju. Jego ciepła osobowość i głęboka wiedza sprawiają, że każda wycieczka jest wyjątkowa.',
            },

            villageTours: {
                title: 'Autentyczne Doświadczenia Japonii',
                description: 'Poza wielkimi miastami odkryj tradycyjne wioski, lokalne rzemiosło, sezonowe festiwale i ciepłą gościnność, która definiuje prawdziwą Japonię.',
                imageAlt: 'Tradycyjne japońskie doświadczenie wiejskie',
                bookButton: 'Odkryj Autentyczną Japonię',
            },

            vehicles: {
                title: 'Nasza Flota',
                text: 'Wygodne, nowoczesne i dobrze utrzymane pojazdy na relaksującą podróż po Japonii.',
                bookButton: 'Zarezerwuj swoją wycieczkę',
                car: { title: 'Prywatny Samochód', text: 'Idealny dla par i małych grup' },
                van: { title: 'Wygodny Van', text: 'Przestronny i komfortowy' },
                minibus: { title: 'Minibus', text: 'Idealny dla rodzin i średnich grup' },
                luxury: { title: 'Luksusowy Autokar', text: 'Premium doświadczenie dla większych grup' },
            },

            notices: {
                title: 'Podróżuj z pewnością',
                intro: 'W Sonic Tours Japan Twój komfort, bezpieczeństwo i satysfakcja są naszymi najważniejszymi priorytetami.',
                fruits: { title: 'Darmowe Przekąski', text: 'Sezonowe owoce i lekkie przekąski' },
                meals: { title: 'Starannie Wybrane Posiłki', text: 'Doświadczenia z autentyczną kuchnią japońską' },
                massage: { title: 'Usługi Relaksacyjne', text: 'Opcjonalne onsen i dodatki wellness' },
                flowers: { title: 'Ciepłe Powitanie', text: 'Tradycyjna japońska gościnność' },
            },

            slider: {
                sigiriya: 'Góra Fuji',
                yala: 'Świątynie Kioto',
                tea: 'Bambusowy Las Arashiyama',
                beaches: 'Jezioro Hakone',
                temples: 'Park Jeleni w Narze',
            },
        },
        tourPackages: {
            hero: {
                discover: 'Klasyczna Japonia',
                starLankaTours: 'Dla pierwszych odwiedzających',
                highlight: 'Ponadczasowa podróż przez Tokio, Fudżi, Kioto i Osakę',
                tagline1: 'Od ikonicznych świateł miasta po spokojne świątynie — Japonia oferuje niezwykłe pierwsze doświadczenie dla każdego podróżnika.',
                tagline2: 'Pozwól Sonic Tours zmienić Twoje wymarzone wakacje w płynną i niezapomnianą podróż po Japonii.',
            },
            overview: {
                eyebrow: 'Najważniejsze atrakcje Japonii',
                title: 'Najważniejsze miejsca Japonii dla pierwszych odwiedzających',
                description: 'Te destynacje należą do najpopularniejszych wśród międzynarodowych podróżników i stanowią doskonałą podstawę atrakcyjnych pakietów wycieczkowych po Japonii.',
            },
            cards: {
                classicTitle: 'Klasyczna Japonia (dla pierwszych odwiedzających)',
                classicMeta: 'Tokio • Góra Fudżi',
                classicText: 'Tokio zachwyca Shibuya Crossing, Asakusą, Tokyo Skytree, shoppingiem, anime i życiem nocnym. Góra Fudżi oferuje malownicze widoki, jezioro Kawaguchiko i 5. stację.',
                classicAlt: 'Panorama Tokio i Góra Fudżi',
                culturalTitle: 'Atrakcje kulturalne',
                culturalMeta: 'Kioto • Nara • Osaka',
                culturalText: 'Odkryj Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Zamek Himeji oraz spokojny urok Parku Nara.',
                culturalAlt: 'Japońskie świątynie i zabytki',
                natureTitle: 'Przyroda i malownicze miejsca',
                natureMeta: 'Hakone • Arashiyama • Nikko',
                natureText: 'Ciesz się gorącymi źródłami w Hakone z widokami na Fudżi, bambusowym lasem Arashiyama, Nikko i Shirakawa-go.',
                natureAlt: 'Malownicze japońskie krajobrazy',
            },
            highlights: {
                eyebrow: 'Popularne doświadczenia',
                title: 'Zaplanuj idealną podróż do Japonii zgodnie ze swoimi zainteresowaniami',
                text: 'Niezależnie od tego, czy kochasz sezonowe piękno, rodzinne atrakcje czy odkrywanie kultury — Sonic Tours stworzy trasę, która będzie łatwa i inspirująca.',
                seasonalTitle: 'Atrakcje sezonowe',
                seasonalText: 'Wiosna jest idealna na kwitnące wiśnie, lato na wspinaczkę na Fudżi i festiwale, jesień na kolorowe liście w Kioto i Nikko, zima na narty w Niseko lub Festiwal Śniegu w Sapporo.',
                familyTitle: 'Atrakcje rodzinne',
                familyText: 'Tokyo Disneyland, Tokyo DisneySea, Universal Studios Japan oraz Osaka Aquarium Kaiyukan to doskonały wybór dla rodzin.',
            },
            recommended: {
                eyebrow: 'Polecane pakiety wycieczkowe',
                title: 'Polecane pakiety wycieczkowe',
                subtitle: 'Wybierz idealny czas trwania dla swojej pierwszej przygody w Japonii',
                packages: {
                    fiveDays: {
                        title: '5 dni: Tokio + Góra Fudżi',
                        description: 'Idealne wprowadzenie do Japonii — tętniące życiem Tokio i ikoniczna Góra Fudżi.',
                        alt: 'Tokio i Góra Fudżi'
                    },
                    sevenDays: {
                        title: '7 dni: Tokio + Góra Fudżi + Kioto + Osaka',
                        description: 'Klasyczna trasa obejmująca najważniejsze miasta i kulturalne serce Japonii.',
                        alt: 'Kioto i Osaka'
                    },
                    tenDays: {
                        title: '10 dni: Tokio + Hakone + Kioto + Nara + Osaka',
                        description: 'Głębsze poznanie z malowniczym Hakone i historyczną Narą.',
                        alt: 'Hakone i Nara'
                    },
                    twelveToFourteenDays: {
                        title: '12–14 dni: Tokio + Hakone + Kioto + Nara + Osaka + Hiroszima + Miyajima',
                        description: 'Kompleksowa podróż obejmująca poruszającą historię Hiroszimy i świętą wyspę Miyajima.',
                        alt: 'Hiroszima i Miyajima'
                    }
                }
            },
            cta: {
                eyebrow: 'Wycieczki szyte na miarę',
                title: 'Pozwól Sonic Tours zaprojektować Twoją podróż do Japonii',
                text: 'Wybierz klasyczną trasę dla pierwszego razu lub spersonalizowany plan dostosowany do Twojego tempa, zainteresowań i pory roku.',
                button: 'Zaplanuj moją podróż do Japonii',
                imageAlt: 'Doświadczenie podróży po Japonii',
            },
        },

        // Polish (pl)
        contactus: {
            heroTitle: 'Skontaktuj się z nami',
            heroSubtitle: 'Sonic Tours Japan – Twoja brama do niezapomnianych podróży po Japonii',

            feelFree: 'Śmiało się z nami skontaktuj',
            planDream: 'Zaplanuj swoje idealne wakacje w Japonii',
            reachOutDesc: 'Skontaktuj się z Sonic Tours Japan, aby stworzyć spersonalizowane itineraria, otrzymać ekspercką poradę i przeżyć niezapomniane przygody w całej Japonii.',

            callCenter: 'Biuro Obsługi Klienta',
            phone: '+81 90-8251-4053',
            emailTitle: 'E-mail',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: 'Nasza lokalizacja',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: 'Śledź nas',

            getInTouch: 'Połączmy się',
            getInTouchDesc: 'Rozpocznij swoją japońską przygodę z Sonic Tours Japan – jesteśmy do dyspozycji, aby pomóc Ci stworzyć niezapomniane wspomnienia.',

            nameLabel: 'Imię i nazwisko',
            namePlaceholder: 'Twoje pełne imię i nazwisko',
            emailLabel: 'E-mail',
            emailPlaceholder: 'twoj.email@przyklad.pl',
            phoneLabel: 'Numer telefonu',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'Wiadomość',
            messagePlaceholder: 'Opowiedz nam o swojej wymarzonej podróży do Japonii...',

            sendButton: 'Wyślij wiadomość',
            sendingButton: 'Wysyłanie...',
            successMsg: 'Twoja wiadomość została wysłana przez WhatsApp!',
            errorMsg: 'Nie udało się otworzyć WhatsApp. Spróbuj ponownie.',

            findUsTitle: 'Znajdź nas w Japonii',
        },

        japan: {
            heroTitle: 'CEO i prezes biura w Japonii',
            heroSubtitle: 'Twój zaufany partner w przygodach na Sri Lance z Japonii',

            contactPerson: 'Tomoya Izawa',
            position: 'Przedstawiciel w Japonii',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'Połącz się z nami w mediach społecznościowych',

            formTitle: 'Wyślij nam wiadomość',
            formHeading: 'Rozpocznij swoją przygodę na Sri Lance',
            formDescription: 'Skontaktuj się z Tomoya Izawa, aby uzyskać spersonalizowane pakiety wycieczek, fachowe porady dotyczące podróży i niezapomniane wrażenia ze Sri Lanki.',

            nameLabel: 'Twoje imię *',
            namePlaceholder: 'Wprowadź swoje pełne imię',
            emailLabel: 'Adres e-mail *',
            emailPlaceholder: 'twoj.email@example.com',
            phoneLabel: 'Numer telefonu',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'Twoja wiadomość *',
            messagePlaceholder: 'Opowiedz nam o swojej wymarzonej przygodzie na Sri Lance...',

            sendButton: 'Wyślij wiadomość e-mail',
            sendingButton: 'Otwieranie klienta poczty...',
            successMsg: 'Twój klient poczty został otwarty z wiadomością!',
            errorMsg: 'Nie można otworzyć klienta poczty. Spróbuj ponownie.',

            whyChooseTitle: 'Dlaczego wybrać Sonic Tours?',

            expertiseTitle: 'Lokalna wiedza',
            expertiseDesc: 'Autentyczne doświadczenia Sri Lanki wyselekcjonowane przez lokalnych ekspertów znających każdy ukryty skarb',

            supportTitle: 'Wsparcie w języku japońskim',
            supportDesc: 'Dedykowany przedstawiciel mówiący po japońsku zapewniający płynną komunikację',

            personalizedTitle: 'Spersonalizowane wycieczki',
            personalizedDesc: 'Niestandardowe trasy zaprojektowane zgodnie z Twoimi zainteresowaniami i stylem podróży',

            mapTitle: 'Znajdź nas na Sri Lance',
        },
        // Polish (pl)
        thingstodo: {
            heroTitle: "Co robić w Japonii",
            heroSubtitle: "Odkryj niezapomniane doświadczenia i stwórz wspomnienia na całe życie w Krainie Wschodzącego Słońca.",

            sectionTitle: "Niezapomniane Doświadczenia w Japonii",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "Kontemplacja Kwitnącej Wiśni",
                description: "Najbardziej ikoniczne i zapierające dech w piersiach sezonowe doświadczenie Japonii.",
                para1: "Kontemplacja kwitnącej wiśni, znana jako „hanami”, jest jedną z najbardziej ukochanych tradycji Japonii. Każdej wiosny miliony ludzi gromadzą się pod różowymi drzewami sakury, by celebrować ulotne piękno życia.",
                para2: "Popularne miejsca to Park Ueno i Shinjuku Gyoen w Tokio, Ścieżka Filozofa w Kioto oraz Park Zamkowy w Osace. Wiele osób urządza pikniki (hanami bento) z rodziną i przyjaciółmi pod kwitnącymi drzewami.",
                para3: "Szczyt sezonu przypada zwykle na koniec marca do początku kwietnia. Wieczorne iluminacje tworzą magiczną atmosferę w wielu miejscach."
            },

            ancientTemples: {
                title: "Starodawne Świątynie i Sanktuaria",
                description: "Odkryj duchowe dziedzictwo Japonii poprzez starożytne świątynie i sanktuaria.",
                para1: "W Japonii znajduje się tysiące historycznych świątyń i sanktuariów, z których wiele jest wpisanych na Listę Światowego Dziedzictwa UNESCO.",
                para2: "Ikoniczne miejsca to Fushimi Inari Taisha z tysiącami czerwonych bram torii, Kinkaku-ji (Złoty Pawilon) oraz ogromna świątynia Todai-ji w Narze.",
                para3: "Odwiedzający mogą brać udział w rytuałach, losować wróżby lub po prostu cieszyć się spokojnymi ogrodami i sezonowym pięknem tych świętych miejsc."
            },

            mountFuji: {
                title: "Góra Fuji i Pięć Jezior Fuji",
                description: "Obejrzyj majestatyczny i święty symbol Japonii.",
                para1: "Wysoka na 3776 metrów góra Fuji jest najwyższym szczytem Japonii i ważnym symbolem kulturowym.",
                para2: "Najlepsze widoki oferuje region Pięciu Jezior Fuji (szczególnie Jezioro Kawaguchi). Możesz wejść na szczyt w oficjalnym sezonie lub podziwiać widoki przez cały rok.",
                para3: "Okolica oferuje urocze miasteczka, ośrodki onsen i doskonałe możliwości fotograficzne."
            },

            onsenRelax: {
                title: "Tradycyjne Onsen (Gorące Źródła)",
                description: "Odpręż ciało i umysł w tradycyjnych japońskich gorących źródłach.",
                para1: "Kultura onsen jest głęboko zakorzeniona w Japonii. Naturalne gorące źródła uważane są za lecznicze.",
                para2: "Popularne destynacje to Hakone, Beppu i Kusatsu. Wiele ryokanów oferuje otwarte kąpiele rotenburo z niesamowitymi widokami.",
                para3: "Przestrzeganie zasad etykiety onsen poprawia doświadczenie i pokazuje szacunek dla japońskich tradycji kąpielowych."
            },

            japaneseCuisine: {
                title: "Autentyczna Kuchnia Japońska",
                description: "Rozkoszuj się światowej sławy japońską kuchnią i street foodem.",
                para1: "Od świeżego sushi i sashimi, przez sycące ramen, tempurę, aż po wielodaniowe kaiseki — japońska kuchnia jest niematerialnym dziedzictwem kulturowym UNESCO.",
                para2: "Tokio, Osaka i Kioto to prawdziwe rajskie miejsca dla smakoszy. Spróbuj street foodu w Dotonbori lub na rynku Nishiki.",
                para3: "Kulinarne wycieczki i warsztaty gotowania to świetny sposób na głębsze poznanie japońskich tradycji kulinarnych."
            },

            shinkansen: {
                title: "Przejazdka Shinkansenem (Pocisk)",
                description: "Doświadcz słynnego na cały świat japońskiego pociągu superszybkiego.",
                para1: "Shinkansen jest symbolem japońskiej doskonałości technologicznej i punktualności.",
                para2: "Komfortowo podróżuj między dużymi miastami takimi jak Tokio, Kioto, Osaka i Hiroszima z prędkością ponad 300 km/h.",
                para3: "Sama podróż jest częścią doświadczenia — czysto, cicho i niezwykle efektywnie."
            },

            matsuriFestivals: {
                title: "Tradycyjne Festiwale Matsuri",
                description: "Zanurz się w żywych tradycyjnych festiwalach.",
                para1: "Matsuri to tętniące życiem festiwale lokalnych społeczności z paradami, muzyką, stoiskami z jedzeniem i tradycyjnymi tańcami.",
                para2: "Słynne wydarzenia to Gion Matsuri w Kioto, Nebuta Matsuri w Aomori oraz Tenjin Matsuri w Osace.",
                para3: "Udział w matsuri to wspaniała okazja, by doświadczyć lokalnej kultury i japońskiego ducha."
            },

            themeParks: {
                title: "Parki Rozrywki i Rozrywka",
                description: "Ciesz się parkami rozrywki światowej klasy.",
                para1: "Tokyo Disneyland i DisneySea należą do najpopularniejszych na świecie.",
                para2: "Universal Studios Japan w Osace oferuje ekscytujące atrakcje oparte na Harrym Potterze, Super Nintendo World i wielu innych.",
                para3: "Te parki zapewniają rozrywkę dla wszystkich grup wiekowych i są szczególnie magiczne podczas wydarzeń sezonowych."
            },

            shoppingJapan: {
                title: "Zakupy w Tokio, Osace i Kioto",
                description: "Rzuć się w wir zakupów w tętniących życiem japońskich miastach.",
                para1: "Od marek luksusowych w Ginzie i Omotesando po elektronikę w Akihabarze i modę w Shinsaibashi.",
                para2: "Nie przegap domów towarowych, sklepów 100 jenów i targów z tradycyjnym rzemiosłem.",
                para3: "Zakupy bez podatku i unikalne pamiątki sprawiają, że zakupy w Japonii to prawdziwa przyjemność."
            },

            fourSeasons: {
                title: "Cztery Piękne Pory Roku Japonii",
                description: "Doświadcz magii czterech wyraźnie zróżnicowanych pór roku Japonii.",
                para1: "Japonia słynie z dramatycznych zmian sezonowych — wiosennych kwiatów wiśni, letnich festiwali, kolorowych jesiennych liści i zimowych śnieżnych krajobrazów.",
                para2: "Każda pora roku oferuje unikalne festiwale, kuchnię i krajobrazy w całym kraju.",
                para3: "Niezależnie od terminu wizyty, naturalne piękno i kulturalne święta Japonii pozostawią niezapomniane wrażenie."
            },

            viewMore: "Zobacz Szczegóły",
            close: "Zamknij",

            ctaTitle: "Gotowy na swoją japońską przygodę?",
            ctaDescription: "Pozwól Sonic Tours Japan stworzyć dla Ciebie idealny plan podróży z profesjonalnym przewodnictwem i spersonalizowaną obsługą.",
            ctaButton: "Zaplanuj podróż już teraz"
        },
        // Polish (pl)
        gallery: {
            heroTitle: "Odkryj Japonię",
            heroSubtitle: "Poznaj zapierające dech w piersiach piękno, kulturę i ikoniczne zabytki Japonii dzięki naszej starannie wyselekcjonowanej galerii.",

            // 20 Selected Places
            shibuya: "Shibuya Crossing",
            asakusa: "Świątynia Senso-ji",
            skytree: "Tokyo Skytree",
            mtfuji: "Góra Fudżi",
            lakeKawaguchi: "Jezioro Kawaguchi",
            hakoneRopeway: "Kolej Linowa Hakone",
            fushimiInari: "Fushimi Inari Taisha",
            arashiyama: "Bambusowy Las Arashiyama",
            kinkakuji: "Kinkaku-ji (Złoty Pawilon)",
            osakaCastle: "Zamek w Osace",
            dotonbori: "Dotonbori",
            naraPark: "Park Nara",
            todaiji: "Świątynia Todai-ji",
            hiroshimaPeace: "Pomnik Pokoju w Hiroszimie",
            miyajima: "Świątynia Itsukushima",
            nikko: "Świątynia Toshogu",
            shirakawago: "Shirakawa-go",
            himeji: "Zamek Himeji",
            universal: "Universal Studios Japan",
            teamlab: "TeamLab Planets",

            lightboxClose: "Zamknij",
            lightboxNext: "Dalej",
            lightboxPrevious: "Wstecz",
            tabPlaces: "Miejsca",
            tabEvents: "Wydarzenia"
        },
        // Polish (pl)
        events: {
            heroTitle: "Festiwale Japonii",
            heroSubtitle: "Doświadcz żywych kolorów, głębokich tradycji i niezapomnianej atmosfery światowej sławy festiwali i obchodów Japonii.",

            // 20 Selected Festivals
            sakuraMatsuri: "Festiwale Kwitnącej Wiśni (Sakura Matsuri)",
            hinaMatsuri: "Hina Matsuri (Święto Lalek)",
            takayamaSpring: "Wiosenny Festiwal Takayama",
            kandaMatsuri: "Kanda Matsuri",
            aoiMatsuri: "Aoi Matsuri",
            fujiShibazakura: "Festiwal Fuji Shibazakura",
            gionMatsuri: "Gion Matsuri",
            tenjinMatsuri: "Tenjin Matsuri",
            nebutaMatsuri: "Nebuta Matsuri",
            sendaiTanabata: "Festiwal Tanabata w Sendai",
            awaOdori: "Festiwal Awa Odori",
            sumidaFireworks: "Festiwal Fajerwerków nad Rzeką Sumida",
            nagaokaFireworks: "Festiwal Fajerwerków w Nagaoka",
            kishiwadaDanjiri: "Festiwal Kishiwada Danjiri",
            jidaiMatsuri: "Jidai Matsuri",
            takayamaAutumn: "Jesienny Festiwal Takayama",
            sapporoSnow: "Śnieżny Festiwal w Sapporo",
            otaruSnow: "Festiwal Śnieżnych Świateł w Otaru",
            nozawaOnsenFire: "Ogniowy Festiwal Nozawa Onsen",
            obonFestival: "Obon (Festiwal Pamięci Przodków)",

            tabPlaces: "Miejsca",
            tabEvents: "Wydarzenia"
        },

        // Polish (pl)
        home: {
            sections: {
                recommendations: {
                    title: "POPULARNE DESTYNACJE",
                    subtitle: "Odkryj najbardziej ikoniczne miasta Japonii, skarby kultury i zapierające dech w piersiach krajobrazy."
                },
                excursions: {
                    title: "PROGRAMY WYCIECZEK PO JAPONII",
                    desc: "Wybierz spośród starannie opracowanych planów podróży po Japonii dla początkujących, rodzin, par i miłośników kultury."
                },
                packages: {
                    title: "POPULARNE PAKIETY WYCIECZEK PO JAPONII"
                }
            },

            recommendations: {
                tokyo: {
                    label: "Tokio",
                    name: "Shibuya Crossing, Asakusa, Tokyo Skytree, zakupy i anime"
                },
                mountFuji: {
                    label: "Góra Fuji",
                    name: "Jezioro Kawaguchi, 5. Stacja Fuji i malownicze widoki"
                },
                kyoto: {
                    label: "Kioto",
                    name: "Świątynie, kapliczki, Las Bambusowy i dzielnica gejsz"
                },
                osaka: {
                    label: "Osaka",
                    name: "Dotonbori, Zamek Osaka i Universal Studios Japan"
                },
                nara: {
                    label: "Nara",
                    name: "Historyczne świątynie i przyjazny Park Jeleni"
                },
                hakone: {
                    label: "Hakone",
                    name: "Gorące źródła, kolejka linowa i widoki na Mt. Fuji"
                },
                nikko: {
                    label: "Nikko",
                    name: "Świątynie UNESCO i piękno natury"
                },
                shirakawago: {
                    label: "Shirakawa-go",
                    name: "Tradycyjna japońska wioska"
                },
                arashiyama: {
                    label: "Arashiyama",
                    name: "Słynny Las Bambusowy i malownicza rzeka"
                },
                himeji: {
                    label: "Himeji",
                    name: "Najpiękniejszy zamek w Japonii"
                }
            },

            excursions: {
                oneDay: {
                    title: "Zwiedzanie Tokio",
                    des: "Odwiedź Shibuya Crossing, Świątynię Asakusa, Tokyo Skytree i dzielnicę handlową Ginza."
                },
                twoDays: {
                    title: "Tokio i Góra Fuji",
                    des: "Poznaj najważniejsze atrakcje Tokio, a następnie ciesz się zapierającymi dech widokami na Górę Fuji i Jezioro Kawaguchi."
                },
                threeDays: {
                    title: "Tokio • Fuji • Hakone",
                    des: "Połącz nowoczesne Tokio z gorącymi źródłami w Hakone, kolejką linową i widokami na Górę Fuji."
                },
                fourDays: {
                    title: "Tokio • Kioto",
                    des: "Odkryj nowoczesną stolicę Japonii i starożytne kulturalne serce Kioto."
                },
                fiveDays: {
                    title: "Złota Trasa Japonii",
                    des: "Podróż przez Tokio, Górę Fuji, Kioto i Osakę."
                },
                sixDays: {
                    title: "Klasyczne Odkrywanie Japonii",
                    des: "Odwiedź Tokio, Hakone, Kioto, Narę i Osakę w jednej niezapomnianej podróży."
                }
            },

            packages: {
                one: {
                    title: "Tokio i Góra Fuji",
                    duration: "5 Dni",
                    desc: "Idealne pierwsze doświadczenie w Japonii – najważniejsze atrakcje Tokio i Góra Fuji."
                },
                two: {
                    title: "Klasyczna Japonia",
                    duration: "7 Dni",
                    desc: "Tokio, Góra Fuji, Kioto i Osaka."
                },
                three: {
                    title: "Złota Trasa",
                    duration: "10 Dni",
                    desc: "Tokio, Hakone, Kioto, Nara i Osaka."
                },
                four: {
                    title: "Odkrywca Japonii",
                    duration: "12 Dni",
                    desc: "Tokio, Hakone, Kioto, Nara, Osaka i Hiroszima."
                },
                five: {
                    title: "Największe Atrakcje Japonii",
                    duration: "14 Dni",
                    desc: "Odkryj słynne miasta, zabytki kultury i malowniczą prowincję Japonii."
                },
                six: {
                    title: "Wielka Podróż po Japonii",
                    duration: "14 Dni",
                    desc: "Ostateczna podróż po Japonii, w tym wyspa Miyajima i Hiroszima."
                }
            },

            featured: {
                elephantRide: {
                    h2: "IKONICZNY ZABYTEK",
                    h3: "GÓRA FUJI",
                    paragraph: "Doświadcz najsłynniejszej góry Japonii z panoramicznymi widokami, Jeziorem Kawaguchi i 5. Stacją Fuji.",
                    button: "Odkryj"
                },
                perahera: {
                    h2: "DZIEDZICTWO KULTUROWE",
                    h3: "ŚWIĄTYNIE KIOTO",
                    h4: "Starożytna Japonia",
                    paragraph: "Odkryj ponadczasowe świątynie, kapliczki, lasy bambusowe Kioto i słynną dzielnicę gejsz.",
                    button: "Poznaj"
                },
                safari: {
                    h2: "RODZINNA PRZYGODA",
                    h3: "TOKYO DISNEY RESORT",
                    paragraph: "Ciesz się niezapomnianymi chwilami w Tokyo Disneyland i Tokyo DisneySea z atrakcjami światowej klasy.",
                    button: "Dowiedz się więcej"
                }
            },

            famousTours: {
                title: "NAJPOPULARNIEJSZE NASZE WYCIECZKI PO JAPONII",
                subtitle: "Odkryj Japonię z starannie opracowanymi itinerariami obejmującymi najważniejsze destynacje kraju.",
                bookNow: "Zarezerwuj teraz",

                tours: {
                    benthotaRiverSafari: {
                        title: "5 Dni",
                        description: "Tokio + Góra Fuji"
                    },

                    polgampalaWaterPool: {
                        title: "7 Dni",
                        description: "Tokio + Góra Fuji + Kioto + Osaka"
                    },

                    galleTour: {
                        title: "10 Dni",
                        description: "Tokio + Hakone + Kioto + Nara + Osaka"
                    },

                    sigiriyaTour: {
                        title: "12–14 Dni",
                        description: "Tokio + Hakone + Kioto + Nara + Osaka + Hiroszima + Miyajima"
                    }
                }
            },

            gallery: {
                title: "NASZA GALERIA JAPONII",
                subtitle: "Obejrzyj niezapomniane chwile uchwycone w ikonicznych miastach, zabytkach kultury i malowniczych krajobrazach Japonii."
            },
            cta: {
                title: "ROZPOCZNIJ SWOJĄ PRZYGODĘ W JAPONII JUŻ DZISIAJ",
                desc: "Pozwól Sonic Tours stworzyć dla Ciebie idealne wakacje w Japonii – z starannie zaplanowanymi trasami, niezapomnianymi przeżyciami i wyjątkową obsługą od początku do końca.",
                button: "Zaplanuj swoją podróż",
                alt: "Wycieczka do Japonii"
            }
        },
        // Polish (pl)
        hero: {
            title: {
                line1: "Odkryj Japonię z",
                line2: "Sonic Tours",
                line3: "Japonia"
            },
            subtitle: "Starożytne świątynie, tętniące życiem miasta, spokojne ogrody i niezapomniane przygody —",
            subtitle2: "dopasowane do Twojej podróży.",

            cta: "Rozpocznij swoją podróż",
            trust: "Uwielbiany przez podróżników z ponad 50 krajów • Doceniany przez światowych ekspertów turystycznych"
        },
        // Polish (pl)
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "Strona główna",
                about: "O nas",
                explore: "Turystyka w Japonii",
                tours: "Tury",
                gallery: "Galeria",
                events: "Wydarzenia",
                things: "Co warto zobaczyć",
                contact: "Kontakt"
            },

            contact: {
                title: "Skontaktuj się z nami",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "Pozostań w kontakcie",
                desc: "Zapisz się do newslettera, aby otrzymywać ekskluzywne wskazówki podróżnicze po Japonii, sezonowe oferty i wczesny dostęp do nowych tourów.",
                placeholder: "Wpisz swój adres email",
                subscribe: "Zapisz się"
            },

            tagline: "Odkryj duszę Japonii z <span class='text-[#f7d774]'>Sonic Tours Japan</span> — Twoim zaufanym partnerem w podróżach pełnych autentycznych i niezapomnianych wrażeń.",

            copyright: "Wszelkie prawa zastrzeżone.",
            developedBy: "Opracowane przez"
        },

    },
    it: {
        translation: {
            home: 'Home',
            aboutUs: 'Chi siamo',
            sriLankanav: 'Giappone',
            gallerynav: 'Galleria',
            bookATour: 'Tour',
            thingsToDo: 'Cose da fare',
            contactUs: 'Contattaci',
            contactJapan: 'Contatto Giappone',
            japanHeroEyebrow: 'Scopri il Giappone',
            japanHeroTitle: 'Scopri l’eleganza del Giappone con Sonic Tours',
            japanHeroSubtitle: 'Dai templi antichi e giardini tranquilli alle città vivaci e alle avventure indimenticabili, il Giappone offre un viaggio unico.',
            japanHeroImageAlt: 'Paesaggio del Giappone',
            japanAboutEyebrow: 'Sul Giappone',
            japanSectionTitle: 'Una destinazione senza tempo per viaggiatori curiosi',
            japanSectionDescription: 'Il Giappone unisce una ricca eredità culturale, una cucina eccellente, la bellezza della natura e l’innovazione moderna in un’esperienza di viaggio straordinaria. Che tu stia cercando templi silenziosi, luci di città o paesaggi mozzafiato, Sonic Tours ti aiuta a scoprirli tutti con comfort e attenzione.',
            japanSectionImageAlt: 'Scena di viaggio in Giappone',
        },
        about: {
            hero: {
                discover: 'Giappone Classico',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: 'Scopri la bellezza senza tempo del Giappone con viaggi guidati da esperti',
                tagline2: 'Dalle città vibranti alle montagne sacre e agli antichi templi — lascia che creiamo la tua perfetta avventura giapponese.',
            },

            about: {
                title: 'Su Sonic Tours Japan',
            },

            tours: {
                classic: 'Giappone Classico (Per i primi visitatori)',
                days4: '5–7 Giorni',
                desc1: 'Tokyo – Shibuya Crossing, Asakusa, Tokyo Skytree, shopping, anime e vita notturna. Monte Fuji – Vedute panoramiche, Lago Kawaguchi e Quinta Stazione del Fuji.',

                safari: 'Attrazioni Culturali',
                days5: 'Kyoto • Nara • Osaka',
                desc2: 'Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Castello di Himeji e il pacifico fascino del Parco di Nara.',

                retreat: 'Natura e Paesaggi',
                days6: 'Hakone • Arashiyama • Nikko',
                desc3: 'Sorgenti termali di Hakone e viste sul Monte Fuji, Foresta di Bambù di Arashiyama, Nikko e il villaggio storico di Shirakawa-go.',
            },

            owner: {
                title: 'Conosci il Nostro Leadership',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: 'Con una profonda passione per la cultura giapponese e decenni di esperienza nel settore dei viaggi di lusso, Tomoya Izawa guida Sonic Tours Japan con visione e dedizione. Il suo impegno per esperienze autentiche e un servizio eccezionale garantisce che ogni ospite riceva ospitalità di classe mondiale e viaggi indimenticabili attraverso il Giappone.',
                imageAlt: 'Tomoya Izawa - CEO & President di Sonic Tours Japan',
            },

            whoWeAre: {
                title: 'Il Tuo Esperto di Viaggi in Giappone',
                description: 'Guidata da <strong>Buddika</strong>, Sonic Tours Japan si specializza nella creazione di esperienze di viaggio personalizzate e di alta qualità in tutto il Giappone. Con una profonda conoscenza locale e una passione per la cultura giapponese, garantiamo che ogni viaggio sia fluido, arricchente e davvero memorabile.',
                item1: { title: 'Guide Locali Esperte', text: 'Autorizzate ed esperte' },
                item2: { title: 'Itinerari Su Misura', text: 'Personalizzati al tuo ritmo' },
                item3: { title: 'Esperienza Senza Intoppi', text: 'Viaggio senza stress' },
                item4: { title: 'Supporto 24/7', text: 'Sempre qui per te' },
                imageAlt: 'Buddika - Esperto di Tour in Giappone',
            },

            offers: {
                title: 'Cosa Offriamo',
                cultural: {
                    title: 'Immersione Culturale',
                    text: 'Templi, santuari, arti tradizionali e tradizioni locali',
                    alt: 'Esperienze culturali giapponesi'
                },
                adventure: {
                    title: 'Natura e Avventura',
                    text: 'Monte Fuji, Hakone, escursioni e percorsi panoramici',
                    alt: 'Avventure nella natura giapponese'
                },
                luxury: {
                    title: 'Viaggi di Lusso',
                    text: 'Hotel premium, trasferimenti privati ed esperienze esclusive',
                    alt: 'Viaggi di lusso in Giappone'
                },
                wellness: {
                    title: 'Benessere e Relax',
                    text: 'Sorgenti termali onsen, mindfulness e ritiri rigeneranti',
                    alt: 'Ritiri wellness in Giappone'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'Lead Tour Guide',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: 'Con anni di esperienza nel guidare viaggiatori attraverso il Giappone, Buddika è appassionato nel condividere la bellezza autentica, la cultura e le gemme nascoste di questo incredibile paese. La sua personalità calorosa e la profonda conoscenza rendono ogni tour davvero speciale.',
            },

            villageTours: {
                title: 'Esperienze Autentiche del Giappone',
                description: 'Oltre le grandi città, scopri villaggi tradizionali, artigianato locale, festival stagionali e la calda ospitalità che definisce il vero Giappone.',
                imageAlt: 'Esperienza di villaggio tradizionale giapponese',
                bookButton: 'Esplora il Giappone Autentico',
            },

            vehicles: {
                title: 'La Nostra Flotta',
                text: 'Veicoli confortevoli, moderni e ben mantenuti per un viaggio rilassante attraverso il Giappone.',
                bookButton: 'Prenota il Tuo Tour',
                car: { title: 'Auto Privata', text: 'Ideale per coppie e piccoli gruppi' },
                van: { title: 'Van Comfort', text: 'Spazioso e confortevole' },
                minibus: { title: 'Minibus', text: 'Perfetto per famiglie e gruppi medi' },
                luxury: { title: 'Pullman di Lusso', text: 'Esperienza premium per gruppi numerosi' },
            },

            notices: {
                title: 'Viaggia con Fiducia',
                intro: 'Presso Sonic Tours Japan, il tuo comfort, la tua sicurezza e la tua soddisfazione sono le nostre massime priorità.',
                fruits: { title: 'Snack Gratuiti', text: 'Frutta di stagione e rinfreschi leggeri' },
                meals: { title: 'Pasti Selezionati con Cura', text: 'Esperienze con autentica cucina giapponese' },
                massage: { title: 'Servizi di Relax', text: 'Aggiunte opzionali di onsen e wellness' },
                flowers: { title: 'Caloroso Benvenuto', text: 'Tradizionale ospitalità giapponese' },
            },

            slider: {
                sigiriya: 'Monte Fuji',
                yala: 'Templi di Kyoto',
                tea: 'Foresta di Bambù di Arashiyama',
                beaches: 'Lago di Hakone',
                temples: 'Parco dei Cervi di Nara',
            },
        },
        tourPackages: {
            hero: {
                discover: 'Giappone Classico',
                starLankaTours: 'Per chi visita per la prima volta',
                highlight: 'Un viaggio senza tempo tra Tokyo, Fuji, Kyoto e Osaka',
                tagline1: 'Dalle luci iconiche della città ai templi sereni, il Giappone offre un’esperienza di viaggio straordinaria per ogni viaggiatore alla prima visita.',
                tagline2: 'Lascia che Sonic Tours trasformi il tuo itinerario dei sogni in un viaggio fluido e indimenticabile attraverso il Giappone.',
            },
            overview: {
                eyebrow: 'Highlights del Giappone',
                title: 'Highlights del Giappone per i primi visitatori',
                description: 'Queste destinazioni sono tra le più amate dai viaggiatori internazionali e costituiscono un’ottima base per pacchetti turistici attraenti in Giappone.',
            },
            cards: {
                classicTitle: 'Giappone Classico (Primo Viaggio)',
                classicMeta: 'Tokyo • Monte Fuji',
                classicText: 'Tokyo offre Shibuya Crossing, Asakusa, Tokyo Skytree, shopping, anime e vita notturna. Il Monte Fuji regala viste spettacolari, il Lago Kawaguchi e la 5ª Stazione.',
                classicAlt: 'Skyline di Tokyo e Monte Fuji',
                culturalTitle: 'Attrazioni Culturali',
                culturalMeta: 'Kyoto • Nara • Osaka',
                culturalText: 'Scopri Fushimi Inari Taisha, Kinkaku-ji, Senso-ji, Castello di Himeji e il fascino pacifico del Parco di Nara.',
                culturalAlt: 'Templi e siti storici giapponesi',
                natureTitle: 'Natura e Paesaggi',
                natureMeta: 'Hakone • Arashiyama • Nikko',
                natureText: 'Goditi le terme di Hakone con vista sul Monte Fuji, la foresta di bambù di Arashiyama, Nikko e Shirakawa-go.',
                natureAlt: 'Paesaggi giapponesi mozzafiato',
            },
            highlights: {
                eyebrow: 'Esperienze Popolari',
                title: 'Pianifica il viaggio perfetto in Giappone secondo i tuoi interessi',
                text: 'Che tu ami la bellezza delle stagioni, il divertimento in famiglia o le scoperte culturali, Sonic Tours crea un itinerario che sia facile e ispiratore.',
                seasonalTitle: 'Attrazioni Stagionali',
                seasonalText: 'La primavera è perfetta per i ciliegi in fiore, l’estate per scalare il Monte Fuji e i festival, l’autunno per il foliage a Kyoto e Nikko, l’inverno per sciare a Niseko o il Festival della Neve di Sapporo.',
                familyTitle: 'Attrazioni per Famiglie',
                familyText: 'Tokyo Disneyland, Tokyo DisneySea, Universal Studios Japan e Osaka Aquarium Kaiyukan sono scelte fantastiche per le famiglie.',
            },
            recommended: {
                eyebrow: 'Pacchetti Raccomandati',
                title: 'Pacchetti Turistici Raccomandati',
                subtitle: 'Scegli la durata perfetta per la tua prima avventura in Giappone',
                packages: {
                    fiveDays: {
                        title: '5 Giorni: Tokyo + Monte Fuji',
                        description: 'Introduzione perfetta al Giappone — Tokyo vibrante e l’iconico Monte Fuji.',
                        alt: 'Tokyo e Monte Fuji'
                    },
                    sevenDays: {
                        title: '7 Giorni: Tokyo + Monte Fuji + Kyoto + Osaka',
                        description: 'Itinerario classico che copre le città imperdibili e il cuore culturale del Giappone.',
                        alt: 'Kyoto e Osaka'
                    },
                    tenDays: {
                        title: '10 Giorni: Tokyo + Hakone + Kyoto + Nara + Osaka',
                        description: 'Esplorazione approfondita con la bellezza scenica di Hakone e la storica Nara.',
                        alt: 'Hakone e Nara'
                    },
                    twelveToFourteenDays: {
                        title: '12–14 Giorni: Tokyo + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima',
                        description: 'Viaggio completo che include la toccante storia di Hiroshima e la sacra isola di Miyajima.',
                        alt: 'Hiroshima e Miyajima'
                    }
                }
            },
            cta: {
                eyebrow: 'Viaggi su misura in Giappone',
                title: 'Lascia che Sonic Tours progetti il tuo viaggio in Giappone',
                text: 'Scegli un itinerario classico per la prima volta o un programma personalizzato secondo il tuo ritmo, interessi e stagione.',
                button: 'Pianifica il mio viaggio in Giappone',
                imageAlt: 'Esperienza di viaggio in Giappone',
            },
        },
        // Italian (it)
        contactus: {
            heroTitle: 'Contattaci',
            heroSubtitle: 'Sonic Tours Japan – Il tuo portale verso indimenticabili viaggi in Giappone',

            feelFree: 'Non esitare a contattarci',
            planDream: 'Pianifica la tua perfetta vacanza in Giappone',
            reachOutDesc: 'Contatta Sonic Tours Japan per itinerari su misura, consigli esperti e esperienze indimenticabili in tutto il Giappone.',

            callCenter: 'Centro Assistenza',
            phone: '+81 90-8251-4053',
            emailTitle: 'Email',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: 'La nostra sede',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: 'Seguici',

            getInTouch: 'Restiamo in contatto',
            getInTouchDesc: 'Inizia la tua avventura giapponese con Sonic Tours Japan – siamo qui per aiutarti a creare ricordi indimenticabili.',

            nameLabel: 'Nome',
            namePlaceholder: 'Il tuo nome completo',
            emailLabel: 'Email',
            emailPlaceholder: 'tuo.email@esempio.it',
            phoneLabel: 'Numero di telefono',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'Messaggio',
            messagePlaceholder: 'Raccontaci del tuo viaggio ideale in Giappone...',

            sendButton: 'Invia messaggio',
            sendingButton: 'Invio in corso...',
            successMsg: 'Il tuo messaggio è stato inviato via WhatsApp!',
            errorMsg: 'Impossibile aprire WhatsApp. Per favore riprova.',

            findUsTitle: 'Trovaci in Giappone',
        },
        japan: {
            heroTitle: 'CEO e presidente dell\'ufficio in Giappone',
            heroSubtitle: 'Il tuo partner di fiducia per le avventure in Sri Lanka dal Giappone',

            contactPerson: 'Tomoya Izawa',
            position: 'Rappresentante Giappone',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'Connettiti con noi sui social media',

            formTitle: 'Inviaci un messaggio',
            formHeading: 'Inizia la tua avventura in Sri Lanka',
            formDescription: 'Contatta Tomoya Izawa per pacchetti turistici personalizzati, consigli di viaggio esperti ed esperienze indimenticabili in Sri Lanka.',

            nameLabel: 'Il tuo nome *',
            namePlaceholder: 'Inserisci il tuo nome completo',
            emailLabel: 'Indirizzo email *',
            emailPlaceholder: 'tua.email@esempio.it',
            phoneLabel: 'Numero di telefono',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'Il tuo messaggio *',
            messagePlaceholder: 'Raccontaci della tua avventura da sogno in Sri Lanka...',

            sendButton: 'Invia messaggio via e-mail',
            sendingButton: 'Apertura client e-mail...',
            successMsg: 'Il tuo client e-mail è stato aperto con il messaggio!',
            errorMsg: 'Impossibile aprire il client e-mail. Riprova.',

            whyChooseTitle: 'Perché scegliere Sonic Tours?',

            expertiseTitle: 'Esperienza locale',
            expertiseDesc: 'Esperienze autentiche dello Sri Lanka curate da esperti locali che conoscono ogni gemma nascosta',

            supportTitle: 'Supporto in giapponese',
            supportDesc: 'Rappresentante dedicato di lingua giapponese per una comunicazione fluida',

            personalizedTitle: 'Tour personalizzati',
            personalizedDesc: 'Itinerari su misura progettati per soddisfare i tuoi interessi e il tuo stile di viaggio',

            mapTitle: 'Trovaci in Sri Lanka',
        },
        // Italian (it)
        thingstodo: {
            heroTitle: "Cose da Fare in Giappone",
            heroSubtitle: "Scopri esperienze indimenticabili e crea ricordi che dureranno tutta la vita nella Terra del Sol Levante.",

            sectionTitle: "Esperienze Indimenticabili in Giappone",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "Ammirare la Fioritura dei Ciliegi",
                description: "L’esperienza stagionale più iconica e mozzafiato del Giappone.",
                para1: "L’ammirazione della fioritura dei ciliegi, conosciuta come 'hanami', è una delle tradizioni più amate del Giappone. Ogni primavera milioni di persone si radunano sotto gli alberi di sakura rosa per celebrare la bellezza effimera della vita.",
                para2: "Luoghi popolari includono il Parco Ueno e Shinjuku Gyoen a Tokyo, il Sentiero del Filosofo a Kyoto e il Parco del Castello di Osaka. Molti fanno picnic (hanami bento) con famiglia e amici sotto i fiori.",
                para3: "Il picco della stagione è solitamente tra fine marzo e inizio aprile. Le illuminazioni serali creano un’atmosfera magica in molti luoghi."
            },

            ancientTemples: {
                title: "Antichi Templi e Santuari",
                description: "Scopri il patrimonio spirituale del Giappone attraverso templi e santuari antichi.",
                para1: "Il Giappone ospita migliaia di templi e santuari storici, molti dei quali sono Patrimonio dell’Umanità UNESCO.",
                para2: "Siti iconici includono il Fushimi Inari Taisha con le sue migliaia di porte torii rosse, il Kinkaku-ji (Padiglione d’Oro) e il grandioso Tempio Todaiji a Nara.",
                para3: "I visitatori possono partecipare a rituali, ricevere fortune o semplicemente godersi i giardini sereni e la bellezza stagionale intorno a questi luoghi sacri."
            },

            mountFuji: {
                title: "Monte Fuji e i Cinque Laghi",
                description: "Ammira il maestoso e sacro simbolo del Giappone.",
                para1: "Con i suoi 3.776 metri, il Monte Fuji è la vetta più alta del Giappone e un’icona culturale.",
                para2: "Le migliori viste si godono dalla regione dei Cinque Laghi Fuji (soprattutto dal Lago Kawaguchi). Puoi scalare la vetta durante la stagione ufficiale o ammirare i panorami tutto l’anno.",
                para3: "La zona circostante offre incantevoli cittadine, resort onsen e opportunità fotografiche di livello mondiale."
            },

            onsenRelax: {
                title: "Onsen Tradizionali (Terme Giapponesi)",
                description: "Rilassa corpo e mente nelle tradizionali terme giapponesi.",
                para1: "La cultura degli onsen è profondamente radicata in Giappone. Le sorgenti termali naturali sono considerate curative.",
                para2: "Destinazioni popolari includono Hakone, Beppu e Kusatsu. Molti ryokan offrono bagni all’aperto rotenburo con viste spettacolari.",
                para3: "Rispettare l’etichetta degli onsen migliora l’esperienza e dimostra rispetto per le tradizioni giapponesi del bagno."
            },

            japaneseCuisine: {
                title: "Cucina Giapponese Autentica",
                description: "Assapora la rinomata cucina giapponese e lo street food.",
                para1: "Da sushi e sashimi freschi a ramen sostanziosi, tempura e raffinati pasti kaiseki — la cucina giapponese è Patrimonio Culturale Immateriale UNESCO.",
                para2: "Tokyo, Osaka e Kyoto sono paradisi gastronomici. Prova lo street food a Dotonbori o al mercato Nishiki.",
                para3: "Tour gastronomici e lezioni di cucina sono modi eccellenti per approfondire le tradizioni culinarie giapponesi."
            },

            shinkansen: {
                title: "Viaggio sullo Shinkansen (Treno Proiettile)",
                description: "Vivi il famoso treno ad alta velocità giapponese.",
                para1: "Lo Shinkansen è simbolo dell’eccellenza tecnologica e della puntualità del Giappone.",
                para2: "Viaggia comodamente tra le grandi città come Tokyo, Kyoto, Osaka e Hiroshima a oltre 300 km/h.",
                para3: "Il viaggio stesso è parte dell’esperienza: pulito, silenzioso e incredibilmente efficiente."
            },

            matsuriFestivals: {
                title: "Festival Tradizionali Matsuri",
                description: "Immergiti nei vivaci festival tradizionali.",
                para1: "I Matsuri sono feste comunitarie piene di vita con sfilate, musica, bancarelle di cibo e danze tradizionali.",
                para2: "Eventi famosi includono il Gion Matsuri a Kyoto, il Nebuta Matsuri ad Aomori e il Tenjin Matsuri a Osaka.",
                para3: "Partecipare a un matsuri è un’occasione meravigliosa per vivere la cultura locale e lo spirito giapponese."
            },

            themeParks: {
                title: "Parchi a Tema e Divertimento",
                description: "Goditi parchi a tema di livello mondiale.",
                para1: "Tokyo Disneyland e DisneySea sono tra i più amati al mondo.",
                para2: "Universal Studios Japan a Osaka offre attrazioni emozionanti ispirate a Harry Potter, Super Nintendo World e molti altri.",
                para3: "Questi parchi offrono divertimento per tutte le età e sono particolarmente magici durante gli eventi stagionali."
            },

            shoppingJapan: {
                title: "Shopping a Tokyo, Osaka e Kyoto",
                description: "Fai shopping fino allo sfinimento nelle vivaci città giapponesi.",
                para1: "Dai marchi di lusso a Ginza e Omotesando all’elettronica ad Akihabara e alla moda a Shinsaibashi.",
                para2: "Non perdere i grandi magazzini, i negozi da 100 yen e i mercati di artigianato tradizionale.",
                para3: "Lo shopping tax-free e i souvenir unici rendono lo shopping in Giappone un’esperienza deliziosa."
            },

            fourSeasons: {
                title: "Le Quattro Belle Stagioni del Giappone",
                description: "Vivi la magia delle quattro stagioni così diverse del Giappone.",
                para1: "Il Giappone è famoso per i suoi drammatici cambiamenti stagionali: fiori di ciliegio in primavera, festival estivi vivaci, foglie autunnali colorate e paesaggi innevati in inverno.",
                para2: "Ogni stagione offre festival unici, cucina e paesaggi in tutto il paese.",
                para3: "Non importa quando visiti, la bellezza naturale e le celebrazioni culturali del Giappone ti lasceranno un’impressione duratura."
            },

            viewMore: "Vedi Dettagli",
            close: "Chiudi",

            ctaTitle: "Pronto per la tua avventura in Giappone?",
            ctaDescription: "Lascia che Sonic Tours Japan crei per te l’itinerario perfetto con guida esperta e servizio personalizzato.",
            ctaButton: "Pianifica il tuo viaggio ora"
        },
        // Italian (it)
        gallery: {
            heroTitle: "Scopri il Giappone",
            heroSubtitle: "Esplora la bellezza mozzafiato, la cultura e i luoghi iconici del Giappone attraverso la nostra galleria curata con cura.",

            // 20 Selected Places
            shibuya: "Shibuya Crossing",
            asakusa: "Tempio Senso-ji",
            skytree: "Tokyo Skytree",
            mtfuji: "Monte Fuji",
            lakeKawaguchi: "Lago Kawaguchi",
            hakoneRopeway: "Funivia di Hakone",
            fushimiInari: "Fushimi Inari Taisha",
            arashiyama: "Foresta di Bambù di Arashiyama",
            kinkakuji: "Kinkaku-ji (Padiglione d'Oro)",
            osakaCastle: "Castello di Osaka",
            dotonbori: "Dotonbori",
            naraPark: "Parco di Nara",
            todaiji: "Tempio Todai-ji",
            hiroshimaPeace: "Memoriale della Pace di Hiroshima",
            miyajima: "Santuario di Itsukushima",
            nikko: "Santuario di Toshogu",
            shirakawago: "Shirakawa-go",
            himeji: "Castello di Himeji",
            universal: "Universal Studios Japan",
            teamlab: "TeamLab Planets",

            lightboxClose: "Chiudi",
            lightboxNext: "Successivo",
            lightboxPrevious: "Precedente",
            tabPlaces: "Luoghi",
            tabEvents: "Eventi"
        },
        // Italian (it)
        events: {
            heroTitle: "Festival Giapponesi",
            heroSubtitle: "Vivi i colori vibranti, le profonde tradizioni e l’atmosfera indimenticabile dei famosissimi festival e celebrazioni del Giappone.",

            // 20 Selected Festivals
            sakuraMatsuri: "Festival della Fioritura dei Ciliegi (Sakura Matsuri)",
            hinaMatsuri: "Hina Matsuri (Festa delle Bambole)",
            takayamaSpring: "Festival Primaverile di Takayama",
            kandaMatsuri: "Kanda Matsuri",
            aoiMatsuri: "Aoi Matsuri",
            fujiShibazakura: "Festival Fuji Shibazakura",
            gionMatsuri: "Gion Matsuri",
            tenjinMatsuri: "Tenjin Matsuri",
            nebutaMatsuri: "Nebuta Matsuri",
            sendaiTanabata: "Festival Tanabata di Sendai",
            awaOdori: "Festival Awa Odori",
            sumidaFireworks: "Festival dei Fuochi d'Artificio sul Fiume Sumida",
            nagaokaFireworks: "Festival dei Fuochi d'Artificio di Nagaoka",
            kishiwadaDanjiri: "Festival Kishiwada Danjiri",
            jidaiMatsuri: "Jidai Matsuri",
            takayamaAutumn: "Festival Autunnale di Takayama",
            sapporoSnow: "Festival della Neve di Sapporo",
            otaruSnow: "Festival delle Luci sulla Neve di Otaru",
            nozawaOnsenFire: "Festival del Fuoco di Nozawa Onsen",
            obonFestival: "Obon (Festival della Memoria degli Antenati)",

            tabPlaces: "Luoghi",
            tabEvents: "Eventi"
        },

        // Italian (it)
        home: {
            sections: {
                recommendations: {
                    title: "DESTINAZIONI POPOLARI",
                    subtitle: "Scopri le città più iconiche del Giappone, i tesori culturali e i paesaggi mozzafiato."
                },
                excursions: {
                    title: "PROGRAMMI DI TOUR IN GIAPPONE",
                    desc: "Scegli tra itinerari attentamente progettati per chi visita il Giappone per la prima volta, famiglie, coppie e amanti della cultura."
                },
                packages: {
                    title: "PACCHETTI TOUR GIAPPONE PIÙ POPOLARI"
                }
            },

            recommendations: {
                tokyo: {
                    label: "Tokyo",
                    name: "Shibuya Crossing, Asakusa, Tokyo Skytree, Shopping & Anime"
                },
                mountFuji: {
                    label: "Monte Fuji",
                    name: "Lago Kawaguchi, Stazione 5 del Fuji e viste panoramiche"
                },
                kyoto: {
                    label: "Kyoto",
                    name: "Templi, Santuari, Foresta di Bambù e Quartiere delle Geisha"
                },
                osaka: {
                    label: "Osaka",
                    name: "Dotonbori, Castello di Osaka e Universal Studios Japan"
                },
                nara: {
                    label: "Nara",
                    name: "Templi storici e Parco dei Cervi amichevoli"
                },
                hakone: {
                    label: "Hakone",
                    name: "Sorgenti termali, Funivia e viste sul Monte Fuji"
                },
                nikko: {
                    label: "Nikko",
                    name: "Santuari UNESCO e bellezza naturale"
                },
                shirakawago: {
                    label: "Shirakawa-go",
                    name: "Villaggio tradizionale giapponese"
                },
                arashiyama: {
                    label: "Arashiyama",
                    name: "Famosa Foresta di Bambù e fiume scenico"
                },
                himeji: {
                    label: "Himeji",
                    name: "Il castello più bello del Giappone"
                }
            },

            excursions: {
                oneDay: {
                    title: "Tour della Città di Tokyo",
                    des: "Visita Shibuya Crossing, Tempio di Asakusa, Tokyo Skytree e il quartiere commerciale di Ginza."
                },
                twoDays: {
                    title: "Tokyo e Monte Fuji",
                    des: "Scopri i punti salienti di Tokyo e goditi le viste mozzafiato sul Monte Fuji e sul Lago Kawaguchi."
                },
                threeDays: {
                    title: "Tokyo • Fuji • Hakone",
                    des: "Combina la moderna Tokyo con le sorgenti termali di Hakone, la funivia e i panorami del Monte Fuji."
                },
                fourDays: {
                    title: "Tokyo • Kyoto",
                    des: "Esplora la moderna capitale del Giappone e l'antico cuore culturale di Kyoto."
                },
                fiveDays: {
                    title: "Golden Route Giappone",
                    des: "Viaggia attraverso Tokyo, Monte Fuji, Kyoto e Osaka."
                },
                sixDays: {
                    title: "Scoperta Classica del Giappone",
                    des: "Visita Tokyo, Hakone, Kyoto, Nara e Osaka in un viaggio indimenticabile."
                }
            },

            packages: {
                one: {
                    title: "Tokyo e Monte Fuji",
                    duration: "5 Giorni",
                    desc: "L'esperienza perfetta per chi visita il Giappone per la prima volta, con i highlights di Tokyo e il Monte Fuji."
                },
                two: {
                    title: "Giappone Classico",
                    duration: "7 Giorni",
                    desc: "Tokyo, Monte Fuji, Kyoto e Osaka."
                },
                three: {
                    title: "Golden Route",
                    duration: "10 Giorni",
                    desc: "Tokyo, Hakone, Kyoto, Nara e Osaka."
                },
                four: {
                    title: "Esploratore del Giappone",
                    duration: "12 Giorni",
                    desc: "Tokyo, Hakone, Kyoto, Nara, Osaka e Hiroshima."
                },
                five: {
                    title: "Highlights del Giappone",
                    duration: "14 Giorni",
                    desc: "Scopri le città più famose del Giappone, i siti culturali e le campagne pittoresche."
                },
                six: {
                    title: "Grand Tour del Giappone",
                    duration: "14 Giorni",
                    desc: "Il viaggio definitivo attraverso il Giappone, inclusa l'isola di Miyajima e Hiroshima."
                }
            },

            featured: {
                elephantRide: {
                    h2: "MONUMENTO ICONICO",
                    h3: "MONTE FUJI",
                    paragraph: "Vivi la montagna più famosa del Giappone con viste panoramiche, Lago Kawaguchi e Stazione 5 del Fuji.",
                    button: "Esplora"
                },
                perahera: {
                    h2: "PATRIMONIO CULTURALE",
                    h3: "TEMPLI DI KYOTO",
                    h4: "Giappone Antico",
                    paragraph: "Scopri i templi senza tempo di Kyoto, i santuari, le foreste di bambù e il famoso quartiere delle geisha.",
                    button: "Scopri"
                },
                safari: {
                    h2: "AVVENTURA IN FAMIGLIA",
                    h3: "TOKYO DISNEY RESORT",
                    paragraph: "Vivi momenti indimenticabili in famiglia al Tokyo Disneyland e Tokyo DisneySea con attrazioni di livello mondiale.",
                    button: "Scopri di più"
                }
            },

            famousTours: {
                title: "I NOSTRI TOUR PIÙ POPOLARI IN GIAPPONE",
                subtitle: "Scopri il Giappone con itinerari attentamente progettati che coprono le destinazioni più iconiche del paese.",
                bookNow: "Prenota Ora",

                tours: {
                    benthotaRiverSafari: {
                        title: "5 Giorni",
                        description: "Tokyo + Monte Fuji"
                    },

                    polgampalaWaterPool: {
                        title: "7 Giorni",
                        description: "Tokyo + Monte Fuji + Kyoto + Osaka"
                    },

                    galleTour: {
                        title: "10 Giorni",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka"
                    },

                    sigiriyaTour: {
                        title: "12–14 Giorni",
                        description: "Tokyo + Hakone + Kyoto + Nara + Osaka + Hiroshima + Miyajima"
                    }
                }
            },

            gallery: {
                title: "LA NOSTRA GALLERIA DEL GIAPPONE",
                subtitle: "Esplora i momenti indimenticabili catturati nelle città iconiche, nei luoghi culturali e nei paesaggi mozzafiato del Giappone."
            },
            cta: {
                title: "INIZIA OGGI LA TUA AVVENTURA IN GIAPPONE",
                desc: "Lascia che Sonic Tours crei la tua vacanza perfetta in Giappone con itinerari studiati, esperienze indimenticabili e un servizio eccezionale dall'inizio alla fine.",
                button: "Pianifica il tuo viaggio",
                alt: "Tour Giappone"
            }
        },
        // Italian (it)
        hero: {
            title: {
                line1: "Scopri il Giappone con",
                line2: "Sonic Tours",
                line3: "Giappone"
            },
            subtitle: "Templi antichi, città vivaci, giardini tranquilli e avventure indimenticabili —",
            subtitle2: "create attorno al tuo viaggio.",

            cta: "Inizia il tuo viaggio",
            trust: "Amato da viaggiatori di oltre 50 paesi • Apprezzato dagli esperti di viaggio di tutto il mondo"
        },
        // Italian (it)
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "Home",
                about: "Chi siamo",
                explore: "Turismo in Giappone",
                tours: "Tour",
                gallery: "Galleria",
                events: "Eventi",
                things: "Cose da fare",
                contact: "Contattaci"
            },

            contact: {
                title: "Contattaci",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "Resta in contatto",
                desc: "Iscriviti per ricevere consigli esclusivi sui viaggi in Giappone, offerte stagionali e accesso anticipato ai nuovi tour.",
                placeholder: "Inserisci la tua email",
                subscribe: "Iscriviti"
            },

            tagline: "Scopri l'anima del Giappone con <span class='text-[#f7d774]'>Sonic Tours Japan</span> — il tuo partner affidabile per viaggi autentici e indimenticabili.",

            copyright: "Tutti i diritti riservati.",
            developedBy: "Sviluppato da"
        },

    },
    zh: {
        translation: {
            home: '首页',
            aboutUs: '关于我们',
            sriLankanav: '日本',
            gallerynav: '画廊',
            bookATour: '旅游',
            thingsToDo: '活动',
            contactUs: '联系我们',
            contactJapan: '联系日本',
            japanHeroEyebrow: '探索日本',
            japanHeroTitle: '与 Sonic Tours 一起感受日本的优雅',
            japanHeroSubtitle: '从古老寺院和宁静花园，到充满活力的城市和难忘冒险，日本带来一段与众不同的旅程。',
            japanHeroImageAlt: '日本风景',
            japanAboutEyebrow: '关于日本',
            japanSectionTitle: '为好奇旅者打造的 timeless 目的地',
            japanSectionDescription: '日本将丰富的文化遗产、世界级美食、自然之美与现代创新融合成一次非凡的旅行体验。无论您是寻找宁静寺院、繁华都市的灯火，还是壮丽风景，Sonic Tours 都将以舒适与细致为您带来一场难忘旅程。',
            japanSectionImageAlt: '日本旅行场景',
        },
        about: {
            hero: {
                discover: '经典日本',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: '与专业导游一起探索日本永恒的美丽',
                tagline2: '从活力四射的城市到神圣的山脉和古老的寺庙——让我们为您打造完美的日本之旅。',
            },

            about: {
                title: '关于 Sonic Tours Japan',
            },

            tours: {
                classic: '经典日本（首次访日游客）',
                days4: '5–7天',
                desc1: '东京 – 涩谷十字路口、浅草、东京晴空塔、购物、动漫与夜生活。富士山 – 壮丽景色、河口湖与富士山第五站。',

                safari: '文化景点',
                days5: '京都 • 奈良 • 大阪',
                desc2: '伏见稻荷大社、金阁寺、浅草寺、姬路城以及奈良公园的宁静魅力。',

                retreat: '自然与风景',
                days6: '箱根 • 岚山 • 日光',
                desc3: '箱根温泉与富士山景观、岚山竹林、日光以及历史悠久的白川乡。',
            },

            owner: {
                title: '认识我们的领导团队',
                name: 'Tomoya Izawa',
                role: '首席执行官 & 总裁',
                bio: 'Tomoya Izawa 对日本文化充满热情，拥有数十年高端旅游业经验，他以远见和奉献精神领导着 Sonic Tours Japan。他致力于提供真实体验和卓越服务，确保每位客人都能享受到世界一流的款待和难忘的日本之旅。',
                imageAlt: 'Tomoya Izawa - Sonic Tours Japan 首席执行官 & 总裁',
            },

            whoWeAre: {
                title: '您的日本旅行专家',
                description: '在 <strong>Buddika</strong> 的带领下，Sonic Tours Japan 专注于为客人打造个性化、高品质的日本旅行体验。我们凭借深厚的本地知识和对日本文化的热爱，确保每一次旅程都顺利、充实且真正难忘。',
                item1: { title: '专业本地导游', text: '持证且经验丰富' },
                item2: { title: '量身定制行程', text: '根据您的节奏定制' },
                item3: { title: '无缝旅行体验', text: '无忧旅行' },
                item4: { title: '24/7 支持', text: '随时为您服务' },
                imageAlt: 'Buddika - 日本旅行专家',
            },

            offers: {
                title: '我们的服务',
                cultural: {
                    title: '文化沉浸',
                    text: '寺庙、神社、传统艺术与当地习俗',
                    alt: '日本文化体验'
                },
                adventure: {
                    title: '自然与冒险',
                    text: '富士山、箱根、徒步与风景之旅',
                    alt: '日本自然冒险'
                },
                luxury: {
                    title: '奢华旅行',
                    text: '高端酒店、私人接送与独家体验',
                    alt: '日本奢华旅行'
                },
                wellness: {
                    title: '养生与放松',
                    text: '温泉、冥想与恢复性静修',
                    alt: '日本养生静修'
                },
            },

            expert: {
                name: 'Buddika',
                role: '首席导游',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: '凭借多年带领旅客游览日本的经验，Buddika 热衷于分享这个美妙国家的真实之美、文化和隐藏的珍宝。他温暖的性格和深厚的知识让每一次旅行都变得特别。',
            },

            villageTours: {
                title: '真实的日本体验',
                description: '远离大城市，探索传统村庄、当地手工艺、季节性节日以及定义真正日本的热情好客。',
                imageAlt: '传统日本乡村体验',
                bookButton: '探索真实日本',
            },

            vehicles: {
                title: '我们的车队',
                text: '舒适、现代且维护良好的车辆，让您在日本的旅程更加轻松愉快。',
                bookButton: '预订您的旅行',
                car: { title: '私人轿车', text: '适合情侣和小团体' },
                van: { title: '舒适面包车', text: '宽敞舒适' },
                minibus: { title: '小型巴士', text: '适合家庭和中型团体' },
                luxury: { title: '豪华大巴', text: '大型团体的尊享体验' },
            },

            notices: {
                title: '安心旅行',
                intro: '在 Sonic Tours Japan，您的舒适、安全和满意是我们最重要的优先事项。',
                fruits: { title: '免费小食', text: '季节性水果和清新点心' },
                meals: { title: '精心挑选的美食', text: '正宗日本料理体验' },
                massage: { title: '放松服务', text: '可选温泉和养生附加服务' },
                flowers: { title: '热情欢迎', text: '传统的日本款待' },
            },

            slider: {
                sigiriya: '富士山',
                yala: '京都寺庙',
                tea: '岚山竹林',
                beaches: '箱根湖',
                temples: '奈良鹿公园',
            },
        },
        tourPackages: {
            hero: {
                discover: '经典日本',
                starLankaTours: '首次访日',
                highlight: '东京、富士山、京都、大阪的永恒之旅',
                tagline1: '从璀璨的城市灯光到宁静的古老寺庙，日本为每一位旅行者提供难忘的首次之旅。',
                tagline2: '让 Sonic Tours 将您的梦想行程变成轻松难忘的日本之旅。',
            },
            overview: {
                eyebrow: '日本精华景点',
                title: '首次访日旅客的日本精华行程',
                description: '这些目的地深受国际旅客欢迎，是打造优质日本旅游团的理想基础。',
            },
            cards: {
                classicTitle: '经典日本（首次访日）',
                classicMeta: '东京 • 富士山',
                classicText: '东京有涩谷十字路口、浅草寺、東京晴空塔、购物、动漫与夜生活。富士山则提供壮丽景色、河口湖和五合目。',
                classicAlt: '东京 skyline 与富士山',
                culturalTitle: '文化景点',
                culturalMeta: '京都 • 奈良 • 大阪',
                culturalText: '探索伏见稻荷大社、金阁寺、浅草寺、姬路城以及奈良公园的宁静魅力。',
                culturalAlt: '日本寺庙与文化遗产',
                natureTitle: '自然与景观',
                natureMeta: '箱根 • 岚山 • 日光',
                natureText: '在箱根享受温泉与富士山美景，漫步岚山竹林，游览日光与白川乡。',
                natureAlt: '日本美丽风景',
            },
            highlights: {
                eyebrow: '热门体验',
                title: '根据您的兴趣规划完美日本之旅',
                text: '无论您喜爱季节之美、家庭乐趣还是文化探索，Sonic Tours 都能为您打造轻松且充满灵感的行程。',
                seasonalTitle: '季节特色',
                seasonalText: '春天适合赏樱，夏天适合攀登富士山和参加祭典，秋天适合欣赏京都和日光的红叶，冬天适合在二世谷滑雪或参加札幌雪祭。',
                familyTitle: '家庭友好景点',
                familyText: '东京迪士尼乐园、東京迪士尼海洋、环球影业日本和大阪海游馆是家庭游客的绝佳选择。',
            },
            recommended: {
                eyebrow: '推荐旅游套餐',
                title: '推荐旅游套餐',
                subtitle: '为您首次日本之旅选择最适合的天数',
                packages: {
                    fiveDays: {
                        title: '5天：东京 + 富士山',
                        description: '完美的日本入门之旅 — 活力四射的东京与标志性的富士山。',
                        alt: '东京与富士山'
                    },
                    sevenDays: {
                        title: '7天：东京 + 富士山 + 京都 + 大阪',
                        description: '经典路线，涵盖日本必访城市与文化核心。',
                        alt: '京都与大阪'
                    },
                    tenDays: {
                        title: '10天：东京 + 箱根 + 京都 + 奈良 + 大阪',
                        description: '深度探索，包含箱根美景与历史悠久的奈良。',
                        alt: '箱根与奈良'
                    },
                    twelveToFourteenDays: {
                        title: '12–14天：东京 + 箱根 + 京都 + 奈良 + 大阪 + 广岛 + 宫岛',
                        description: '全面行程，包含广岛的历史记忆与神圣的宫岛。',
                        alt: '广岛与宫岛'
                    }
                }
            },
            cta: {
                eyebrow: '量身定制的日本之旅',
                title: '让 Sonic Tours 为您设计日本之旅',
                text: '选择经典首次访日路线，或根据您的节奏、兴趣和季节量身定制行程。',
                button: '规划我的日本之旅',
                imageAlt: '日本旅行体验',
            },
        },
        // Chinese (zh)
        contactus: {
            heroTitle: '联系我们',
            heroSubtitle: 'Sonic Tours Japan – 开启您难忘日本之旅的大门',

            feelFree: '欢迎随时联系我们',
            planDream: '规划您完美的日本之旅',
            reachOutDesc: '欢迎联系 Sonic Tours Japan，定制专属行程、专业咨询以及全日本难忘的旅行体验。',

            callCenter: '客服中心',
            phone: '+81 90-8251-4053',
            emailTitle: '邮箱',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: '我们的地址',
            location: '2F Ginza Otake Residence, 1-22-11 Ginza, Chuo-ku, Tokyo 104-0061, Japan',
            socialTitle: '关注我们',

            getInTouch: '与我们联系',
            getInTouchDesc: '与 Sonic Tours Japan 开启您的日本之旅 — 我们随时为您服务，共同创造难忘回忆。',

            nameLabel: '姓名',
            namePlaceholder: '您的全名',
            emailLabel: '邮箱',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: '电话号码',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: '留言',
            messagePlaceholder: '告诉我们您理想的日本之旅...',

            sendButton: '发送消息',
            sendingButton: '发送中...',
            successMsg: '您的消息已通过 WhatsApp 发送成功！',
            errorMsg: '无法打开 WhatsApp，请稍后重试。',

            findUsTitle: '在日本找到我们',
        },
        japan: {
            heroTitle: 'CEO兼日本办事处总裁',
            heroSubtitle: '您在日本值得信赖的斯里兰卡冒险合作伙伴',

            contactPerson: 'Tomoya Izawa',
            position: '日本代表',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: '在社交媒体上与我们联系',

            formTitle: '发送消息给我们',
            formHeading: '开始您的斯里兰卡冒险',
            formDescription: '联系 Tomoya Izawa 获取个性化旅游套餐、专业旅行建议和难忘的斯里兰卡体验。',

            nameLabel: '您的姓名 *',
            namePlaceholder: '输入您的全名',
            emailLabel: '电子邮件地址 *',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: '电话号码',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: '您的消息 *',
            messagePlaceholder: '告诉我们您梦想中的斯里兰卡冒险...',

            sendButton: '通过电子邮件发送消息',
            sendingButton: '正在打开电子邮件客户端...',
            successMsg: '您的电子邮件客户端已打开并包含消息！',
            errorMsg: '无法打开电子邮件客户端。请重试。',

            whyChooseTitle: '为什么选择 Sonic Tours？',

            expertiseTitle: '本地专业知识',
            expertiseDesc: '由了解每个隐藏宝藏的当地专家策划的正宗斯里兰卡体验',

            supportTitle: '日语支持',
            supportDesc: '专门的日语代表，实现无缝沟通',

            personalizedTitle: '个性化旅游',
            personalizedDesc: '根据您的兴趣和旅行风格设计的定制行程',

            mapTitle: '在斯里兰卡找到我们',
        },
        // Simplified Chinese (zh)
        thingstodo: {
            heroTitle: "日本必体验活动",
            heroSubtitle: "探索难忘的体验，在日出之国创造一生难忘的回忆。",

            sectionTitle: "日本难忘的体验",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "樱花观赏",
                description: "日本最具标志性和最令人惊叹的季节性体验。",
                para1: "赏樱（花见）是日本最受欢迎的传统之一。每年春天，数百万人在粉红色的樱花树下聚集，庆祝生命的短暂美丽。",
                para2: "热门地点包括东京的上野公园、新宿御苑、京都的哲学之道以及大阪城公园。许多人会和家人朋友一起在樱花树下野餐（花见便当）。",
                para3: "樱花季通常在3月底至4月初达到高峰。夜晚的灯光照明让许多地方呈现出梦幻般的氛围。"
            },

            ancientTemples: {
                title: "古老寺庙与神社",
                description: "通过古老的寺庙和神社探索日本的精神遗产。",
                para1: "日本拥有数千座历史悠久的寺庙和神社，其中许多被列入联合国教科文组织世界遗产名录。",
                para2: "标志性景点包括拥有数千座红色鸟居的伏见稻荷大社、金阁寺，以及奈良宏伟的东大寺。",
                para3: "游客可以参加宗教仪式、抽签求运，或单纯享受环绕这些圣地的宁静花园和季节美景。"
            },

            mountFuji: {
                title: "富士山与富士五湖",
                description: "见证日本雄伟而神圣的象征。",
                para1: "海拔3776米的富士山是日本最高峰，也是重要的文化象征。",
                para2: "最佳观赏点位于富士五湖地区（尤其是河口湖）。您可以在官方登山季攀登山顶，或全年欣赏美景。",
                para3: "周边地区有迷人的小镇、温泉度假村和世界级的摄影机会。"
            },

            onsenRelax: {
                title: "传统温泉体验",
                description: "在日本传统温泉中放松身心。",
                para1: "温泉文化深深植根于日本。天然温泉被认为具有疗愈功效。",
                para2: "热门目的地包括箱根、别府和草津。许多旅馆提供露天露天风吕，景色壮丽。",
                para3: "遵守温泉礼仪能提升体验，并体现对日本沐浴传统的尊重。"
            },

            japaneseCuisine: {
                title: "正宗日本料理",
                description: "品尝世界闻名的日本美食和街头小吃。",
                para1: "从新鲜的寿司和生鱼片，到丰盛的拉面、天妇罗和怀石料理——日本料理被列为联合国教科文组织非物质文化遗产。",
                para2: "东京、大阪和京都都是美食天堂。在道顿堀或锦市场品尝街头美食。",
                para3: "美食之旅和烹饪课程是深入了解日本饮食传统的最佳方式。"
            },

            shinkansen: {
                title: "乘坐新干线（子弹头列车）",
                description: "体验世界著名的高速列车。",
                para1: "新干线是日本技术卓越和准点的象征。",
                para2: "以超过300公里/小时的速度舒适穿梭于东京、京都、大阪和广岛等主要城市之间。",
                para3: "旅程本身就是一种享受——干净、安静且极其高效。"
            },

            matsuriFestivals: {
                title: "传统祭典（Matsuri）",
                description: "沉浸在热闹的传统节日中。",
                para1: "祭典是充满活力的社区节日，包括游行、音乐、美食摊位和传统舞蹈。",
                para2: "著名活动包括京都的祇园祭、青森的ねぶた祭和大阪的天神祭。",
                para3: "参加祭典是体验当地文化和日本精神的绝佳机会。"
            },

            themeParks: {
                title: "主题乐园与娱乐",
                description: "享受世界级的主题乐园和景点。",
                para1: "东京迪士尼乐园和迪士尼海洋是全球最受欢迎的乐园之一。",
                para2: "大阪的日本环球影城提供以哈利·波特、超级任天堂世界等为主题的刺激游乐设施。",
                para3: "这些乐园适合所有年龄层，在季节性活动中尤其梦幻。"
            },

            shoppingJapan: {
                title: "东京、大阪和京都购物",
                description: "在日本充满活力的城市尽情购物。",
                para1: "从银座和表参道的奢侈品牌，到秋叶原的电子产品和心斋桥的时尚。",
                para2: "不要错过百货公司、100日元店和传统工艺品市场。",
                para3: "免税购物和独特纪念品让在日本购物成为一种愉快的体验。"
            },

            fourSeasons: {
                title: "日本美丽的四季",
                description: "体验日本鲜明四季的魅力。",
                para1: "日本以其戏剧性的季节变化而闻名——春天的樱花、夏天的节日、秋天的红叶和冬天的雪景。",
                para2: "每个季节在全国各地都有独特的节日、美食和景观。",
                para3: "无论何时前来，日本的自然美景和文化庆典都会给您留下持久的印象。"
            },

            viewMore: "查看详情",
            close: "关闭",

            ctaTitle: "准备好开启您的日本之旅了吗？",
            ctaDescription: "让 Sonic Tours Japan 以专业的指导和个性化的服务为您打造完美的行程。",
            ctaButton: "立即规划您的旅行"
        },
        // Simplified Chinese (zh)
        gallery: {
            heroTitle: "探索日本",
            heroSubtitle: "通过我们精心策划的画廊，探索日本令人惊叹的美丽、文化和标志性景点。",

            // 20 Selected Places
            shibuya: "涩谷十字路口",
            asakusa: "浅草寺",
            skytree: "东京晴空塔",
            mtfuji: "富士山",
            lakeKawaguchi: "河口湖",
            hakoneRopeway: "箱根空中缆车",
            fushimiInari: "伏见稻荷大社",
            arashiyama: "岚山竹林",
            kinkakuji: "金阁寺",
            osakaCastle: "大阪城",
            dotonbori: "道顿堀",
            naraPark: "奈良公园",
            todaiji: "东大寺",
            hiroshimaPeace: "广岛和平纪念公园",
            miyajima: "严岛神社",
            nikko: "日光东照宫",
            shirakawago: "白川乡",
            himeji: "姬路城",
            universal: "日本环球影城",
            teamlab: "TeamLab Planets",

            lightboxClose: "关闭",
            lightboxNext: "下一张",
            lightboxPrevious: "上一张",
            tabPlaces: "景点",
            tabEvents: "活动"
        },
        // Simplified Chinese (zh)
        events: {
            heroTitle: "日本节庆",
            heroSubtitle: "体验日本世界著名的节庆活动，感受绚丽色彩、深厚传统和难忘的节日氛围。",

            // 20 Selected Festivals
            sakuraMatsuri: "樱花节 (Sakura Matsuri)",
            hinaMatsuri: "雏祭 (Hina Matsuri)",
            takayamaSpring: "高山春季祭",
            kandaMatsuri: "神田祭",
            aoiMatsuri: "葵祭",
            fujiShibazakura: "富士芝樱节",
            gionMatsuri: "祇园祭",
            tenjinMatsuri: "天神祭",
            nebutaMatsuri: "ねぶた祭",
            sendaiTanabata: "仙台七夕祭",
            awaOdori: "阿波踊り",
            sumidaFireworks: "隅田川烟火大会",
            nagaokaFireworks: "长冈烟火节",
            kishiwadaDanjiri: "岸和田地车祭",
            jidaiMatsuri: "时代祭",
            takayamaAutumn: "高山秋季祭",
            sapporoSnow: "札幌雪祭",
            otaruSnow: "小樽雪灯之路",
            nozawaOnsenFire: "野泽温泉火祭",
            obonFestival: "盂兰盆节 (Obon)",

            tabPlaces: "景点",
            tabEvents: "活动"
        },

        // Simplified Chinese (zh)
        home: {
            sections: {
                recommendations: {
                    title: "热门目的地",
                    subtitle: "探索日本最具标志性的城市、文化瑰宝和令人叹为观止的自然风光。"
                },
                excursions: {
                    title: "日本旅游行程",
                    desc: "为首次访日游客、家庭、情侣和文化爱好者精心设计的日本旅行行程供您选择。"
                },
                packages: {
                    title: "热门日本旅游套餐"
                }
            },

            recommendations: {
                tokyo: {
                    label: "东京",
                    name: "涩谷十字路口、浅草、东京晴空塔、购物与动漫"
                },
                mountFuji: {
                    label: "富士山",
                    name: "河口湖、富士山五合目及绝美景观"
                },
                kyoto: {
                    label: "京都",
                    name: "寺庙、神社、竹林与艺伎区"
                },
                osaka: {
                    label: "大阪",
                    name: "道顿堀、大阪城与日本环球影城"
                },
                nara: {
                    label: "奈良",
                    name: "历史古寺与亲人鹿公园"
                },
                hakone: {
                    label: "箱根",
                    name: "温泉、缆车与富士山景观"
                },
                nikko: {
                    label: "日光",
                    name: "UNESCO世界遗产神社与自然美景"
                },
                shirakawago: {
                    label: "白川乡",
                    name: "传统日本合掌屋村落"
                },
                arashiyama: {
                    label: "岚山",
                    name: "著名竹林与美丽河景"
                },
                himeji: {
                    label: "姬路",
                    name: "日本最美丽的城堡"
                }
            },

            excursions: {
                oneDay: {
                    title: "东京市区一日游",
                    des: "游览涩谷十字路口、浅草寺、东京晴空塔和银座购物区。"
                },
                twoDays: {
                    title: "东京与富士山",
                    des: "体验东京亮点，随后欣赏富士山和河口湖的壮丽景色。"
                },
                threeDays: {
                    title: "东京 • 富士山 • 箱根",
                    des: "融合现代东京与箱根温泉、缆车及富士山美景。"
                },
                fourDays: {
                    title: "东京 • 京都",
                    des: "探索日本现代首都与古老文化中心京都。"
                },
                fiveDays: {
                    title: "日本黄金路线",
                    des: "畅游东京、富士山、京都和大阪。"
                },
                sixDays: {
                    title: "经典日本探索之旅",
                    des: "东京、箱根、京都、奈良和大阪，一次难忘的旅程。"
                }
            },

            packages: {
                one: {
                    title: "东京与富士山",
                    duration: "5天",
                    desc: "完美的首次日本之旅，包含东京主要景点和富士山。"
                },
                two: {
                    title: "经典日本",
                    duration: "7天",
                    desc: "东京、富士山、京都和大阪。"
                },
                three: {
                    title: "黄金路线",
                    duration: "10天",
                    desc: "东京、箱根、京都、奈良和大阪。"
                },
                four: {
                    title: "日本探索者",
                    duration: "12天",
                    desc: "东京、箱根、京都、奈良、大阪和广岛。"
                },
                five: {
                    title: "日本精华之旅",
                    duration: "14天",
                    desc: "探索日本著名城市、文化地标和美丽乡村。"
                },
                six: {
                    title: "日本大环游",
                    duration: "14天",
                    desc: "日本终极之旅，包含宫岛和广岛。"
                }
            },

            featured: {
                elephantRide: {
                    h2: "标志性地标",
                    h3: "富士山",
                    paragraph: "体验日本最著名的山岳，欣赏全景、河口湖与富士山五合目。",
                    button: "探索"
                },
                perahera: {
                    h2: "文化遗产",
                    h3: "京都古寺",
                    h4: "古老日本",
                    paragraph: "探索京都永恒的寺庙、神社、竹林和著名的艺伎区。",
                    button: "了解更多"
                },
                safari: {
                    h2: "家庭冒险",
                    h3: "东京迪士尼度假区",
                    paragraph: "在东京迪士尼乐园和东京迪士尼海洋享受世界级的家庭欢乐时光。",
                    button: "了解更多"
                }
            },

            famousTours: {
                title: "我们最受欢迎的日本旅游线路",
                subtitle: "通过精心设计的行程，探索日本最具标志性的目的地。",
                bookNow: "立即预订",

                tours: {
                    benthotaRiverSafari: {
                        title: "5天",
                        description: "东京 + 富士山"
                    },

                    polgampalaWaterPool: {
                        title: "7天",
                        description: "东京 + 富士山 + 京都 + 大阪"
                    },

                    galleTour: {
                        title: "10天",
                        description: "东京 + 箱根 + 京都 + 奈良 + 大阪"
                    },

                    sigiriyaTour: {
                        title: "12–14天",
                        description: "东京 + 箱根 + 京都 + 奈良 + 大阪 + 广岛 + 宫岛"
                    }
                }
            },

            gallery: {
                title: "我们的日本画廊",
                subtitle: "欣赏在日本标志性城市、文化地标和美丽风景中捕捉的难忘瞬间。"
            },
            cta: {
                title: "今天就开始您的日本冒险之旅",
                desc: "让 Sonic Tours 为您打造完美的日本假期，提供精心设计的行程、难忘的体验以及从始至终的卓越服务。",
                button: "规划您的旅程",
                alt: "日本旅游"
            }
        },
        // Simplified Chinese (zh)
        hero: {
            title: {
                line1: "与",
                line2: "Sonic Tours",
                line3: "一起发现日本"
            },
            subtitle: "古老寺院、璀璨都市、宁静花园与难忘冒险——",
            subtitle2: "为您的旅程量身打造。",

            cta: "开启您的旅程",
            trust: "深受来自超过50个国家的旅行者喜爱 • 受全球旅行专家信赖"
        },
        // Simplified Chinese (zh)
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "首页",
                about: "关于我们",
                explore: "日本旅游",
                tours: "旅游行程",
                gallery: "画廊",
                events: "活动",
                things: "景点推荐",
                contact: "联系我们"
            },

            contact: {
                title: "联系我们",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "保持联系",
                desc: "订阅我们的通讯，获取独家日本旅行tips、季节性优惠以及新行程的优先信息。",
                placeholder: "请输入您的邮箱",
                subscribe: "订阅"
            },

            tagline: "与 <span class='text-[#f7d774]'>Sonic Tours Japan</span> 一起探索日本的灵魂 — 您值得信赖的真实难忘日本旅行伙伴。",

            copyright: "保留所有权利。",
            developedBy: "技术支持"
        },

    },
    ja: {
        translation: {
            home: 'ホーム',
            aboutUs: '会社概要',
            sriLankanav: '日本',
            gallerynav: 'ギャラリー',
            bookATour: 'ツアー',
            thingsToDo: 'すること',
            contactUs: 'お問い合わせ',
            contactJapan: '日本へのお問い合わせ',
            japanHeroEyebrow: '日本を発見',
            japanHeroTitle: 'Sonic Toursと一緒に日本の elegance を体験',
            japanHeroSubtitle: '古代寺院や静かな庭園から、活気ある街並みや忘れられない冒険まで、日本は他とは違う旅をお届けします。',
            japanHeroImageAlt: '日本の風景',
            japanAboutEyebrow: '日本について',
            japanSectionTitle: '好奇心旺盛な旅人のための timeless な destination',
            japanSectionDescription: '日本は、豊かな文化遺産、世界的に評価される食文化、自然の美しさ、現代的な革新性を一つの特別な旅の中に融合しています。静かな寺院、街の明かり、絶景の風景を求める方にも、Sonic Toursは快適さと配慮を持ってお届けします。',
            japanSectionImageAlt: '日本の旅行シーン',
        },
        about: {
            hero: {
                discover: 'クラシックジャパン',
                starLankaTours: 'Sonic Tours Japan',
                tagline1: '専門ガイドと共に日本の timeless な美しさを発見する旅へ',
                tagline2: '活気あふれる都市から神聖な山々、古代の寺院まで — あなただけの完璧な日本旅行をお作りします。',
            },

            about: {
                title: 'Sonic Tours Japan について',
            },

            tours: {
                classic: 'クラシックジャパン（初めての日本旅行者向け）',
                days4: '5–7日間',
                desc1: '東京 – 渋谷スクランブル交差点、浅草、東京スカイツリー、ショッピング、アニメ＆ナイトライフ。富士山 – 絶景、河口湖＆富士山5合目。',

                safari: '文化的な魅力',
                days5: '京都 • 奈良 • 大阪',
                desc2: '伏見稲荷大社、金閣寺、浅草寺、姫路城、そして奈良公園の穏やかな魅力。',

                retreat: '自然と絶景スポット',
                days6: '箱根 • 嵐山 • 日光',
                desc3: '箱根温泉と富士山の眺め、嵐山竹林、日光、そして歴史的な白川郷。',
            },

            owner: {
                title: '私たちのリーダーシップ',
                name: 'Tomoya Izawa',
                role: 'CEO & President',
                bio: '日本文化への深い情熱とラグジュアリーツーリズムでの長年の経験を持つ Tomoya Izawa は、ビジョンと献身を持って Sonic Tours Japan を率いています。本物の体験と卓越したサービスへのこだわりにより、すべてのゲストに世界クラスのおもてなしと忘れられない日本旅行をお届けします。',
                imageAlt: 'Tomoya Izawa - Sonic Tours Japan CEO & President',
            },

            whoWeAre: {
                title: 'あなたの日本旅行の専門家',
                description: '<strong>Buddika</strong> が率いる Sonic Tours Japan は、日本全国でパーソナライズされた高品質な旅行体験を提供しています。深い現地知識と日本文化への情熱により、すべての旅がスムーズで充実した、忘れられないものになることを保証します。',
                item1: { title: '経験豊富な現地ガイド', text: '免許取得済みで経験豊富' },
                item2: { title: 'オーダーメイド行程', text: 'お客様のペースに合わせたカスタマイズ' },
                item3: { title: 'シームレスな体験', text: 'ストレスフリーの旅行' },
                item4: { title: '24/7 サポート', text: 'いつでもサポート' },
                imageAlt: 'Buddika - 日本旅行の専門家',
            },

            offers: {
                title: '私たちのサービス',
                cultural: {
                    title: '文化体験',
                    text: '寺院、神社、伝統芸術と地元の風習',
                    alt: '日本の文化体験'
                },
                adventure: {
                    title: '自然とアドベンチャー',
                    text: '富士山、箱根、ハイキングと絶景の旅',
                    alt: '日本の自然アドベンチャー'
                },
                luxury: {
                    title: 'ラグジュアリー旅行',
                    text: 'プレミアムホテル、私的送迎、特別な体験',
                    alt: '日本のラグジュアリー旅行'
                },
                wellness: {
                    title: 'ウェルネス＆リラクゼーション',
                    text: '温泉、心の平穏、リフレッシュできるリトリート',
                    alt: '日本のウェルネスリトリート'
                },
            },

            expert: {
                name: 'Buddika',
                role: 'チーフツアーガイド',
                imageAlt: 'Buddika - Sonic Tours Japan',
                bio: '長年にわたり日本各地を案内してきた経験を持つ Buddika は、この素晴らしい国の本物の美しさ、文化、そして隠れた魅力をお伝えすることに情熱を注いでいます。彼の温かい人柄と深い知識が、すべてのツアーを特別なものにします。',
            },

            villageTours: {
                title: '本物の日本体験',
                description: '大都市を離れて、伝統的な集落、地元の手仕事、季節の祭り、そして本物の日本を象徴する温かいおもてなしを発見してください。',
                imageAlt: '伝統的な日本の集落体験',
                bookButton: '本物の日本を探訪する',
            },

            vehicles: {
                title: '弊社の車両 fleet',
                text: '快適で近代的、整備の行き届いた車両で日本を快適に巡る旅をお楽しみください。',
                bookButton: 'ツアーを予約する',
                car: { title: 'プライベートカー', text: 'カップルや少人数グループに最適' },
                van: { title: '快適バン', text: '広々として快適' },
                minibus: { title: 'ミニバス', text: '家族や中規模グループに最適' },
                luxury: { title: 'ラグジュアリーバス', text: '大人数向けプレミアム体験' },
            },

            notices: {
                title: '安心してご旅行ください',
                intro: 'Sonic Tours Japan では、お客様の快適、安全、満足を最優先に考えています。',
                fruits: { title: '無料のおやつ', text: '季節のフルーツと軽いお飲み物' },
                meals: { title: '厳選された食事', text: '本格的な日本料理体験' },
                massage: { title: 'リラクゼーションサービス', text: 'オプションの温泉＆ウェルネス追加プラン' },
                flowers: { title: '温かいおもてなし', text: '伝統的な日本のホスピタリティ' },
            },

            slider: {
                sigiriya: '富士山',
                yala: '京都の寺院',
                tea: '嵐山竹林',
                beaches: '箱根の湖',
                temples: '奈良の鹿公園',
            },
        },
        tourPackages: {
            hero: {
                discover: 'クラシックジャパン',
                starLankaTours: '初めての日本旅行',
                highlight: '東京・富士山・京都・大阪を巡るタイムレスな旅',
                tagline1: '賑やかな街の光から静かな寺院まで、日本は初めての旅行者に素晴らしい体験を提供します。',
                tagline2: 'Sonic Tours があなたの夢の旅程を、スムーズで忘れられない日本旅行に変えます。',
            },
            overview: {
                eyebrow: '日本のハイライト',
                title: '初めての日本旅行におすすめのハイライト',
                description: 'これらの目的地は海外旅行者にとても人気があり、魅力的な日本ツアーパッケージの素晴らしい基盤となります。',
            },
            cards: {
                classicTitle: 'クラシックジャパン（初めての訪問者向け）',
                classicMeta: '東京 • 富士山',
                classicText: '東京には渋谷スクランブル交差点、浅草、東京スカイツリー、ショッピング、アニメ、ナイトライフがあります。富士山では絶景、河口湖、5合目をお楽しみいただけます。',
                classicAlt: '東京の skyline と富士山',
                culturalTitle: '文化的な見どころ',
                culturalMeta: '京都 • 奈良 • 大阪',
                culturalText: '伏見稲荷大社、金閣寺、浅草寺、姫路城、奈良公園の穏やかな魅力などを探索してください。',
                culturalAlt: '日本の寺院と文化遺産',
                natureTitle: '自然と絶景',
                natureMeta: '箱根 • 嵐山 • 日光',
                natureText: '箱根の温泉と富士山の眺め、嵐山の竹林、日光、白川郷をお楽しみください。',
                natureAlt: '美しい日本の風景',
            },
            highlights: {
                eyebrow: '人気の体験',
                title: 'あなたの興味に合わせた完璧な日本旅行を計画しましょう',
                text: '季節の美しさ、家族向けの楽しみ、文化発見のどれをお好みでも、Sonic Tours が無理なく心躍るルートをご提案します。',
                seasonalTitle: '季節ごとの魅力',
                seasonalText: '春は桜、夏は富士登山と祭り、秋は京都と日光の紅葉、冬はニセコのスキーや札幌雪まつりがおすすめです。',
                familyTitle: 'ファミリー向けアトラクション',
                familyText: '東京ディズニーランド、東京ディズニーシー、ユニバーサル・スタジオ・ジャパン、大阪海遊館は家族旅行に最適です。',
            },
            recommended: {
                eyebrow: 'おすすめツアーパッケージ',
                title: 'おすすめツアーパッケージ',
                subtitle: '初めての日本旅行に最適な日数をお選びください',
                packages: {
                    fiveDays: {
                        title: '5日間：東京 + 富士山',
                        description: '日本への完璧な導入コース — 活気あふれる東京と象徴的な富士山。',
                        alt: '東京と富士山'
                    },
                    sevenDays: {
                        title: '7日間：東京 + 富士山 + 京都 + 大阪',
                        description: '日本の必見都市と文化の中心を巡る定番ルート。',
                        alt: '京都と大阪'
                    },
                    tenDays: {
                        title: '10日間：東京 + 箱根 + 京都 + 奈良 + 大阪',
                        description: '箱根の絶景と歴史ある奈良を加えた充実した探索の旅。',
                        alt: '箱根と奈良'
                    },
                    twelveToFourteenDays: {
                        title: '12–14日間：東京 + 箱根 + 京都 + 奈良 + 大阪 + 広島 + 宮島',
                        description: '広島の感動的な歴史と神聖な宮島を含む包括的な旅程。',
                        alt: '広島と宮島'
                    }
                }
            },
            cta: {
                eyebrow: 'オーダーメイドの日本旅行',
                title: 'Sonic Tours があなたの日本旅行をデザインします',
                text: '初めての定番コース、またはご希望のペース・興味・季節に合わせたカスタムプランをお選びください。',
                button: '日本旅行を計画する',
                imageAlt: '日本旅行の体験',
            },
        },
        contactus: {
            heroTitle: 'お問い合わせ',
            heroSubtitle: 'Sonic Tours Japan – 忘れられない日本旅行への入り口',

            feelFree: 'お気軽にご連絡ください',
            planDream: '理想の日本旅行を計画しましょう',
            reachOutDesc: 'Sonic Tours Japan までご連絡ください。オーダーメイドの旅程、専門的なアドバイス、そして日本全国での思い出に残る体験をお手伝いします。',

            callCenter: 'コールセンター',
            phone: '+81 90-8251-4053',
            emailTitle: 'メール',
            email: 'vbuddika@sonictourssl.com',
            locationTitle: '所在地',
            location: '〒104-0061 東京都中央区銀座1-22-11 Ginza Otake Residence 2F',
            socialTitle: 'フォローする',

            getInTouch: 'ご連絡ください',
            getInTouchDesc: 'Sonic Tours Japan と一緒に日本での冒険を始めましょう。いつでもご相談ください、忘れられない思い出をお作りします。',

            nameLabel: 'お名前',
            namePlaceholder: 'フルネーム',
            emailLabel: 'メールアドレス',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: '電話番号',
            phonePlaceholder: '+81 90 XXX XXXX',
            messageLabel: 'メッセージ',
            messagePlaceholder: '理想の日本旅行について教えてください...',

            sendButton: 'メッセージを送信',
            sendingButton: '送信中...',
            successMsg: 'WhatsAppでメッセージを送信しました！',
            errorMsg: 'WhatsAppを開けませんでした。もう一度お試しください。',

            findUsTitle: '日本で当社を見つける',
        },
        japan: {
            heroTitle: '日本オフィスのCEO兼社長',
            heroSubtitle: '日本からスリランカの冒険をサポートする信頼できるパートナー',

            contactPerson: 'いざわ ともや',
            position: '日本担当代表',
            phone: '+81 90 2583 9920',
            email: 'mtakahashi@sonictourssl.com',
            socialMedia: 'ソーシャルメディアでつながる',

            formTitle: 'メッセージを送る',
            formHeading: 'スリランカの冒険を始めましょう',
            formDescription: 'いざわともやまでご連絡ください。カスタマイズされたツアーパッケージ、専門的な旅行アドバイス、忘れられないスリランカ体験をご提供します。',

            nameLabel: 'お名前 *',
            namePlaceholder: 'フルネームを入力してください',
            emailLabel: 'メールアドレス *',
            emailPlaceholder: 'your.email@example.com',
            phoneLabel: '電話番号',
            phonePlaceholder: '+81 XX XXXX XXXX',
            messageLabel: 'メッセージ *',
            messagePlaceholder: '夢のスリランカ冒険について教えてください...',

            sendButton: 'メールでメッセージを送信',
            sendingButton: 'メールクライアントを開いています...',
            successMsg: 'メールクライアントがメッセージとともに開かれました！',
            errorMsg: 'メールクライアントを開けませんでした。もう一度お試しください。',

            whyChooseTitle: 'Sonic Toursを選ぶ理由',

            expertiseTitle: '現地の専門知識',
            expertiseDesc: '隠れた宝石をすべて知っている地元の専門家が厳選した本物のスリランカ体験',

            supportTitle: '日本語サポート',
            supportDesc: '日本語対応の専門担当者によるスムーズなコミュニケーション',

            personalizedTitle: 'カスタマイズツアー',
            personalizedDesc: 'お客様の興味や旅行スタイルに合わせて設計されたオーダーメイドの旅程',

            mapTitle: 'スリランカで私たちを見つける',
        },
        // Add this inside the resources object in i18n.js
        thingstodo: {
            heroTitle: "日本で楽しめること",
            heroSubtitle: "忘れられない体験を発見し、「日の出ずる国」で一生の思い出を作りましょう。",

            sectionTitle: "日本での忘れられない体験",

            // 10 Activities with Full Details
            sakuraViewing: {
                title: "桜鑑賞",
                description: "日本を代表する最も美しく象徴的な季節の体験です。",
                para1: "「花見」として知られる桜鑑賞は、日本で最も愛されている伝統行事の一つです。毎年春になると、何百万人もの人々が満開の桜の木の下に集まり、儚く美しい命の輝きを祝います。",
                para2: "人気の花見スポットには、東京の上野公園や新宿御苑、京都の哲学の道、大阪城公園などがあります。多くの人々が家族や友人と一緒に花見弁当を楽しみます。",
                para3: "桜の見頃は通常3月下旬から4月上旬です。夜にはライトアップが行われ、多くの場所で幻想的な雰囲気を楽しめます。"
            },

            ancientTemples: {
                title: "歴史ある寺院と神社",
                description: "由緒ある寺院や神社を巡り、日本の精神文化に触れましょう。",
                para1: "日本には数千もの歴史ある寺院や神社があり、その多くがユネスコ世界遺産に登録されています。",
                para2: "有名なスポットには、数千本の朱色の鳥居が並ぶ伏見稲荷大社、金閣寺、奈良の壮大な東大寺などがあります。",
                para3: "参拝やおみくじ体験、静かな庭園や四季折々の美しい景色を楽しみながら、日本の伝統文化を感じることができます。"
            },

            mountFuji: {
                title: "富士山と富士五湖",
                description: "日本の象徴である雄大な富士山を満喫しましょう。",
                para1: "標高3,776メートルの富士山は、日本最高峰であり、日本文化を象徴する存在です。",
                para2: "富士五湖エリアでは最高の景色を楽しめます。登山シーズンには山頂を目指したり、一年を通して絶景を眺めることができます。",
                para3: "周辺には魅力的な町や温泉地があり、世界屈指の写真撮影スポットとしても人気です。"
            },

            onsenRelax: {
                title: "伝統的な温泉",
                description: "日本の温泉で心も体もリフレッシュしましょう。",
                para1: "温泉文化は日本に深く根付いています。天然温泉は古くから癒しの効果があると信じられています。",
                para2: "箱根、別府、草津などは人気の温泉地です。多くの旅館では絶景を眺めながら楽しめる露天風呂を提供しています。",
                para3: "正しい温泉マナーを守ることで、より快適で本格的な日本の温泉文化を体験できます。"
            },

            japaneseCuisine: {
                title: "本格的な日本料理",
                description: "世界的に評価される日本料理や屋台グルメを味わいましょう。",
                para1: "新鮮な寿司や刺身、ラーメン、天ぷら、懐石料理など、日本の食文化はユネスコ無形文化遺産にも登録されています。",
                para2: "東京・大阪・京都はグルメの宝庫です。道頓堀や錦市場では本場のストリートフードも楽しめます。",
                para3: "グルメツアーや料理教室に参加すれば、日本の食文化をより深く知ることができます。"
            },

            shinkansen: {
                title: "新幹線に乗る",
                description: "世界的に有名な日本の新幹線を体験しましょう。",
                para1: "新幹線は、日本の高度な技術力と時間の正確さを象徴しています。",
                para2: "東京・京都・大阪・広島などの主要都市を時速300km以上で快適に移動できます。",
                para3: "清潔で静か、そして非常に効率的な新幹線の旅そのものが特別な体験となります。"
            },

            matsuriFestivals: {
                title: "伝統的な祭り",
                description: "活気あふれる日本の伝統的なお祭りを体験しましょう。",
                para1: "祭りでは、山車の巡行、伝統音楽、屋台、盆踊りなど、日本ならではの文化を楽しめます。",
                para2: "京都の祇園祭、青森のねぶた祭、大阪の天神祭は特に有名です。",
                para3: "祭りに参加することで、地域文化や日本人の温かいおもてなしを体感できます。"
            },

            themeParks: {
                title: "テーマパークとエンターテインメント",
                description: "世界クラスのテーマパークで思い切り楽しみましょう。",
                para1: "東京ディズニーランドと東京ディズニーシーは世界中から多くの観光客が訪れる人気スポットです。",
                para2: "大阪のユニバーサル・スタジオ・ジャパンでは、ハリー・ポッターやスーパー・ニンテンドー・ワールドなどの人気アトラクションを楽しめます。",
                para3: "季節ごとのイベントも充実しており、子どもから大人まで楽しめます。"
            },

            shoppingJapan: {
                title: "東京・大阪・京都でショッピング",
                description: "日本の人気都市でショッピングを満喫しましょう。",
                para1: "銀座や表参道の高級ブランドから、秋葉原の家電、心斎橋のファッションまで幅広く楽しめます。",
                para2: "百貨店、100円ショップ、伝統工芸品市場もぜひ訪れてみてください。",
                para3: "免税ショッピングや日本ならではのお土産選びも旅行の大きな楽しみです。"
            },

            fourSeasons: {
                title: "日本の美しい四季",
                description: "四季折々の美しい日本の魅力を体験しましょう。",
                para1: "日本は春の桜、夏祭り、秋の紅葉、冬の雪景色など、四季それぞれが美しいことで知られています。",
                para2: "季節ごとに異なる祭りや郷土料理、風景を楽しむことができます。",
                para3: "いつ訪れても、日本の自然美と豊かな文化が心に残る素晴らしい思い出を作ってくれるでしょう。"
            },

            viewMore: "詳細を見る",
            close: "閉じる",

            ctaTitle: "日本への冒険を始めませんか？",
            ctaDescription: "Sonic Tours Japan が専門スタッフによるサポートとオーダーメイドのプランで、あなたにぴったりの旅をご提案します。",
            ctaButton: "今すぐ旅行を計画する"
        },
        gallery: {
            heroTitle: "日本を発見する",
            heroSubtitle: "当社の厳選ギャラリーで、日本の息をのむような美しさ、文化、そして象徴的な名所を探索してください。",

            // 20 Selected Places
            shibuya: "渋谷スクランブル交差点",
            asakusa: "浅草寺",
            skytree: "東京スカイツリー",
            mtfuji: "富士山",
            lakeKawaguchi: "河口湖",
            hakoneRopeway: "箱根ロープウェイ",
            fushimiInari: "伏見稲荷大社",
            arashiyama: "嵐山竹林",
            kinkakuji: "金閣寺",
            osakaCastle: "大阪城",
            dotonbori: "道頓堀",
            naraPark: "奈良公園",
            todaiji: "東大寺",
            hiroshimaPeace: "広島平和記念公園",
            miyajima: "厳島神社",
            nikko: "日光東照宮",
            shirakawago: "白川郷",
            himeji: "姫路城",
            universal: "ユニバーサル・スタジオ・ジャパン",
            teamlab: "チームラボプラネッツ",

            lightboxClose: "閉じる",
            lightboxNext: "次へ",
            lightboxPrevious: "前へ",
            tabPlaces: "場所",
            tabEvents: "イベント"
        },
        // Inside en, ru, ar → resources
        events: {
            heroTitle: "日本の祭り",
            heroSubtitle: "日本が世界に誇る色彩豊かで伝統深い、忘れられない祭りと祝祭の雰囲気をお楽しみください。",

            // 20 Selected Festivals
            sakuraMatsuri: "桜まつり（Cherry Blossom Festivals）",
            hinaMatsuri: "ひな祭り（Hina Matsuri）",
            takayamaSpring: "高山春祭",
            kandaMatsuri: "神田祭",
            aoiMatsuri: "葵祭",
            fujiShibazakura: "富士芝桜祭り",
            gionMatsuri: "祇園祭",
            tenjinMatsuri: "天神祭",
            nebutaMatsuri: "ねぶた祭",
            sendaiTanabata: "仙台七夕祭",
            awaOdori: "阿波おどり",
            sumidaFireworks: "隅田川花火大会",
            nagaokaFireworks: "長岡花火大会",
            kishiwadaDanjiri: "岸和田だんじり祭",
            jidaiMatsuri: "時代祭",
            takayamaAutumn: "高山秋祭",
            sapporoSnow: "さっぽろ雪まつり",
            otaruSnow: "小樽雪あかりの路",
            nozawaOnsenFire: "野沢温泉火祭り",
            obonFestival: "お盆（Obon）",

            tabPlaces: "場所",
            tabEvents: "イベント"
        },

        home: {
            sections: {
                recommendations: {
                    title: "人気の目的地",
                    subtitle: "日本の象徴的な都市、文化の宝物、息をのむような絶景を発見してください。"
                },
                excursions: {
                    title: "日本ツアープログラム",
                    desc: "初めての日本旅行者、ファミリー、カップル、文化愛好家のために丁寧に設計された旅程からお選びください。"
                },
                packages: {
                    title: "人気の日本ツアーパッケージ"
                }
            },

            recommendations: {
                tokyo: {
                    label: "東京",
                    name: "渋谷スクランブル交差点、浅草、東京スカイツリー、ショッピング＆アニメ"
                },
                mountFuji: {
                    label: "富士山",
                    name: "河口湖、富士山五合目＆絶景"
                },
                kyoto: {
                    label: "京都",
                    name: "寺院・神社・竹林・祇園"
                },
                osaka: {
                    label: "大阪",
                    name: "道頓堀、大阪城、ユニバーサル・スタジオ・ジャパン"
                },
                nara: {
                    label: "奈良",
                    name: "歴史ある寺院と親しい鹿の公園"
                },
                hakone: {
                    label: "箱根",
                    name: "温泉、ロープウェイ＆富士山ビュー"
                },
                nikko: {
                    label: "日光",
                    name: "世界遺産の神社と豊かな自然"
                },
                shirakawago: {
                    label: "白川郷",
                    name: "伝統的な合掌造りの村"
                },
                arashiyama: {
                    label: "嵐山",
                    name: "有名な竹林と美しい川"
                },
                himeji: {
                    label: "姫路",
                    name: "日本で最も美しい城"
                }
            },

            excursions: {
                oneDay: {
                    title: "東京シティツアー",
                    des: "渋谷スクランブル交差点、浅草寺、東京スカイツリー、銀座ショッピング街を巡ります。"
                },
                twoDays: {
                    title: "東京と富士山",
                    des: "東京のハイライトを楽しみ、その後富士山と河口湖の壮大な景色をお楽しみください。"
                },
                threeDays: {
                    title: "東京 • 富士山 • 箱根",
                    des: "近代的な東京と箱根の温泉、ロープウェイ、富士山の景色を組み合わせます。"
                },
                fourDays: {
                    title: "東京 • 京都",
                    des: "日本の現代的な首都と古都京都を探索します。"
                },
                fiveDays: {
                    title: "ゴールデンルート日本",
                    des: "東京、富士山、京都、大阪を巡る旅。"
                },
                sixDays: {
                    title: "クラシックジャパン発見の旅",
                    des: "東京、箱根、京都、奈良、大阪を巡る忘れられない旅。"
                }
            },

            packages: {
                one: {
                    title: "東京と富士山",
                    duration: "5日間",
                    desc: "東京の主要スポットと富士山を巡る、初めての日本旅行に最適なプラン。"
                },
                two: {
                    title: "クラシックジャパン",
                    duration: "7日間",
                    desc: "東京、富士山、京都、大阪。"
                },
                three: {
                    title: "ゴールデンルート",
                    duration: "10日間",
                    desc: "東京、箱根、京都、奈良、大阪。"
                },
                four: {
                    title: "ジャパンエクスプローラー",
                    duration: "12日間",
                    desc: "東京、箱根、京都、奈良、大阪、広島。"
                },
                five: {
                    title: "日本ハイライト",
                    duration: "14日間",
                    desc: "日本の有名都市、文化遺産、美しい田舎を巡る旅。"
                },
                six: {
                    title: "グランドジャパンツアー",
                    duration: "14日間",
                    desc: "宮島と広島を含む、日本を巡る究極の旅。"
                }
            },

            featured: {
                elephantRide: {
                    h2: "象徴的なランドマーク",
                    h3: "富士山",
                    paragraph: "日本を代表する山・富士山を、河口湖や五合目からの絶景とともに体験してください。",
                    button: "探索する"
                },
                perahera: {
                    h2: "文化遺産",
                    h3: "京都の寺院",
                    h4: "古都日本",
                    paragraph: "京都の時代を超えた寺院、神社、竹林、祇園の花街をご覧ください。",
                    button: "発見する"
                },
                safari: {
                    h2: "ファミリーアドベンチャー",
                    h3: "東京ディズニーリゾート",
                    paragraph: "東京ディズニーランドと東京ディズニーシーの世界クラスのアトラクションで、忘れられない家族の思い出をお作りください。",
                    button: "詳細を見る"
                }
            },

            famousTours: {
                title: "最も人気の日本ツアー",
                subtitle: "日本の象徴的な観光地を網羅した、丁寧に設計された旅程で日本を巡りましょう。",
                bookNow: "今すぐ予約",

                tours: {
                    benthotaRiverSafari: {
                        title: "5日間",
                        description: "東京 + 富士山"
                    },

                    polgampalaWaterPool: {
                        title: "7日間",
                        description: "東京 + 富士山 + 京都 + 大阪"
                    },

                    galleTour: {
                        title: "10日間",
                        description: "東京 + 箱根 + 京都 + 奈良 + 大阪"
                    },

                    sigiriyaTour: {
                        title: "12–14日間",
                        description: "東京 + 箱根 + 京都 + 奈良 + 大阪 + 広島 + 宮島"
                    }
                }
            },

            gallery: {
                title: "日本のギャラリー",
                subtitle: "日本の象徴的な都市、文化遺産、素晴らしい風景の中で撮影された忘れられない瞬間をご覧ください。"
            },
            cta: {
                title: "今日から日本旅行を始めましょう",
                desc: "Sonic Toursが、丁寧に設計された旅程、忘れられない体験、そして最初から最後まで最高のサービスで、あなただけの完璧な日本旅行をお作りします。",
                button: "旅程を計画する",
                alt: "日本ツアー"
            }
        },
        hero: {
            title: {
                line1: "日本を",
                line2: "Sonic Tours",
                line3: "と一緒に探索"
            },
            subtitle: "古代寺院、都会の光景、静かな庭園、忘れられない冒険 —",
            subtitle2: "あなたの旅のために設計されています。",
            cta: "旅を始める",
            trust: "50カ国以上からの旅行者に愛され • 世界の旅行専門家から信頼されています"
        },
        footer: {
            brand: "Sonic Tours <span class='text-[#f7d774]'>Japan</span>",

            nav: {
                home: "ホーム",
                about: "会社概要",
                explore: "日本観光",
                tours: "ツアー",
                gallery: "ギャラリー",
                events: "イベント",
                things: "おすすめスポット",
                contact: "お問い合わせ"
            },

            contact: {
                title: "お問い合わせ",
                address: "2F Ginza Otake Residence,<br>1-22-11 Ginza, Chuo-ku, Tokyo, Japan",
                email: "vbuddika@sonictourssl.com",
                phone: "+81 90-8251-4053"
            },

            newsletter: {
                title: "最新情報を受け取る",
                desc: "ニュースレターに登録して、限定の日本旅行情報、季節限定オファー、新規ツアーの先行案内をお届けします。",
                placeholder: "メールアドレスを入力",
                subscribe: "登録する"
            },

            tagline: "<span class='text-[#f7d774]'>Sonic Tours Japan</span> とともに日本の魂を旅する — 信頼できる本物の忘れられない旅のパートナー。",

            copyright: "All Rights Reserved.",
            developedBy: "Developed by"
        },

    },

};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;